'use strict';

(function (angular) {
  angular.module('ibf').controller('growerNavCtrl', ['$rootScope', '$scope', 'alertify', '$state', '$stateParams', 'commonSrv', 'sessionSrv', 'growerSrv', '$location', 'environment', growerNavCtrl]);

  function growerNavCtrl($rootScope, $scope, alertify, $state, $stateParams, commonSrv, sessionSrv, growerSrv, $location, environment) {
    var nav = this,
        common = commonSrv,
        session = sessionSrv;

    nav.orderRequestItemsWithoutBid = 0;
    nav.open = false;
    nav.showDashboardRoute = false;
    nav.isBookKeeping = false;
    nav.showPriceDashboardRoute = false;

    nav.include = function (name) {
      return $state.includes('grower.' + name);
    };

    nav.isCurrent = function (name) {
      return $state.is('grower.' + name);
    };

    function init() {
      var data = common.getUserData();

      var token = data.token;
      var user_key = data.key;
      nav.so_url = "https://admin.ibuyflowers.com/admin_v2/grower/standing_order?token=" + token + "&user_key=" + user_key;
      // nav.so_url = "https://admin.ibuyflowers.com/admin/grower/standing_order"

      nav.validateSession();
      nav.price_grower_v2 = "https://admin.ibuyflowers.com/admin_v2/grower/price_comparison?token=" + token + "&user_key=" + user_key;
    }

    nav.pageReload = function () {
      localStorage.removeItem('user_key');
      window.location.reload();
    };

    $rootScope.$on('name_changed_grower', function () {
      nav.name = common.getUserData().data.name;
    });

    nav.loadPermissions = function () {
      var query = common.sbx.with('grower_user_config').andWhereIsEqual('user', common.getUserData().key).compile();
      common.method.query(common.urls.find, query).then(function () {
        var response = common.response.post_query.data.results;

        if (response) {

          nav.userPermission = response[0] || {};

          nav.showPriceDashboardRoute = nav.userPermission.orders === true && nav.userPermission.inventory === true;
        }
      });
    };

    nav.onRedirectPopover = function () {
      nav.open = false;
      $state.go('grower.order_request.open');
    };

    nav.getOrderRequestData = function () {
      growerSrv.getOrderRequestCb(function (err, res) {
        if (err) {
          res = [];
        }
        nav.orderRequestItemsWithoutBid = res.items.reduce(function (acc, item) {
          return !item.order_request_bid ? ++acc : acc;
        }, 0);
        nav.open = Boolean(nav.orderRequestItemsWithoutBid);
      });
    };

    nav.validateSession = function () {

      var currentUrl = $location.absUrl();

      if (session.validate()) {
        nav.fromCountryManager = common.getUserData().fromCountryManager;

        nav.fromCountryManagerMaster = common.config.country_manager_master && Array.isArray(common.config.country_manager_master) ? common.config.country_manager_master.includes(common.getUserData().data.email) : false;
        nav.user = common.getUserData().data;

        if (common.config.availableGrowerDashboard && (common.config.availableGrowerDashboard.includes(common.getUserData().key) || common.config.availableGrowerDashboard.includes('all'))) {
          nav.showDashboardRoute = true;
        }

        if (common.config.availableGrowerCountryDashboard && common.getUserData().country._KEY && (common.config.availableGrowerCountryDashboard.includes(common.getUserData().country._KEY) || common.config.availableGrowerCountryDashboard.includes('all'))) {
          nav.showDashboardRoute = true;
        }

        if (nav.fromCountryManager) {
          nav.showDashboardRoute = true;
        }

        if (nav.fromCountryManager) {
          nav.isBookKeeping = common.getUserData().main_role === "BOOKKEEPING";
        }
        nav.grower = common.getUserData().grower;
        nav.name = common.getUserData().data.name;
        var userData = common.getUserData();
        var userEmail = userData && userData.data ? userData.data.email : null;
        var isHdbEmail = userEmail === 'nederland@ibuyflowers.com';

        if (userData && userData.grower === 'a8bf30bf-9d85-4ad5-8c48-5c39d671d1f' && !isHdbEmail && !userData.main_role) {
          nav.hideInventoryTab = true;
          nav.hidePriceDashboard = true;
        }

        common.setHeaders(common.getUserData().token);
        nav.loadPermissions();
        if (!nav.isCurrent('order_request.open')) {
          nav.getOrderRequestData();
        }
      }
    };

    nav.logout = function () {
      session.logout(true);
    };

    nav.redirectPriceComparison = function () {

      window.open('/admin/#/grower/price_comparison/');
    };

    init();
  }
})(angular);
//# sourceMappingURL=growerNavCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('growerManageUsersCtrl', ['$rootScope', '$scope', 'alertify', 'commonSrv', '$uibModalInstance', 'data', growerManageUsersCtrl]).controller('growerManageBoxesCtrl', ['$scope', 'alertify', 'commonSrv', '$uibModalInstance', 'config', '$filter', 'productSrv', growerManageBoxesCtrl]).controller('growerUpdateModalCtrl', ['$scope', 'alertify', 'commonSrv', '$uibModalInstance', '$filter', 'growerSrv', 'config', growerUpdateModalCtrl]);

  function growerManageUsersCtrl($rootScope, $scope, alertify, commonSrv, $uibModalInstance, data) {

    var modal = this,
        common = commonSrv;

    modal.grower = data.grower;

    modal.pass_edit = false;
    modal.isEdit = false;
    modal.isLoading = false;
    modal.perm = {
      orders: null,
      inventory: null,
      auto_buys: null,
      standing_orders: null,
      accounting: null,
      claims: null,
      setup: null
    };

    function init() {

      if (data.config) {

        modal.isAdmin = data.config.user.isAdmin;
        modal.isEdit = true;
        modal.perm = {
          orders: data.config.orders,
          inventory: data.config.inventory,
          auto_buys: data.config.auto_buys,
          standing_orders: data.config.standing_orders,
          claims: data.config.claims,
          accounting: data.config.accounting,
          setup: data.config.setup
        };
        modal.perm._KEY = data.config._KEY;
        modal.user = data.config.user;
        modal.first_name = modal.user.first_name;
        modal.last_name = modal.user.last_name;
        modal.cellphone = modal.user.cellphone;
        modal.confirm_user_email = modal.user.user_email;
        modal.user_email = modal.user.user_email;
        modal.skype = modal.user.skype;
      }
    }

    modal.saveUser = function (query) {

      var data = {
        'domain': common.actual_domain,
        'rows': [query],
        'row_model': 'user'
      };
      common.method.query(common.urls.row, data).then(function () {

        var response = common.response.post_query.data;
        if (response.success) {
          modal.addPermissions(response.keys[0], common.urls.row, 'User created');
        }
      });
    };

    modal.addPermissions = function (key, url, msg) {

      modal.perm.user = key;
      var query = {
        'domain': common.actual_domain,
        'rows': [modal.perm],
        'row_model': 'grower_user_config'
      };
      common.method.query(url, query).then(function () {

        modal.isLoading = false;
        var response = common.response.post_query.data;
        if (response.success) {
          $uibModalInstance.close();
          alertify.success(msg);
        } else {
          alertify.error('Internal error');
        }
      });
    };

    modal.updateARDIPass = function (data) {

      common.method.get(common.urls.update_password, data).then(function () {

        var response = common.response.get.results;
        if (!response.success) {
          alertify.error('Error updating password.');
        }
      });
    };

    modal.edit = function () {

      if (modal.user_password && modal.confirm_user_password != modal.user_password) {
        alertify.error('User Passwords must match.');
        return;
      }

      if (modal.confirm_user_email != modal.user_email) {
        alertify.error('User Emails must match.');
        return;
      }

      if (modal.user_password) {
        modal.pass_edit = true;
        modal.ardi_data = {
          domain: common.actual_domain,
          password: modal.user_password,
          id: modal.user.user_id
        };
      }

      var query = {
        first_name: modal.first_name,
        last_name: modal.last_name,
        cellphone: modal.cellphone,
        skype: modal.skype,
        user_email: modal.user_email,
        _KEY: modal.user._KEY
      };
      var data = {
        'domain': common.actual_domain,
        'rows': [query],
        'row_model': 'user'
      };
      modal.isLoading = true;
      common.method.query(common.urls.update, data).then(function () {
        if (query._KEY == common.getUserData().key) {
          var user_cookie = common.getUserData();
          user_cookie.data.name = query.first_name + ' ' + query.last_name;
          common.setUserData(user_cookie);
          $rootScope.$emit('name_changed_grower');
        }
        var response = common.response.post_query.data;

        if (response.success) {
          modal.addPermissions(modal.user._KEY, common.urls.update, 'User updated');
          if (modal.pass_edit) {
            modal.updateARDIPass(modal.ardi_data);
          }
        }
      });
    };

    modal.save = function () {
      var valid = true,
          msg = '';

      var perm = false;
      angular.forEach(modal.perm, function (item) {
        if (item) {
          perm = true;
        }
      });

      $scope.$broadcast('show-errors-check-validity');
      if ($scope.growerForm.$invalid) {
        modal.isLoading = false;
        valid = false;
        alertify.error('There are invalid fields');
        return;
      }
      if (modal.confirm_user_password != modal.user_password) {
        valid = false;
        msg = 'User Passwords must match.';
      }

      if (modal.confirm_user_email != modal.user_email) {
        valid = false;
        msg = 'User Emails must match.';
      }

      if (!perm) {
        valid = false;
        msg = 'There must be at least one permission for the user.';
      }

      modal.isLoading = true;
      var login_user = modal.user_email ? modal.user_email.replace('@', '_').replace(/\./g, '_') : null;
      var query = {
        email: modal.user_email,
        password: modal.user_password,
        name: modal.first_name + ' ' + modal.last_name,
        login: login_user,
        domain: common.actual_domain
      };

      modal.user_query = {
        first_name: modal.first_name,
        last_name: modal.last_name,
        role: 'GROWER',
        grower: modal.grower,
        cellphone: modal.cellphone,
        user_email: modal.user_email,
        skype: modal.skype,
        is_admin: false,
        active: true
      };

      if (valid) {
        common.method.get(common.urls.register, query).then(function () {
          modal.isLoading = false;

          var response = common.response.get.data;
          if (response.success) {
            modal.user_query.user_id = response.user.id;
            modal.saveUser(modal.user_query);
          } else {
            alertify.error('Cannot register user');
          }
        });
      } else {
        modal.isLoading = false;
        alertify.error(msg);
      }
    };

    modal.close = function () {
      $uibModalInstance.dismiss();
    };

    init();
  }

  function growerManageBoxesCtrl($scope, alertify, commonSrv, $uibModalInstance, config, $filter, productSrv) {
    var modal = this,
        common = commonSrv,
        ps = productSrv;

    modal.grower = config.grower;
    modal.isLoading = false;

    function init() {
      modal.box2 = false;
      modal.box3 = false;
      modal.loadGroups();
      modal.loadLengths();
      modal.loadGrades();
      modal.loadUoM();
      modal.loadGrowerInfo(common.getUserData().grower);
    }

    modal.enableBox = function (num) {
      switch (num) {
        case 2:
          modal.box2 = true;
          break;
        case 3:
          modal.box3 = true;
          break;
      }
    };

    modal.loadGrowerInfo = function (key) {
      var query = {
        'domain': common.actual_domain,
        'row_model': 'grower',
        'where': {
          'keys': [common.getUserData().grower]
        }
      };

      common.method.query(common.urls.find, query).then(function () {
        var response = common.response.post_query.data;

        if (response.success) {
          modal.grower = response.results;
          modal.loadBoxTypes(modal.grower[0].country);
        } else {
          alertify.error('Error while retrieving Grower info.');
        }
      });
    };
    modal.productConfig = {
      create: false,
      highlight: true,
      valueField: '_KEY',
      //labelField: 'common_name',
      delimiter: '|',
      searchField: ['common_name', 'category', 'botanical_name'],
      placeholder: 'Select Product Group',
      maxItems: 1,
      render: {
        option: function option(data, escape) {
          return '<div class="option">' + '<span class="title">' + escape(data.common_name) + ' (' + escape(data.category) + ')' + '</span>' + '</div>';
        },
        item: function item(data, escape) {
          return '<div class="item">' + '<span class="item">' + escape(data.common_name) + ' (' + escape(data.category) + ')' + '</span>' + '</div>';
        }
      }
    };

    // modal.loadGroups = function(){
    //   var query = {
    //     "domain": common.actual_domain,
    //     "page": 1,
    //     "row_model": "product_group",
    //     "size": 1000
    //   }

    //   common.method.query(common.urls.find, query).then(function(){
    //     var response = common.response.post_query.data;
    //     if(response.success){

    //       modal.products = response.results;
    //     }else{
    //       alertify.error('Internal Error loading Product Groups');
    //     }
    //   });
    // }

    modal.loadGroups = function () {

      var query = {
        'domain': common.actual_domain,
        'page': 1,
        'row_model': 'box_per_product',
        'fetch': ['product_group'],
        'size': 1000
      };

      common.method.query(common.urls.find, query).then(function () {

        var response = common.response.post_query.data;
        if (response.success) {
          //obj.boxes = response.results;
          var fetched_results = response.fetched_results;

          angular.forEach(response.results, function (item) {
            modal.products.push(fetched_results.product_group[item.product_group]);
          });
        } else {
          alertify.error('Error loading boxes.');
        }
      });
    };

    modal.lengthConfig = {
      create: false,
      highlight: true,
      valueField: '_KEY',
      //labelField: 'length',
      delimiter: '|',
      searchField: ['length'],
      placeholder: 'Select Length',
      maxItems: 1,
      render: {
        option: function option(data, escape) {
          return '<div class="option">' + '<span class="title">' + escape(data.length) + ' in' + '</span>' + '</div>';
        },
        item: function item(data, escape) {
          return '<div class="item">' + '<span class="item">' + escape(data.length) + ' in' + '</span>' + '</div>';
        }
      }
    };

    modal.loadLengths = function () {

      ps.listBoxLengths(function (lengths) {
        modal.lengths = lengths.mapped.length_inch;
      }, function (err) {
        alertify.error(err);
      });
    };

    modal.loadUoM = function () {
      var query = {
        'domain': common.actual_domain,
        'page': 1,
        'row_model': 'uom',
        'size': 1000
      };

      common.method.query(common.urls.find, query).then(function () {
        var response = common.response.post_query.data;

        if (response.success) {
          modal.uoms = response.results;
        } else {
          alertify.error('Internal Error loading Units of Measurement.');
        }
      });
    };

    modal.gradeConfig = {
      create: false,
      highlight: true,
      valueField: '_KEY',
      delimiter: '|',
      searchField: ['grade', 'grade_type'],
      placeholder: 'Select Grade',
      maxItems: 1,
      render: {
        option: function option(data, escape) {
          return '<div class="option">' + '<span class="title">' + escape(data.grade) + ' (' + escape(data.grade_type) + ')' + '</span>' + '</div>';
        },
        item: function item(data, escape) {
          return '<div class="item">' + '<span class="item">' + escape(data.grade) + ' (' + escape(data.grade_type) + ')' + '</span>' + '</div>';
        }
      }
    };

    modal.loadGrades = function () {
      // var query = {
      //   "domain": common.actual_domain,
      //   "page": 1,
      //   "row_model": "grade",
      //   "size": 1000
      // }
      // common.method.query(common.urls.find, query).then(function(){
      //   var response = common.response.post_query.data;
      //   if(response.success){
      //     modal.grades = response.results;
      //   }else{
      //     alertify.error('Internal Error loading Grades.');
      //   }
      // });

      ps.listGrades(function (grades) {
        modal.grades = grades.all;
      }, function (err) {
        alertify.error(err);
      });
    };
    modal.loadBoxTypes = function (country) {

      var query = {
        'domain': common.actual_domain,
        'row_model': 'box',
        'where': {
          'country': [country]
        }
      };

      common.method.query(common.urls.find, query).then(function () {
        var response = common.response.post_query.data;

        if (response.success) {
          modal.box_types = response.results;
        } else {
          alertify.error('Internal error loading box types.');
        }
      });
    };

    modal.save = function () {

      var valid = true,
          msg = '';
      $scope.$broadcast('show-errors-check-validity');
      if (modal.growerForm.$invalid) {
        modal.isLoading = false;
        valid = false;
        msg = 'You need to fill the required fields.';
        return;
      }

      if (modal.box2 && !modal.box_option_2 && modal.box_charge_box_2 != '') {
        modal.isLoading = false;
        valid = false;
        alertify.error('You need to fill the option 2 fields.');
      }

      if (modal.box3 && !modal.box_option_3 && modal.box_charge_box_3 != '') {
        modal.isLoading = false;
        valid = false;
        alertify.error('You need to fill the option 2 fields.');
      }

      var query = commonSrv.sbx.with('box_per_product').setPage(1).setPageSize(1).andWhereIsEqual('product_group', modal.product).compile();
      /*var query = commonSrv.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('box_per_product')
        .setPage(1)
        .setPageSize(1)
        .addCondition('AND', 'product_group', '=', modal.product)
        .compile();*/

      common.method.query(common.urls.find, query).then(function () {
        var res = common.response.post_query.data;
        if (res.success) {
          // if the
          if (res.results.length > 0 && res.results[0]._KEY != modal.product) {
            modal.isLoading = false;
            valid = false;
            alertify.error('There is already a Box with the same product group.');
          } else {
            if (valid) {
              var query = {
                'domain': common.actual_domain,
                'row_model': 'box_per_product',
                'rows': [{
                  'product_group': modal.product,
                  'length': modal.box_length,
                  'UoM': modal.uom._KEY,
                  'grade': modal.grade,
                  'box_option_1': modal.box_option_1._KEY,
                  'box_charge_box_1': modal.box_charge_box_1,
                  'box_option_2': modal.box_option_2 ? modal.box_option_2._KEY : null,
                  'box_charge_box_2': modal.box_charge_box_2,
                  'box_option_3': modal.box_option_3 ? modal.box_option_3._KEY : null,
                  'box_charge_box_3': modal.box_charge_box_3
                }]
              };
              common.method.query(common.urls.row, query).then(function () {

                var response = common.response.post_query.data;
                if (response.success) {
                  $uibModalInstance.close();
                  alertify.success('Box Type Added.');
                } else {
                  alertify.error('There was a problem adding the box type.');
                }
              });
            }
          }
        }
      });
      //$uibModalInstance.close();
    };

    modal.close = function () {
      $uibModalInstance.dismiss();
    };

    init();
  }

  function growerUpdateModalCtrl($scope, alertify, commonSrv, $uibModalInstance, $filter, growerSrv, config) {
    var modal = this,
        common = commonSrv,
        gs = growerSrv;

    function init() {
      gs.updateInventory(config.inventories, config.partialsChange, config.grower, config.initDate, config.endDate, modal, config.onSuccess, config.onError, config.close);
    }

    init();
  }
})(angular);
//# sourceMappingURL=growerModals.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('growerDashboardCtrl', ['$scope', 'alertify', '$state', 'commonSrv', 'sessionSrv', growerDashboardCtrl]);

  function growerDashboardCtrl($scope, alertify, $state, commonSrv, sessionSrv) {

    var obj = this,
        common = commonSrv;
  }
})(angular);
//# sourceMappingURL=growerDashboardCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('growerInventoryCtrl', ['$scope', 'alertify', '$state', '$stateParams', 'commonSrv', 'sessionSrv', growerInventoryCtrl]);

  function growerInventoryCtrl($scope, alertify, $state, $stateParams, commonSrv, sessionSrv) {

    var content = this,
        common = commonSrv;

    content.isCurrent = function (name) {
      return $state.is('grower.inventory.' + name);
    };

    content.include = function (name) {
      return $state.includes('grower.inventory.' + name);
    };

    content.isGrower = function () {
      return common.getUserData().ibf_role !== "COUNTRY_MANAGER";
    };

    /*obj.gotoTab = function(tab){
      $state.go('grower.inventory', {tab:tab});
    }
     obj.tabs = {
      'update_assistant':0,
      'import_assistant':1,
      'copy_delete_assistant':2,
      'add_new_item':3
    }*/

    function init() {}

    init();
  }
})(angular);
//# sourceMappingURL=growerInventoryCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('growerInventoryViewerCtrl', ['$rootScope', '$scope', 'alertify', 'commonSrv', 'productSrv', '$filter', 'filterSrv', growerInventoryViewerCtrl]);

  function growerInventoryViewerCtrl($rootScope, $scope, alertify, commonSrv, productSrv, $filter, filterSrv) {

    var obj = this,
        common = commonSrv,
        ps = productSrv,
        fs = filterSrv,
        today = new Date();

    obj.base_masterlist = { map: {}, items: [] };
    obj.weekInventory = [];
    obj.filteredInventory = [];
    obj.loadingInv = false;
    obj.hasLoaded = false;
    obj.currentPage = 1;
    obj.itemsPerPage = 15;
    obj.searchText = '';

    // ── Date picker ──────────────────────────────────────────────
    obj.format = 'dd-MMMM-yyyy';
    obj.altInputFormats = ['M!/d!/yyyy'];
    obj.popup = { opened: false };

    obj.open = function () {
      obj.popup.opened = true;
    };

    function getMonday(d) {
      d = new Date(d);
      var day = d.getDay();
      var diff = d.getDate() - day + (day == 0 ? -6 : 1);
      return new Date(d.setDate(diff));
    }

    // Only Mondays selectable in the calendar
    function disabledDays(data) {
      var date = data.date,
          mode = data.mode;
      return mode === 'day' && date.getDay() !== 1;
    }

    obj.dateOptions = {
      dateDisabled: disabledDays,
      formatYear: 'yy',
      startingDay: 1,
      showWeeks: false
    };

    // Default: Monday of the current week
    obj.selectedWeek = getMonday(today);

    obj.weekEnd = function () {
      if (!obj.selectedWeek) return null;
      var d = new Date(obj.selectedWeek);
      d.setDate(d.getDate() + 5);
      return d;
    };

    obj.prevWeek = function () {
      var d = new Date(obj.selectedWeek);
      d.setDate(d.getDate() - 7);
      obj.selectedWeek = d;
      obj.search();
    };

    obj.nextWeek = function () {
      var d = new Date(obj.selectedWeek);
      d.setDate(d.getDate() + 7);
      obj.selectedWeek = d;
      obj.search();
    };

    obj.onDateChange = function () {
      if (obj.selectedWeek) {
        // Snap to Monday in case user typed a non-Monday date
        obj.selectedWeek = getMonday(obj.selectedWeek);
        obj.search();
      }
    };

    // ── Grades (exact copy from UpdateAssistant) ─────────────────
    obj.loadGrades = function () {
      ps.listGrades(function (grades) {
        obj.grades = grades.all;
        obj.gradeOptions = angular.copy(obj.grades);
        obj.gradesMap = grades.mapped;
      }, function (err) {
        alertify.error(err);
      });
    };

    // ── Masterlist (exact copy from UpdateAssistant) ─────────────
    obj.loadMasterlist = function () {
      var arrayFetch = ['UoM', 'variety', 'variety.color', 'variety.product_group', 'variety.color', 'stems_per_bunch', 'grade', 'box'];
      obj.notReady = true;
      productSrv.loadMasterlistByGrower(common.getUserData().grower, arrayFetch, function (response) {
        obj.notReady = false;
        obj.masterlist = response.results;

        if (obj.masterlist.length > 0) {
          var fetched_results = response.fetched_results;
          obj.fetched_masterlist = angular.copy(fetched_results);

          angular.forEach(response.results, function (item) {
            item.UoM = fetched_results.uom[item.UoM];
            item.box = fetched_results.admin_box[item.box];
            item.variety = fetched_results.variety[item.variety];
            item.variety.color = fetched_results.color[item.variety.color] || item.variety.color;
            item.product_group = fetched_results.product_group[item.variety.product_group];
            item.stems_per_bunch = fetched_results.stems_per_bunch[item.stems_per_bunch];
            item.grade = fetched_results.grade[item.grade];
            item.variety.color.colors = [];
            for (var _i = 1; _i < 8; _i++) {
              var tmp = 'html_code_' + _i;
              if (item.variety.color[tmp]) item.variety.color.colors.push(item.variety.color[tmp]);
            }
          });

          obj.masterlistBackUp = angular.copy(obj.masterlist);

          obj.varieties = [];
          angular.forEach(Object.keys(fetched_results.variety), function (vKey) {
            var v = fetched_results.variety[vKey];
            var pg = fetched_results.product_group[v.product_group];
            v._product_group_name = pg ? pg.common_name : '';
            obj.varieties.push(v);
          });
          obj.varieties.sort(function (a, b) {
            var vA = (a.variety_name || '').trim();
            var vB = (b.variety_name || '').trim();
            return vA.localeCompare(vB, undefined, { sensitivity: 'base' });
          });

          var pgSeen = {};
          obj.productGroups = [];
          angular.forEach(response.results, function (item) {
            var pg = item.product_group;
            if (pg && pg._KEY && !pgSeen[pg._KEY]) {
              pgSeen[pg._KEY] = true;
              obj.productGroups.push(pg);
            }
          });
          obj.productGroups.sort(function (a, b) {
            var nA = (a.common_name || '').trim();
            var nB = (b.common_name || '').trim();
            return nA.localeCompare(nB, undefined, { sensitivity: 'base' });
          });

          obj.length_array = [];
          obj.lengths_object = [];
          angular.forEach(response.results, function (item) {
            if (obj.length_array.indexOf(item.length) == -1) {
              obj.length_array.push(item.length);
            }
          });
          obj.lengths = obj.length_array.sort(function (a, b) {
            return a - b;
          });
          for (var i = 0; i < obj.lengths.length; i++) {
            obj.lengths_object.push({ key: obj.lengths[i], label: obj.lengths[i] + ' cm' });
          }
        }

        // Auto-load current week after masterlist is ready
        obj.search();
      }, function (err) {
        obj.notReady = false;
        alertify.error('Error loading masterlist.');
      });
    };

    // ── Masterlist filter (exact copy from UpdateAssistant) ───────
    obj.setupBaseMasterlist = function () {
      obj.masterlist = fs.start(obj.masterlistBackUp).applyFilter('filter', [obj.variety]).applyFilter('filter', [obj.grade]).value;
      if (obj.product_group) {
        obj.masterlist = obj.masterlist.filter(function (item) {
          return item.product_group && item.product_group._KEY === obj.product_group;
        });
      }
      if (obj.length) {
        var list = [];
        angular.forEach(obj.masterlist, function (item) {
          if (item.length == obj.length) list.push(item);
        });
        obj.masterlist = list;
      }
      if (obj.masterlist) {
        obj.masterlist = obj.masterlist.sort(function (a, b) {
          var vA = (a.variety.variety_name || '').trim();
          var vB = (b.variety.variety_name || '').trim();
          var nameCompare = vA.localeCompare(vB, undefined, { sensitivity: 'base' });
          if (nameCompare !== 0) return nameCompare;
          var pgA = (a.product_group && a.product_group.common_name || '').trim();
          var pgB = (b.product_group && b.product_group.common_name || '').trim();
          return pgA.localeCompare(pgB, undefined, { sensitivity: 'base' });
        });
        obj.base_masterlist.map = common.toMap(obj.masterlist, 'base_map', '_KEY');
        obj.base_masterlist.items = angular.copy(obj.masterlist);
      }
    };

    // ── Inventory fetch (single week) ────────────────────────────
    obj.search = function () {
      if (!obj.masterlistBackUp || !obj.masterlistBackUp.length) return;

      obj.setupBaseMasterlist();

      if (Object.keys(obj.base_masterlist.map).length === 0) {
        obj.weekInventory = [];
        obj.hasLoaded = true;
        obj.loadingInv = false;
        return;
      }

      obj.loadingInv = true;
      obj.weekInventory = [];
      obj.currentPage = 1;

      var query = commonSrv.sbx.with('inventory').andWhereIsEqual('grower', common.getUserData().grower).andWhereIsEqual('week', common.convertDateToNumberDate(obj.selectedWeek, true)).andWhereIn('masterlist', Object.keys(obj.base_masterlist.map)).compile();

      common.loadAllPages(query, function (data) {
        var invMap = {};
        data.results.filter(function (inv) {
          return !inv.kind;
        }).forEach(function (inv) {
          invMap[inv.masterlist] = inv;
        });
        obj.weekInventory = obj.masterlist.map(function (ms) {
          var inv = invMap[ms._KEY];
          return {
            ms: ms,
            variety_name: ms.variety.variety_name,
            variety_subtitle: ms.variety.subtitle || '',
            product_group_name: ms.product_group && ms.product_group.common_name || '',
            grade_name: ms.grade && ms.grade.grade || '',
            length_value: ms.length || ms.box && ms.box.fixed_length || '',
            uom_name: ms.UoM && ms.UoM.uom || '',
            quantity: inv ? parseInt(inv.quantity, 10) || 0 : 0,
            price: inv ? parseFloat(inv.price) || 0 : 0
          };
        });
        applyClientFilter();
        obj.hasLoaded = true;
        obj.loadingInv = false;
      }, function (err) {
        alertify.error(err);
        obj.loadingInv = false;
      });
    };

    // ── Client-side text search ──────────────────────────────────
    function applyClientFilter() {
      if (!obj.searchText) {
        obj.filteredInventory = obj.weekInventory;
      } else {
        obj.filteredInventory = $filter('filter')(obj.weekInventory, obj.searchText);
      }
    }

    obj.onSearchTextChange = function () {
      obj.currentPage = 1;
      applyClientFilter();
    };

    obj.clearSearch = function () {
      obj.searchText = '';
      obj.onSearchTextChange();
    };

    // ── Clear filters ────────────────────────────────────────────
    obj.clearFilters = function () {
      obj.variety = null;
      obj.grade = null;
      obj.length = null;
      obj.product_group = null;
      if (obj.varietySelectize) obj.varietySelectize.setValue(null, true);
      if (obj.gradesSelectize) {
        obj.gradesSelectize.setValue(null, true);obj.gradesSelectize.refreshOptions();
      }
      if (obj.lengthSelectize) obj.lengthSelectize.setValue(null, true);
      if (obj.productGroupSelectize) obj.productGroupSelectize.setValue(null, true);
      obj.search();
    };

    obj.productGroupConfig = {
      create: false,
      highlight: true,
      valueField: '_KEY',
      delimiter: '|',
      searchField: ['common_name'],
      placeholder: 'All product groups',
      maxItems: 1,
      render: {
        option: function option(data, escape) {
          return '<div class="option"><span class="title">' + escape(data.common_name) + '</span></div>';
        },
        item: function item(data, escape) {
          return '<div class="item"><span class="item">' + escape(data.common_name) + '</span></div>';
        }
      },
      onChange: function onChange(value) {
        obj.product_group = value || null;
        obj.search();
        $scope.$apply();
      },
      onInitialize: function onInitialize(selectize) {
        obj.productGroupSelectize = selectize;
      }
    };

    // ── Selectize configs (same pattern as UpdateAssistant) ───────
    obj.varietyConfig = {
      create: false,
      highlight: true,
      valueField: '_KEY',
      delimiter: '|',
      searchField: ['variety_name', '_product_group_name'],
      placeholder: 'All varieties',
      maxItems: 1,
      render: {
        option: function option(data, escape) {
          var label = escape(data.variety_name + (data.subtitle ? ' ' + data.subtitle : ''));
          return '<div class="option"><span class="title">' + label + '</span></div>';
        },
        item: function item(data, escape) {
          var label = escape(data.variety_name + (data.subtitle ? ' ' + data.subtitle : ''));
          return '<div class="item"><span class="item">' + label + '</span></div>';
        }
      },
      onChange: function onChange(value) {
        obj.variety = value || null;
        obj.search();
        $scope.$apply();
      },
      onInitialize: function onInitialize(selectize) {
        obj.varietySelectize = selectize;
      }
    };

    obj.gradeConfig = {
      create: false,
      highlight: true,
      valueField: '_KEY',
      delimiter: '|',
      searchField: ['grade', 'grade_type'],
      placeholder: 'All grades',
      maxItems: 1,
      render: {
        option: function option(data, escape) {
          return '<div class="option"><span class="title">' + escape(data.grade) + ' (' + escape(data.grade_type) + ')</span></div>';
        },
        item: function item(data, escape) {
          return '<div class="item"><span class="item">' + escape(data.grade) + ' (' + escape(data.grade_type) + ')</span></div>';
        }
      },
      onChange: function onChange(value) {
        obj.grade = value || null;
        obj.search();
        $scope.$apply();
      },
      onInitialize: function onInitialize(selectize) {
        obj.gradesSelectize = selectize;
      }
    };

    obj.lengthConfig = {
      create: false,
      highlight: true,
      valueField: 'key',
      delimiter: '|',
      searchField: ['label'],
      placeholder: 'All lengths',
      maxItems: 1,
      render: {
        option: function option(data, escape) {
          return '<div class="option"><span class="title">' + escape(data.label) + '</span></div>';
        },
        item: function item(data, escape) {
          return '<div class="item"><span class="item">' + escape(data.label) + '</span></div>';
        }
      },
      onChange: function onChange(value) {
        obj.length = value || null;
        obj.search();
        $scope.$apply();
      },
      onInitialize: function onInitialize(selectize) {
        obj.lengthSelectize = selectize;
      }
    };

    function init() {
      obj.loadMasterlist();
      obj.loadGrades();
    }

    init();
  }
})(angular);
//# sourceMappingURL=growerInventoryViewerCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('growerInventoryUpdateAssistantCtrl', ['$rootScope', '$scope', 'alertify', 'commonSrv', 'productSrv', '$filter', '$http', 'filterSrv', 'growerSrv', growerInventoryUpdateAssistantCtrl]);

  function growerInventoryUpdateAssistantCtrl($rootScope, $scope, alertify, commonSrv, productSrv, $filter, $http, filterSrv, growerSrv) {

    var obj = this,
        common = commonSrv,
        ps = productSrv,
        fs = filterSrv,
        today = new Date();
    obj.waitTilSave = false;
    obj.showBar = {};
    obj.base_masterlist = {
      map: {},
      items: []
    };
    obj.inventories = [];
    obj.copyInventory = [];

    obj.notReady = true;
    obj.showSave = false;

    obj.weeksNumber = [];

    obj.combOptions = [{
      value: 0,
      label: 'Combo off'
    }, {
      value: 1,
      label: '10%'
    }, {
      value: 2,
      label: '20%'
    }, {
      value: 3,
      label: '30%'
    }, {
      value: 4,
      label: '40%'
    }, {
      value: 5,
      label: '50%'
    }];

    function init() {
      obj.loadMasterlist();
      //obj.length_values();
      // obj.loadInventory();
      obj.loadGrades();
    }

    obj.format = 'dd-MMMM-yyyy';
    obj.altInputFormats = ['M!/d!/yyyy'];
    obj.popup1 = {
      opened: false
    };

    obj.popup2 = {
      opened: false
    };

    obj.open1 = function () {
      obj.popup1.opened = true;
    };

    obj.open2 = function () {
      obj.popup2.opened = true;
    };

    function getMonday(d) {
      d = new Date(d);
      var day = d.getDay(),
          diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
      return new Date(d.setDate(diff));
    }

    obj.dateOptions1 = {
      dateDisabled: disabled1,
      formatYear: 'yy',
      maxDate: new Date(today.getFullYear() + 3, 5, 22),
      minDate: getMonday(new Date()),
      startingDay: 1
    };

    obj.dateOptions2 = {
      dateDisabled: disabled2,
      formatYear: 'yy',
      // maxDate: new Date(today.getFullYear() + 3, 5, 22),
      minDate: new Date(),
      startingDay: 1
    };

    // Disable weekend selection
    function disabled1(data) {
      var date = data.date,
          mode = data.mode;
      return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6 || date.getDay() === 2 || date.getDay() === 3 || date.getDay() === 4 || date.getDay() === 5);
    }

    function disabled2(data) {
      var date = data.date,
          mode = data.mode;
      return mode === 'day' && (date.getDay() === 1 || date.getDay() === 0 || date.getDay() === 2 || date.getDay() === 3 || date.getDay() === 4 || date.getDay() === 5);
    }

    obj.loadMasterlist = function () {
      var arrayFetch = ['UoM', 'variety', 'variety.color', 'variety.product_group', 'variety.color', 'stems_per_bunch', 'grade', 'box'];
      obj.notReady = true;
      productSrv.loadMasterlistByGrower(common.getUserData().grower, arrayFetch, function (response) {
        obj.notReady = false;
        obj.masterlist = response.results;

        if (obj.masterlist.length > 0) {

          var fetched_results = response.fetched_results;
          obj.fetched_masterlist = angular.copy(fetched_results);

          angular.forEach(response.results, function (item) {
            item.UoM = fetched_results.uom[item.UoM];
            item.box = fetched_results.admin_box[item.box];
            item.variety = fetched_results.variety[item.variety];
            item.variety.color = fetched_results.color[item.variety.color] || item.variety.color;
            item.product_group = fetched_results.product_group[item.variety.product_group];
            item.stems_per_bunch = fetched_results.stems_per_bunch[item.stems_per_bunch];
            item.grade = fetched_results.grade[item.grade];
            item.variety.color.colors = [];

            for (var _i = 1; _i < 8; _i++) {
              var tmp = 'html_code_' + _i;
              if (item.variety.color[tmp]) {
                item.variety.color.colors.push(item.variety.color[tmp]);
              }
            }
          });
          //Original objet from the query result
          obj.masterlistBackUp = angular.copy(obj.masterlist);
          //------------------------

          obj.products = [];
          angular.forEach(Object.keys(fetched_results.product_group), function (pKey) {
            obj.products.push(fetched_results.product_group[pKey]);
          });

          obj.productMap = common.toMap(obj.products, 'productMap', '_KEY');

          obj.products.sort(function (a, b) {
            return a.common_name.localeCompare(b.common_name);
          });
          obj.productsMaster = angular.copy(obj.products);

          obj.varieties = [];
          angular.forEach(Object.keys(fetched_results.variety), function (vKey) {
            var v = fetched_results.variety[vKey];
            var pg = fetched_results.product_group[v.product_group];
            v._product_group_name = pg ? pg.common_name : '';
            obj.varieties.push(v);
          });

          obj.varieties.sort(function (a, b) {
            var pg = a._product_group_name.localeCompare(b._product_group_name);
            if (pg !== 0) return pg;
            return a.variety_name.localeCompare(b.variety_name);
          });
          obj.varietiesMaster = angular.copy(obj.varieties);

          obj.length_array = [];
          obj.lengths_object = [];
          angular.forEach(response.results, function (item) {
            if (obj.length_array.indexOf(item.length) == -1) {
              obj.length_array.push(item.length);
            }
          });
          obj.lengths = obj.length_array.sort(function (a, b) {
            return a - b;
          });

          for (var i = 0; i < obj.lengths.length; i++) {
            obj.lengths_object.push({
              key: obj.lengths[i],
              label: obj.lengths[i] + ' cm'
            });
          }
        }
      }, function (err) {
        alertify.error('Error loading masterlist.');
      });
    };

    obj.updateProductsForVariety = function (varietyKey) {
      if (!varietyKey) {
        obj.products = angular.copy(obj.productsMaster);
      } else {
        var pgMap = {};
        obj.masterlistBackUp.forEach(function (item) {
          if (item.variety._KEY === varietyKey) {
            pgMap[item.product_group._KEY] = item.product_group;
          }
        });
        obj.products = Object.keys(pgMap).map(function (k) {
          return pgMap[k];
        }).sort(function (a, b) {
          return a.common_name.localeCompare(b.common_name);
        });
      }
      if (obj.productSelectize) obj.productSelectize.refreshOptions(false);
    };

    obj.updateVarietiesForProduct = function (productGroupKey) {
      if (!productGroupKey) {
        obj.varieties = angular.copy(obj.varietiesMaster);
      } else {
        obj.varieties = obj.varietiesMaster.filter(function (v) {
          return v.product_group === productGroupKey;
        });
      }
      if (obj.varietySelectize) obj.varietySelectize.refreshOptions(false);
    };

    obj.updateLengths = function (varietyKey, productGroupKey) {
      var items = obj.masterlistBackUp;
      if (varietyKey) {
        items = items.filter(function (i) {
          return i.variety._KEY === varietyKey;
        });
      }
      if (productGroupKey) {
        items = items.filter(function (i) {
          return i.product_group._KEY === productGroupKey;
        });
      }
      var seen = {},
          lengths = [];
      items.forEach(function (i) {
        if (i.length != null && !seen[i.length]) {
          seen[i.length] = true;
          lengths.push(i.length);
        }
      });
      lengths.sort(function (a, b) {
        return a - b;
      });
      obj.lengths_object = lengths.map(function (l) {
        return { key: l, label: l + ' cm' };
      });
      if (obj.length && !seen[obj.length]) {
        obj.length = null;
        if (obj.lengthSelectize) obj.lengthSelectize.setValue(null, true);
      }
      if (obj.lengthSelectize) obj.lengthSelectize.refreshOptions(false);
    };

    obj.productConfig = {
      create: false,
      highlight: true,
      valueField: '_KEY',
      //labelField: 'common_name',
      delimiter: '|',
      searchField: ['common_name', 'category', 'botanical_name'],
      placeholder: 'Select Product Group',
      maxItems: 1,
      render: {
        option: function option(data, escape) {
          return '<div class="option">' + '<span class="title">' + escape(data.common_name) + '</span>' + '</div>';
        },
        item: function item(data, escape) {
          return '<div class="item">' + '<span class="item">' + escape(data.common_name) + '</span>' + '</div>';
        }
      },
      onChange: function onChange(value) {
        obj.updateVarietiesForProduct(value);
        if (obj.variety) {
          var stillValid = obj.varieties.some(function (v) {
            return v._KEY === obj.variety;
          });
          if (!stillValid) {
            obj.variety = null;
            if (obj.varietySelectize) obj.varietySelectize.setValue(null, true);
          }
        }
        obj.updateGrades(value);
        obj.updateLengths(obj.variety, value);
        $scope.$apply();
      },
      onInitialize: function onInitialize(selectize) {
        obj.productSelectize = selectize;
      }
    };

    obj.varietyConfig = {
      create: false,
      highlight: true,
      valueField: '_KEY',
      delimiter: '|',
      searchField: ['variety_name', 'subtitle'],
      placeholder: 'Select Variety',
      maxItems: 1,
      render: {
        option: function option(data, escape) {
          var label = escape(data.variety_name + (data.subtitle ? ' ' + data.subtitle : ''));
          return '<div class="option"><span class="title">' + label + '</span></div>';
        },
        item: function item(data, escape) {
          var label = escape(data.variety_name + (data.subtitle ? ' ' + data.subtitle : ''));
          return '<div class="item"><span class="item">' + label + '</span></div>';
        }
      },
      onChange: function onChange(value) {
        if (value) {
          var selected = obj.varietiesMaster.find(function (v) {
            return v._KEY === value;
          });
          if (selected && selected.product_group && obj.product !== selected.product_group) {
            obj.product = selected.product_group;
            if (obj.productSelectize) obj.productSelectize.setValue(selected.product_group, true);
            obj.updateGrades(selected.product_group);
          }
        }
        obj.length = null;
        if (obj.lengthSelectize) obj.lengthSelectize.setValue(null, true);
        obj.updateLengths(value, obj.product);
        $scope.$apply();
      },
      onInitialize: function onInitialize(selectize) {
        obj.varietySelectize = selectize;
      }
    };

    obj.lengthConfig = {
      create: false,
      highlight: true,
      valueField: 'key',
      //labelField: 'length',
      delimiter: '|',
      searchField: ['label'],
      placeholder: 'Select Length',
      maxItems: 1,
      render: {
        option: function option(data, escape) {
          return '<div class="option">' + '<span class="title">' + escape(data.label) + '</span>' + '</div>';
        },
        item: function item(data, escape) {
          return '<div class="item">' + '<span class="item">' + escape(data.label) + '</span>' + '</div>';
        }
      },
      onInitialize: function onInitialize(selectize) {
        obj.lengthSelectize = selectize;
      }
    };

    obj.updateGrades = function (product_group) {
      obj.grades = [];
      obj.grades_aux = {};

      if (!product_group) {
        angular.copy(obj.grades, obj.gradeOptions);
      } else {

        for (var i = 0; i < obj.masterlist.length; i++) {

          if (obj.masterlist[i].product_group._KEY == product_group) {

            // not al the masterlist have a grade object
            if (obj.masterlist[i].grade) {
              obj.grades_aux[obj.masterlist[i].grade._KEY] = obj.masterlist[i].grade;
            }
          }
        }

        angular.forEach(obj.grades_aux, function (item) {
          obj.grades.push(item);
        });
      }
      obj.gradesSelectize.refreshOptions();
    };

    obj.loadGrades = function () {

      ps.listGrades(function (grades) {

        obj.grades = grades.all;
        obj.gradeOptions = angular.copy(obj.grades);
        obj.gradesMap = grades.mapped;

        obj.grade_types = [{ label: 'all', value: 'all' }];
        angular.forEach(obj.gradesMap, function (item, key) {
          obj.grade_types.push({ label: key, value: key });
        });
      }, function (err) {
        alertify.error(err);
      });
    };

    obj.gradeConfig = {
      create: false,
      highlight: true,
      valueField: '_KEY',
      delimiter: '|',
      searchField: ['grade', 'grade_type'],
      placeholder: 'Select Grade',
      maxItems: 1,
      render: {
        option: function option(data, escape) {
          return '<div class="option">' + '<span class="title">' + escape(data.grade) + ' (' + escape(data.grade_type) + ')' + '</span>' + '</div>';
        },
        item: function item(data, escape) {
          return '<div class="item">' + '<span class="item">' + escape(data.grade) + ' (' + escape(data.grade_type) + ')' + '</span>' + '</div>';
        }
      },
      onInitialize: function onInitialize(selectize) {
        // receives the selectize object as an argument
        obj.gradesSelectize = selectize;
      }
    };

    obj.checkDates = function (isStart) {
      if (obj.start_date) {
        if (isStart || !obj.end_date) {
          var nextSaturday = new Date(obj.start_date);
          var day = nextSaturday.getDay();
          var diff = (6 - day + 7) % 7;
          if (diff === 0) diff = 7; // If it's already Saturday, go to next Saturday
          nextSaturday.setDate(nextSaturday.getDate() + diff);
          obj.end_date = nextSaturday;
        }

        // var maxEndDate = new Date(obj.start_date);
        // maxEndDate.setDate(maxEndDate.getDate() + 7 * 8);
        // obj.dateOptions2.maxDate = maxEndDate;
        obj.dateOptions2.minDate = obj.start_date;

        // if (obj.end_date && obj.end_date > maxEndDate) {
        //   alertify.error('The end date cannot be more than 8 weeks after the start date.');
        //   obj.end_date = null;
        // }
      }
      if (obj.start_date && obj.end_date) {
        if (obj.start_date > obj.end_date) {
          alertify.error('The end date must be a Saturday after the start date.');
          obj.end_date = null;
        }
      }
    };

    obj.setupBaseMasterlist = function () {
      obj.masterlist = fs.start(obj.masterlistBackUp).applyFilter('filter', [obj.variety]).applyFilter('filter', [obj.grade]).value;
      if (obj.product) {
        obj.masterlist = obj.masterlist.filter(function (item) {
          return item.product_group && item.product_group._KEY === obj.product;
        });
      }
      if (obj.length) {
        var list = [];
        angular.forEach(obj.masterlist, function (item) {
          if (item.length == obj.length) {
            list.push(item);
          }
        });
        obj.masterlist = list;
      }
      if (obj.masterlist) {
        obj.masterlist = obj.masterlist.sort(function (a, b) {
          var nameCompare = a.variety.variety_name.localeCompare(b.variety.variety_name);
          if (nameCompare !== 0) return nameCompare;
          var lenA = a.length || a.box && a.box.fixed_length || 0;
          var lenB = b.length || b.box && b.box.fixed_length || 0;
          return lenA - lenB;
        });
        obj.base_masterlist.map = common.toMap(obj.masterlist, 'base_map', '_KEY');
        obj.base_masterlist.items = angular.copy(obj.masterlist);
      }
    };

    obj.loadInventory = function (cb) {

      if (Object.keys(obj.base_masterlist.map).length === 0) {
        alertify.error("The current grower doesn't have masterlist active.");
        cb();
      } else {
        var query = commonSrv.sbx.with('inventory').andWhereIsEqual('grower', common.getUserData().grower).andWhereIsEqual('week', common.convertDateToNumberDate(obj.start_date, true)).andWhereIn('masterlist', Object.keys(obj.base_masterlist.map)).compile();

        common.loadAllPages(query, function (data) {
          var inventory = {};
          obj.copyInventor = [];
          obj.inventories = [];
          data.results.filter(function (inv) {
            return !inv.kind;
          }).forEach(function (inv) {
            inventory[inv.masterlist] = inv;
          });
          obj.masterlist.forEach(function (ms) {
            var inv = inventory[ms._KEY];
            var aux = { ms: ms, masterlist: ms._KEY, variety: ms.variety._KEY, price: 0, quantity: 0, key: null, freeze: false };
            if (inv) {
              aux.price = inv.price;
              aux.quantity = inv.quantity;
              aux.key = inv._KEY;
              aux.freeze = !!inv.freeze;
            }
            obj.copyInventory.push(Object.assign({}, aux));
            obj.inventories.push(Object.assign({}, aux));
          });

          cb();
        }, function (err) {
          alertify.error(err);
          obj.loadingInv = false;
        });
      }
    };

    obj.computeWeeks = function () {
      var weeks = [];
      var current = new Date(obj.start_date);
      while (current <= obj.end_date) {
        var weekEnd = new Date(current);
        weekEnd.setDate(weekEnd.getDate() + 5);
        if (weekEnd > obj.end_date) weekEnd = new Date(obj.end_date);
        weeks.push({ start: new Date(current), end: new Date(weekEnd) });
        current.setDate(current.getDate() + 7);
      }
      return weeks;
    };

    obj.loadMultiWeekInventory = function (weeks, cb) {
      if (Object.keys(obj.base_masterlist.map).length === 0) {
        alertify.error("The current grower doesn't have masterlist active.");
        return cb();
      }

      var weekNumbers = weeks.map(function (w) {
        return common.convertDateToNumberDate(w.start, true);
      });

      var query = commonSrv.sbx.with('inventory').andWhereIsEqual('grower', common.getUserData().grower).andWhereIn('week', weekNumbers).andWhereIn('masterlist', Object.keys(obj.base_masterlist.map)).compile();

      common.loadAllPages(query, function (data) {
        var inventoryMap = {};
        data.results.filter(function (inv) {
          return !inv.kind;
        }).forEach(function (inv) {
          if (!inventoryMap[inv.week]) inventoryMap[inv.week] = {};
          inventoryMap[inv.week][inv.masterlist] = inv;
        });

        obj.weeksInventories = weeks.map(function (week) {
          var weekNum = common.convertDateToNumberDate(week.start, true);
          var weekInvMap = inventoryMap[weekNum] || {};
          var inventories = obj.masterlist.map(function (ms) {
            var inv = weekInvMap[ms._KEY];
            var origPrice = inv ? parseFloat(inv.price) || 0 : 0;
            var origQty = inv ? parseInt(inv.quantity, 10) || 0 : 0;
            var origFreeze = inv ? !!inv.freeze : false;
            var aux = { ms: ms, masterlist: ms._KEY, variety: ms.variety._KEY, price: origPrice, quantity: origQty, _origPrice: origPrice, _origQty: origQty, key: inv ? inv._KEY : null, freeze: origFreeze, _origFreeze: origFreeze };
            return aux;
          });
          return { week: week, inventories: inventories };
        });

        cb();
      }, function (err) {
        alertify.error(err);
        obj.loadingInv = false;
      });
    };

    obj.search = function () {
      if (!obj.product) {
        return alertify.error('You must select a Product Group before selecting a range.');
      }
      if (!obj.start_date || !obj.end_date) {
        return alertify.error('You must choose a start date and an ending date.');
      }
      obj.loadingInv = true;
      obj.weeksInventories = [];
      obj.editMode = false;
      obj.showConfirm = false;

      obj.setupBaseMasterlist();
      var weeks = obj.computeWeeks();
      obj.loadMultiWeekInventory(weeks, function () {
        obj.showSave = true;
        obj.loadingInv = false;
      });
    };

    obj.clearFilters = function () {
      obj.variety = null;
      obj.product = null;
      obj.length = null;
      obj.grade = null;
      obj.start_date = null;
      obj.end_date = null;
      obj.weeksInventories = [];
      obj.editMode = false;
      obj.showConfirm = false;
      obj.showSave = false;
      if (obj.productSelectize) {
        obj.productSelectize.setValue(null, true);obj.productSelectize.refreshOptions(false);
      }
      if (obj.varietySelectize) {
        obj.varietySelectize.setValue(null, true);obj.varietySelectize.refreshOptions(false);
      }
      if (obj.lengthSelectize) {
        obj.lengthSelectize.setValue(null, true);obj.lengthSelectize.refreshOptions(false);
      }
      if (obj.gradesSelectize) obj.gradesSelectize.refreshOptions();
      obj.products = angular.copy(obj.productsMaster);
      obj.varieties = angular.copy(obj.varietiesMaster);
      obj.updateLengths(null, null);
    };

    obj.singlePriceMode = false;
    obj.editMode = false;
    obj.showConfirm = false;
    obj.confirmWeeks = [];
    obj.confirmRows = [];

    obj.enableEdit = function () {
      obj.editMode = true;
      obj.showConfirm = false;
    };

    obj.requestSave = function () {
      // Snapshot: deep-copy values so confirm view is stable even if user goes back and edits
      obj.confirmWeeks = obj.weeksInventories.map(function (wd) {
        return wd.week;
      });
      obj.confirmRows = obj.weeksInventories[0].inventories.map(function (inv, i) {
        return {
          ms: inv.ms,
          weeks: obj.weeksInventories.map(function (wd) {
            var src = obj.singlePriceMode ? obj.weeksInventories[0].inventories[i] : wd.inventories[i];
            var weekInv = wd.inventories[i];
            return {
              price: src.price,
              quantity: src.quantity,
              uom: src.ms.UoM.uom,
              freeze: weekInv.freeze,
              unfreezing: weekInv._origFreeze && !weekInv.freeze
            };
          })
        };
      });
      obj.editMode = false;
      obj.showConfirm = true;
    };

    obj.cancelConfirm = function () {
      obj.showConfirm = false;
      obj.editMode = true;
    };

    obj.confirmSave = function () {
      obj.showConfirm = false;
      obj.saveInventory();
    };

    obj.toggleFreeze = function (inv, week) {
      // Only records that were loaded as frozen can be touched from here — the
      // grower can flip this switch back and forth freely until Review & Save,
      // but once _origFreeze is false (either never frozen, or already saved as
      // unfrozen and reloaded), it's locked — freezing is admin-only.
      if (!inv._origFreeze || !inv.key) return;

      if (!inv.freeze) {
        // Reverting to the original (still) frozen state — no need to confirm.
        inv.freeze = true;
        return;
      }

      var weekLabel = $filter('date')(week.start, 'MMM dd') + ' – ' + $filter('date')(week.end, 'MMM dd, yyyy');
      var varietyLabel = inv.ms.variety.variety_name + (inv.ms.variety.subtitle ? ' ' + inv.ms.variety.subtitle : '');

      common.confirmModal({
        title: 'Unfreeze inventory',
        msj: 'Mark <strong>' + varietyLabel + '</strong> (' + inv.ms.product_group.common_name + ') for week ' + weekLabel + ' to be unfrozen? Current quantity: ' + (inv.quantity || 0) + ', price: $' + $filter('number')(inv.price, 2) + '. This will only take effect once you press <strong>Review &amp; Save</strong>.',
        trustMsj: true,
        saveText: 'Mark to unfreeze',
        cancelText: 'Cancel'
      }, function () {
        // Staged locally only — the actual write happens in saveInventory(),
        // same as quantity/price, so nothing is persisted until Review & Save.
        inv.freeze = false;
        alertify.log('Marked to unfreeze — press "Review & Save" to apply.');
      });
    };

    obj.saveInventory = function () {
      if (!obj.weeksInventories || !obj.weeksInventories.length) {
        return alertify.log('Nothing to update');
      }

      var growerName = common.getUserData().grower_name ? common.getUserData().grower_name : common.getUserData().data.metadata.grower_name;

      var freezeChanges = [];
      obj.weeksInventories.forEach(function (weekData) {
        weekData.inventories.forEach(function (inv) {
          if (inv.key && inv.freeze !== inv._origFreeze) {
            freezeChanges.push(inv);
          }
        });
      });

      var weekTasks = obj.weeksInventories.map(function (weekData, weekIdx) {
        var changedItems = [];
        var changedMs = [];

        weekData.inventories.forEach(function (inv, i) {
          var src = obj.singlePriceMode ? obj.weeksInventories[0].inventories[i] : inv;
          var newPrice = parseFloat(src.price) || 0;
          var newQty = parseInt(src.quantity, 10) || 0;

          if (newPrice !== inv._origPrice || newQty !== inv._origQty) {
            var aux = Object.assign({}, src);
            aux.masterlist = inv.masterlist;
            aux.variety = inv.variety;
            aux.price = newPrice;
            aux.quantity = newQty;
            delete aux.ms;
            delete aux._origPrice;
            delete aux._origQty;
            changedItems.push(aux);
            changedMs.push(inv.ms);
          }
        });

        return { week: weekData.week, tempMs: changedMs, items: changedItems };
      });

      obj.updatebleSize = weekTasks.length;
      obj.updateIndex = 0;
      obj.loadingInv = true;

      async.eachSeries(weekTasks, function (weekTask, nextWeek) {
        if (!weekTask.items.length) return nextWeek();

        growerSrv.updateInventoryCS(weekTask.items, weekTask.week.start, weekTask.week.end, function (data) {
          if (data.box && data.box.toCreate && data.box.toCreate.length > 0) {
            try {
              growerSrv.batchUpdateInventories(data.box.toCreate.map(function (inv) {
                return inv._KEY;
              }));
            } catch (e) {
              console.error(e);
            }
          }
          if (data.box && data.box.toUpdate && data.box.toUpdate.length > 0) {
            try {
              growerSrv.batchUpdateInventories(data.box.toUpdate.map(function (inv) {
                return inv._KEY;
              }));
            } catch (e) {
              console.error(e);
            }
          }

          obj.updateIndex += 1;

          var msjSlack = '*Updating inventory* week ' + obj.updateIndex + ' of ' + obj.updatebleSize + ',\n *Date range:* ' + common.convertDateToNumberDate(weekTask.week.start, true) + ' *to* ' + common.convertDateToNumberDate(weekTask.week.end, true) + ',\n *Grower:* ' + growerName + ',\n';
          var changes = weekTask.items.map(function (res) {
            var masterlist = weekTask.tempMs.find(function (m) {
              return m._KEY === res.masterlist;
            });
            return ' *' + (masterlist ? masterlist.search_name : '') + '* = ' + res.quantity + ' items';
          });
          growerSrv.messageSlackMassiveInventory({
            username: 'ibfBot',
            message: msjSlack + JSON.stringify(changes).replace(/[\[\]"]/g, '').replace(/,/g, ',\n'),
            url: 'farm_update'
          }, function (data) {
            if (!data.success) console.error(data.error);
          });

          nextWeek();
        }, function (err) {
          nextWeek(err);
        });
      }, function (err) {
        if (err) {
          obj.loadingInv = false;
          return alertify.error(err);
        }

        function applyFreezeChanges(cb) {
          if (!freezeChanges.length) return cb();
          var query = common.sbx.insert('inventory', freezeChanges.map(function (inv) {
            return { _KEY: inv.key, freeze: inv.freeze };
          }));
          common.method.update(query).then(function (data) {
            if (!data.success) alertify.error('Error updating freeze status, try again.');
            cb();
          });
        }

        applyFreezeChanges(function () {
          obj.loadingInv = false;
          obj.updatebleSize = 0;
          obj.updateIndex = 0;

          var eventInventories = weekTasks.reduce(function (acc, t) {
            return acc.concat(t.items);
          }, []);

          if (eventInventories.length > 0 || freezeChanges.length > 0) {
            alertify.success('Inventories Updated.');
            obj.search();
            try {
              var meta = Object.assign({ name: 'ibf_inventory_update' }, common.meta_event_data);
              $http({
                method: 'POST',
                url: 'https://sbx-event.ibuyflowers.com/api/event/' + common.actual_domain + '/ibf_inventory_update',
                data: angular.copy({
                  meta: meta,
                  props: {
                    start_date: common.convertDateToNumberDate(obj.start_date),
                    end_date: common.convertDateToNumberDate(obj.end_date),
                    inventories: eventInventories
                  }
                }),
                headers: common.getHeaders()
              });
            } catch (e) {}
          }
        });
      });
    };

    init();
  }
})(angular);
//# sourceMappingURL=growerInventoryUpdateAssistantCtrl.js.map

'use strict';

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Made by: carlos@socobox.co
 *
 */
(function (angular) {
  angular.module('ibf').controller('growerInventoryImportAssistantCtrl', ['$scope', 'alertify', 'commonSrv', 'growerSrv', 'environment', '$uibModal', '$http', growerInventoryImportAssistantCtrl]);

  function growerInventoryImportAssistantCtrl($scope, alertify, commonSrv, growerSrv, environment, $uibModal, $http) {
    var obj = this,
        common = commonSrv,
        gr = growerSrv,
        today = new Date();
    obj.format = 'dd-MMMM-yyyy';
    obj.checkboxs = {};
    var emptyCols = obj.col = {
      code: null,
      price: null,
      quantity: null,
      special: null,
      photo: null
    };
    obj.altInputFormats = ['M!/d!/yyyy'];
    obj.popup1 = {
      opened: false
    };
    obj.rowError = [];
    obj.masterlist = [];
    obj.fromCountryManager = false;
    obj.loading = false;
    obj.originalFile = null;
    $scope.$watch('obj.fileContent', function (res) {
      obj.checkboxs = {};
      if (res) {
        var preview = [];
        for (var i = 0; i < res[1].length; i++) {
          preview[i] = new Array(5);
        }
        var length = res.length > 6 ? 6 : res.length;
        for (var row = 0; row < res[1].length; row++) {
          for (var col = 1; col < length; col++) {
            preview[row][col - 1] = res[col][row];
          }
        }

        obj.preview = preview;
      }
    });

    obj.popup2 = {
      opened: false
    };

    obj.open1 = function () {
      obj.popup1.opened = true;
    };

    obj.open2 = function () {
      obj.popup2.opened = true;
    };

    function getMonday(d) {
      d = new Date(d);
      var day = d.getDay(),
          diff = d.getDate() - day + (day === 0 ? -6 : 1); // adjust when day is sunday
      return new Date(d.setDate(diff));
    }

    obj.dateOptions1 = {
      dateDisabled: disabled1,
      formatYear: 'yy',
      maxDate: new Date(today.getFullYear() + 3, 5, 22),
      minDate: getMonday(new Date()),
      startingDay: 1
    };

    obj.dateOptions2 = {
      dateDisabled: disabled2,
      formatYear: 'yy',
      maxDate: new Date(today.getFullYear() + 3, 5, 22),
      minDate: new Date(),
      startingDay: 1
    };

    // Disable weekend selection
    function disabled1(data) {
      var date = data.date,
          mode = data.mode;
      return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6 || date.getDay() === 2 || date.getDay() === 3 || date.getDay() === 4 || date.getDay() === 5);
    }

    function disabled2(data) {
      var date = data.date,
          mode = data.mode;
      return mode === 'day' && (date.getDay() === 1 || date.getDay() === 0 || date.getDay() === 2 || date.getDay() === 3 || date.getDay() === 4 || date.getDay() === 5);
    }

    obj.close = function () {};
    obj.toggled = function (index) {

      var option = obj.checkboxs[index];
      index++;
      switch (option) {
        case '1':
          Object.keys(obj.col).forEach(function (item) {
            if (obj.col[item] === index) {
              obj.col[item] = null;
            }
          });
          obj.col.code = index;
          break;
        case '2':
          Object.keys(obj.col).forEach(function (item) {
            if (obj.col[item] === index) {
              obj.col[item] = null;
            }
          });
          obj.col.price = index;

          break;
        case '3':
          Object.keys(obj.col).forEach(function (item) {
            if (obj.col[item] === index) {
              obj.col[item] = null;
            }
          });
          obj.col.quantity = index;
          break;
        case '4':
          Object.keys(obj.col).forEach(function (item) {
            if (obj.col[item] === index) {
              obj.col[item] = null;
            }
          });
          obj.col.special = index;
          break;
        case '5':
          Object.keys(obj.col).forEach(function (item) {
            if (obj.col[item] === index) {
              obj.col[item] = null;
            }
          });
          obj.col.photo = index;
          break;
        case '':
          delete obj.checkboxs[index - 1];
          Object.keys(obj.col).forEach(function (item) {
            if (obj.col[item] === index) {
              obj.col[item] = null;
            }
          });
          break;
      }
    };

    obj.getInventoryAudit = function (file, uploadData) {

      var grower = common.getUserData();
      obj.originalFile = file;
      // console.log('grower', grower)
      // debugger

      var query = common.sbx.with('inventory_audit').andWhereIsEqual('grower', grower.grower).setPage(1).compile();

      return common.method.query(common.urls.find, query).then(function () {
        var res = common.response.post_query.data;

        if (!res || !res.success) {
          alertify.error(res.error);
          throw new Error("No results");
        }

        var hasResults = res.results.length > 0;
        var folderKey = hasResults && res.results[0].folder_key ? res.results[0].folder_key : "";
        var auditKey = hasResults ? res.results[0]._KEY : "";

        return { grower: grower, folderKey: folderKey, auditKey: auditKey };
      })

      // 2️⃣ Crear folder si no existe
      .then(function (ctx) {
        if (ctx.folderKey) {
          return ctx;
        }

        var payload = {
          parent_key: common.growers_inventories_folder_key,
          name: ctx.grower.grower_company_name
        };

        return common.method.post(common.urls.addFolder, payload).then(function () {
          var response = common.response.post.data;

          if (!response.success) {
            alertify.error(response.error);
            throw new Error("No folder created");
          }

          ctx.folderKey = response.folder.key;
          return ctx;
        });
      })

      // 3️⃣ Subir archivo
      .then(function (ctx) {

        if (!ctx.folderKey) return ctx;

        var fd = new FormData();
        fd.append('file', obj.originalFile, new Date().getTime() + '-' + obj.originalFile.name);
        fd.append('model', JSON.stringify({ key: ctx.folderKey }));

        // Convertir callback en promesa
        return new Promise(function (resolve) {
          growerSrv.uploadFileToUrl(fd, function (res) {

            resolve(ctx);
          });
        });
      })

      // 4️⃣ Crear audit si no existe
      .then(function (ctx) {

        var params = {};

        if (ctx.auditKey) {
          params = {
            result: JSON.stringify({ data: uploadData }),
            _KEY: ctx.auditKey
          };
        } else {
          params = {
            grower: ctx.grower.grower,
            folder_key: ctx.folderKey,
            result: JSON.stringify({ data: uploadData })
          };
        }

        var insertQuery = common.sbx.insert("inventory_audit", [params]);

        if (params._KEY) {
          return common.method.update(insertQuery).then(function (data) {
            ctx.auditCreated = true;
            return ctx;
          });
        } else {
          return common.method.insert(insertQuery).then(function (data) {
            ctx.auditCreated = true;
            return ctx;
          });
        }
      })

      // 5️⃣ Final
      .then(function (ctx) {
        // console.log("Proceso completado:", ctx);

        try {

          var meta = Object.assign({ name: "ibf_inventory_import" }, common.meta_event_data);

          $http({
            method: 'POST',
            url: 'https://sbx-event.ibuyflowers.com/api/event/' + common.actual_domain + '/ibf_inventory_import',
            data: angular.copy({
              meta: meta,
              props: {
                grower_key: ctx.grower.grower,
                company_name: ctx.grower.grower_company_name,
                folder_key: ctx.folderKey,
                result: JSON.stringify({ data: uploadData })
              }
            }),
            headers: common.getHeaders()
          }).then(function (response) {
            return ctx;
          });

          // common.method.post(`https://sbx-event.ibuyflowers.com/api/event/${common.actual_domain}/ibf_inventory_import`, {
          //   meta: {},
          //   props: {
          //
          //     grower_key: ctx.grower.grower,
          //     company_name: ctx.grower.grower_company_name,
          //     folder_key: ctx.folderKey,
          //     last_error: JSON.stringify({not_found: uploadData.changesNotFound})
          //   }
          // }).then(function (res) {
          //   console.log('res', res)
          //   return ctx;
          // });
        } catch (e) {
          try {
            var _meta = Object.assign({ name: "ibf_inventory_import" }, common.meta_event_data);
            growerSrv.messageSlackMassiveInventory({
              username: "ibfBot",
              message: '@U05CX2MV1QD Query event fails ' + e + '\n URL: https://sbx-event.ibuyflowers.com/api/event/' + common.actual_domain + '/ibf_inventory_import  \nparams: ' + JSON.stringify({
                meta: _meta,
                props: {
                  grower_key: ctx.grower.grower,
                  company_name: ctx.grower.grower_company_name,
                  folder_key: ctx.folderKey,
                  result: JSON.stringify({ data: uploadData })
                }
              }),
              url: "test_messages"
            }, function (data) {
              if (!data.success) {}
            });
          } catch (e) {}

          return ctx;
        }
      })

      // 6️⃣ Errores
      .catch(function (err) {
        console.error("Error en getInventoryAudit:", err);
      });
    };

    obj.updateInventory = function () {
      /**
       * This function check if all the parms are filled and then take the intory to uptade in pieces of
       * 100 elements to do an async each for those elements
       * By: carlos@socobox.co
       */

      var lowestPrice = 0.01;
      if (obj.start_date != null && obj.end_date != null && obj.col.code != null && obj.col.price != null && obj.col.quantity != null) {
        var changes = [];
        obj.rowError = [];
        var currentIndex = 0;
        try {
          obj.fileContent.forEach(function (row, index) {
            currentIndex = index;
            if (index > 0 && row.length > 2) {
              var item = {
                price: parseFloat(row[obj.col.price - 1].replace(',', '.')),
                code: row[obj.col.code - 1],
                quantity: parseInt(row[obj.col.quantity - 1])
              };
              if (isNaN(item.quantity)) {
                throw obj.col.quantity;
              }
              // console.log(item.price < lowestPrice);

              if (isNaN(item.price) || item.price < lowestPrice) {
                throw { col: obj.col.price, value: item.price };
              }
              if (obj.col.special) {
                var special = row[obj.col.special - 1].toLowerCase();
                try {
                  item.special = JSON.parse(special);
                } catch (e) {
                  throw obj.col.special;
                }
              }
              if (obj.col.photo) {
                item.photo = row[obj.col.photo - 1];
              }
              changes.push(item);
            }
          });
        } catch (e) {
          obj.rowError = obj.fileContent[currentIndex];
          if (e.col) {
            return alertify.error('Error found in row ' + currentIndex + ', column ' + e.col + '. The price is below to ' + lowestPrice);
          }
          return alertify.error('Error found in row ' + currentIndex + ', column ' + e);
        }
        // console.log(changes);
        changes.forEach(function (i) {
          i.code = i.code.trim();
        });
        var emptyCode = changes.find(function (item, index) {
          item.index = index;
          return !item.code;
        });
        var emptySpecial = changes.find(function (item, index) {
          item.index = index;
          return typeof item.special !== 'boolean';
        });
        changes.forEach(function (item) {
          if (obj.col.photo && !item.photo.length) {
            item.photo = null;
          }
        });
        changes = changes.filter(function (item) {
          return item.quantity;
        });
        // console.log(emptyCode, emptySpecial);
        if (emptyCode) {
          return alertify.error('Have an error "Code" in the row ' + emptyCode.index);
        } else {
          if (emptySpecial && obj.col.special) {
            return alertify.error('Have an error "Special" in the row ' + emptySpecial.index);
          } else {
            var grower = common.getUserData().grower;
            var initDate = obj.start_date.numDateWithoutTimeZone();
            var endDate = obj.end_date.numDateWithoutTimeZone();

            var modal = gr.confirmModal({
              params: {
                changes: changes,
                initDate: obj.start_date.numDateWithoutTimeZone(),
                endDate: obj.end_date.numDateWithoutTimeZone(),
                grower: changes
              }
            });

            modal.result.then(function () {
              var partialsChange = [];
              for (var i = 0; i < changes.length; i += 50) {

                partialsChange.push(changes.slice(i, i + 50));
              }
              //TODO:Call the function to return the map for the new modal and display the data
              // Mete monoconsole.log(gr.updateInventory);
              var modal = $uibModal.open({
                templateUrl: 'views/progress_dialog.html',
                controller: 'growerUpdateModalCtrl',
                controllerAs: 'modal',
                bindToController: true,
                backdrop: 'static',
                keyboard: false,
                size: 'lg',
                resolve: {
                  config: function config() {
                    return {
                      inventories: changes,
                      partialsChange: partialsChange,
                      grower: grower,
                      initDate: initDate,
                      endDate: endDate,
                      onSuccess: function onSuccess(_data) {
                        modal.close();
                        var modalPost = $uibModal.open({
                          templateUrl: 'views/grower/updated.modal.html',
                          controller: 'growerInventoryUpdated',
                          controllerAs: 'obj',
                          bindToController: true,
                          backdrop: 'static',
                          keyboard: false,
                          size: 'lg',
                          resolve: {
                            data: function data() {
                              return _data;
                            }
                          }
                        });

                        try {
                          obj.getInventoryAudit(obj.originalFile, _data);
                        } catch (e) {}
                      },
                      onError: function onError(data) {

                        modal.close();
                        var modal2 = $uibModal.open({
                          templateUrl: 'views/confirm_modal.html',
                          controller: 'confirmModalCtrl',
                          controllerAs: 'obj',
                          backdrop: 'static',
                          size: 'sm',
                          resolve: {
                            config: function config() {
                              return {
                                title: "Error updating inventory",
                                msj: "There was an error updating the inventory, please try again later",
                                save: "Ok",
                                hideCancel: true
                              };
                            }
                          }
                        });
                      },
                      close: function close() {
                        return modal.close();
                      }
                    };
                  }
                }
              });
            }, function (reason) {
              console.log('Closing task modal');
            });
          }
        }
      } else {
        alertify.error('Please complete the process');
      }
    };

    obj.checkDates = function () {
      // console.log(obj.start_date);
      // console.log(obj.start_date.numDateWithoutTimeZone());
    };

    obj.downloadExcelVarietyExpectedPrice = function (array) {

      var wb = XLSX.utils.book_new();
      wb.SheetNames.push('variety_expected_price');

      var data = obj.generateTableVarietyExpectedPrice(array);

      var ws = XLSX.utils.aoa_to_sheet(data);
      wb.Sheets['variety_expected_price'] = ws;
      var wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

      var fileName = common.convertDateToNumberDate(new Date()) + ' ' + (common.getUserData().grower_company_name ? common.getUserData().grower_company_name : '') + ' download file iBuyFlowers.xls';
      saveAs(new Blob([obj.convertArrayBuffer(wbout)], { type: 'application/octet-stream' }), fileName);
    };

    obj.convertArrayBuffer = function (item) {

      var buf = new ArrayBuffer(item.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i < item.length; i++) {
        view[i] = item.charCodeAt(i) & 0xFF;
      }return buf;
    };

    obj.generateUniqueDateColumns = function () {
      var monthsOrder = {
        1: "jan",
        2: "feb",
        3: "mar",
        4: "apr",
        5: "may",
        6: "jun",
        7: "jul",
        8: "aug",
        9: "sep",
        10: "oct",
        11: "nov",
        12: "dec"
      };

      var currentDate = new Date();
      var currentMonthNumber = currentDate.getMonth() + 1;
      var monthsToAdd = 5;

      return Array.from({ length: monthsToAdd }, function (_, i) {
        var nextMonthNumber = (currentMonthNumber + (i + 1)) % 12 || 12;
        return monthsOrder[nextMonthNumber];
      });
    };

    obj.firstCapitalizeLetter = function (str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    };

    obj.getCurrentMonthName = function () {
      var monthsOrder = {
        1: "jan",
        2: "feb",
        3: "mar",
        4: "apr",
        5: "may",
        6: "jun",
        7: "jul",
        8: "aug",
        9: "sep",
        10: "oct",
        11: "nov",
        12: "dec"
      };
      var currentDate = new Date();
      var currentMonthNumber = currentDate.getMonth() + 1;
      return monthsOrder[currentMonthNumber];
    };

    obj.generateTableVarietyExpectedPrice = function (array) {

      var dynamicColumns = obj.generateUniqueDateColumns().map(function (month) {
        return obj.firstCapitalizeLetter(month) + ' exp.price';
      });
      var currentMonth = obj.getCurrentMonthName();

      var expectedMonthPrice = obj.firstCapitalizeLetter(currentMonth) + ' exp.price';
      var head = [[
      // 'masterlist_key',
      // 'search_name',
      'grower_code', 'UoM', 'UoM/week', 'ibf ave.price', expectedMonthPrice].concat(_toConsumableArray(dynamicColumns))];

      var dataCsv = [];

      if (!array.length) return;

      dataCsv = array.map(function (item) {

        var props = _defineProperty({
          // masterlist_key: item._KEY ? item._KEY : '',
          // search_name: item.search_name ? item.search_name : '',
          grower_code: item.grower_code,
          UOM: item.uom,
          'UoM/week': '',
          'ibf ave.price': item.total_average.toFixed(2)
        }, expectedMonthPrice, item.ty_tm ? (item.ty_tm ? item.ty_tm : 0).toFixed(2) : 0);

        Object.keys(item.prices_by_month).forEach(function (month) {
          var head = dynamicColumns.find(function (column) {
            return column.toLocaleLowerCase().includes(month);
          });
          if (head) {
            props[head] = item.prices_by_month[month].toFixed(2);
          }
        });

        return props;
      });

      var _loop = function _loop(item) {
        var variety = dataCsv[item];
        var valuesBymonths = dynamicColumns.map(function (column) {
          return variety[column];
        });

        head.push([
        // variety.masterlist_key,
        // variety.search_name,
        variety.grower_code, variety.UOM, variety['UoM/week'], variety['ibf ave.price'], variety[expectedMonthPrice]].concat(_toConsumableArray(valuesBymonths)));
      };

      for (var item = 0; item < dataCsv.length; item++) {
        _loop(item);
      }

      return head;
    };

    obj.getReportVarietyExpectedNextMonths = function () {
      return new Promise(function (resolve, reject) {
        obj.loadingColumn = true;
        var query = common.sbx.with('report_variety_expected_next_months').compile();
        common.loadAllPages(query, function (res) {
          if (res.results.length) {

            var results = res.results;

            var expectedItems = [];
            var noGrowerCodeMasterlist = [];
            var notFoundedMasterlist = [];

            obj.masterlist.filter(function (item) {
              return item.grower_code;
            }).forEach(function (masterlist) {
              var items = results.filter(function (item) {
                var product_group = masterlist.product_group.trim().toLowerCase();
                var variety = (item.variety ? item.variety : "").trim().toLowerCase().split(product_group)[0];

                return masterlist.variety.trim().toLowerCase() === variety.trim().toLowerCase() && (item.variety ? item.variety : "").trim().toLowerCase().includes(product_group.trim().toLowerCase()) && masterlist.length === parseInt(item.length) && masterlist.uom.trim() === item.uom.trim();
              });

              if (items.length > 0) {
                items.forEach(function (item) {
                  if (item) {
                    if (!expectedItems.some(function (expItem) {
                      return expItem.grower_code.trim() === (masterlist.grower_code ? masterlist.grower_code : "").trim() && expItem.date === item.date;
                    })) {
                      item.grower_code = masterlist.grower_code.trim();
                      item.search_name = masterlist.search_name;
                      item._KEY = masterlist._KEY;
                      expectedItems.push(item);
                    }
                  }
                });
              } else {
                notFoundedMasterlist.push({
                  grower_code: masterlist.grower_code,
                  length: masterlist.length,
                  product_group: masterlist.product_group,
                  variety: masterlist.variety + ' ' + masterlist.product_group,
                  uom: masterlist.uom,
                  _KEY: masterlist._KEY,
                  search_name: masterlist.search_name ? masterlist.search_name : ''
                });
              }
            });

            obj.masterlist.filter(function (item) {
              return !item.grower_code || item.grower_code === "";
            }).forEach(function (masterlist) {

              var items = results.filter(function (item) {
                var product_group = masterlist.product_group.trim().toLowerCase();
                var variety = (item.variety ? item.variety : "").trim().toLowerCase().split(product_group)[0];

                return masterlist.variety.trim().toLowerCase() === variety.trim().toLowerCase() && (item.variety ? item.variety : "").trim().toLowerCase().includes(product_group.trim().toLowerCase()) && masterlist.length === parseInt(item.length) && masterlist.uom.trim() === item.uom.trim();
              });

              var grower_code = masterlist.product_group + ' ' + masterlist.variety + ' ' + masterlist.length;

              if (!noGrowerCodeMasterlist.some(function (noGrowerCode) {
                return noGrowerCode.grower_code === grower_code;
              })) {
                noGrowerCodeMasterlist.push({
                  _KEY: masterlist._KEY,
                  grower_code: grower_code.trim(),
                  search_name: masterlist.search_name ? masterlist.search_name : ''
                });
              }

              if (items.length > 0) {
                items.forEach(function (item) {
                  if (item) {
                    if (!expectedItems.some(function (expItem) {
                      return expItem.grower_code.trim() === (masterlist.grower_code ? masterlist.grower_code : "").trim() && expItem.date === item.date;
                    })) {
                      item.grower_code = grower_code.trim();
                      item.search_name = masterlist.search_name;
                      item._KEY = masterlist._KEY;
                      expectedItems.push(item);
                    }
                  }
                });
              } else {
                notFoundedMasterlist.push({
                  grower_code: grower_code,
                  length: masterlist.length,
                  product_group: masterlist.product_group,
                  variety: masterlist.variety + ' ' + masterlist.product_group,
                  uom: masterlist.uom,
                  _KEY: masterlist._KEY,
                  search_name: masterlist.search_name
                });
              }
            });

            common.removeDuplicateFromArrayObj(notFoundedMasterlist, "_KEY").forEach(function (masterlist) {
              var grower_code = masterlist.grower_code ? masterlist.grower_code : masterlist.product_group + ' ' + masterlist.variety + ' ' + masterlist.length;
              if (grower_code && !expectedItems.some(function (expItem) {
                return expItem.grower_code === grower_code;
              })) {
                var objItemMasterList = Object.assign({}, masterlist);
                objItemMasterList.tm_expected_price = 0;
                objItemMasterList.total_average = 0;
                objItemMasterList.date = null;
                objItemMasterList.grower_code = grower_code;
                expectedItems.push(objItemMasterList);
              }
            });

            // console.log('second table')
            // console.log('expectedItems', expectedItems.length)
            // console.log('noGrowerCodeMasterlist', noGrowerCodeMasterlist.length)
            var objDateExpectedPrice = {};

            expectedItems.forEach(function (ele) {
              var key = ele.variety.trim() + '_' + ele.length + '_' + ele.uom + '_' + ele.grower_code;
              if (!objDateExpectedPrice[key]) {
                objDateExpectedPrice[key] = {
                  total_average: 0,
                  variety: ele.variety,
                  length: ele.length,
                  uom: ele.uom,
                  prices_by_month: {},
                  grower_code: ele.grower_code,
                  _KEY: ele._KEY,
                  search_name: ele.search_name
                };
                obj.generateUniqueDateColumns().forEach(function (month) {
                  objDateExpectedPrice[key].prices_by_month[month] = 0;
                });
              }

              objDateExpectedPrice[key].total_average = ele.total_average;
              if (ele.date) {
                objDateExpectedPrice[key].prices_by_month[ele.date.toLowerCase()] = ele.tm_expected_price;
              }
            });

            var reportData = objDateExpectedPrice;

            obj.loadingColumn = false;
            resolve({ reportData: reportData, noGrowerCodeMasterlist: noGrowerCodeMasterlist });
          } else {
            obj.loadingColumn = false;
            reject(new Error('No data available'));
          }
        });
      });
    };

    obj.getExcelVarietyExpectedPrice = function () {
      obj.loading = true;
      var query = common.sbx.with('report_variety_expected_price').compile();

      var buildFallbackGrowerCode = function buildFallbackGrowerCode(masterlist) {
        var base = masterlist.product_group + ' ' + masterlist.variety + ' ' + masterlist.length;

        if (!masterlist.subtitle) return base;
        var withSubtitle = masterlist.product_group + ' ' + masterlist.variety + ' ' + masterlist.subtitle + ' ' + masterlist.length;

        return withSubtitle.length >= 255 ? base : withSubtitle;
      };

      var resolveGrowerCode = function resolveGrowerCode(masterlist) {
        if (masterlist.grower_code) {
          if (masterlist.subtitle && !masterlist.grower_code.toLowerCase().includes(masterlist.subtitle.toLowerCase())) {
            return buildFallbackGrowerCode(masterlist);
          }

          if (masterlist.variety && !masterlist.grower_code.toLowerCase().includes(masterlist.variety.toLowerCase())) {
            return buildFallbackGrowerCode(masterlist);
          }
          return masterlist.grower_code.trim();
        }
        return buildFallbackGrowerCode(masterlist);
      };

      var buildKey = function buildKey(item) {
        return item.variety.trim() + '_' + item.length + '_' + item.uom + '_' + item.grower_code;
      };

      var findMatchingResult = function findMatchingResult(masterlist, results) {
        return results.find(function (item) {
          var product_group = masterlist.product_group.trim().toLowerCase();
          var variety = (item.variety ? item.variety : "").trim().toLowerCase().split(product_group)[0];

          return masterlist.variety.trim().toLowerCase() === variety.trim().toLowerCase() && (item.variety ? item.variety : "").trim().toLowerCase().includes(product_group.trim().toLowerCase()) && masterlist.length === parseInt(item.length) && masterlist.uom.trim() === item.uom.trim();
        });
      };

      common.loadAllPages(query, function (res) {

        if (res.results.length) {
          res.results = res.results.filter(function (item) {
            return item.variety;
          });
          obj.loading = false;

          var noGrowerCodeMasterlist = [];
          var expectedItems = [];

          obj.masterlist.filter(function (item) {
            return item.grower_code;
          }).forEach(function (masterlist) {
            var item = findMatchingResult(masterlist, res.results);
            var resolvedCode = resolveGrowerCode(masterlist);

            if (item) {

              if (!expectedItems.some(function (expItem) {
                return expItem.grower_code.toLowerCase().trim() === resolvedCode.toLowerCase().trim();
              })) {
                item.grower_code = resolvedCode;
                item.search_name = masterlist.search_name;
                item._KEY = masterlist._KEY;
                expectedItems.push(item);
              } else {}
            }
          });

          obj.masterlist.filter(function (item) {

            var grower_code = buildFallbackGrowerCode(item);

            if (item.variety && !item.grower_code.includes(item.variety)) {
              return true;
            }

            if (item.product_group && !item.grower_code.includes(item.product_group)) {
              return true;
            }

            if (grower_code !== item.grower_code && item.subtitle && !item.grower_code.includes(item.subtitle)) {
              return true;
            }

            return !item.grower_code || item.grower_code === "";
          }).forEach(function (masterlist) {
            var item = findMatchingResult(masterlist, res.results);
            var grower_code = buildFallbackGrowerCode(masterlist);

            if (!noGrowerCodeMasterlist.some(function (noGrowerCode) {
              return noGrowerCode.grower_code === grower_code;
            })) {
              noGrowerCodeMasterlist.push({
                _KEY: masterlist._KEY,
                grower_code: grower_code.trim(),
                search_name: masterlist.search_name
              });
            }

            if (item) {
              item.grower_code = grower_code.trim();
              item.search_name = masterlist.search_name;
              item._KEY = masterlist._KEY;
              expectedItems.push(item);
            }
          });

          obj.masterlist.filter(function (item) {
            var grower_code = resolveGrowerCode(item);
            return !expectedItems.some(function (expItem) {
              return expItem.grower_code.toLowerCase().trim() === grower_code.toLowerCase().trim();
            });
          }).forEach(function (masterlist) {
            expectedItems.push({
              _KEY: masterlist._KEY,
              search_name: masterlist.search_name ? masterlist.search_name : '',
              grower_code: resolveGrowerCode(masterlist),
              variety: masterlist.variety + ' ' + masterlist.product_group,
              length: masterlist.length,
              uom: masterlist.uom,
              ty_tm: 0,
              ly_pm: 0,
              ly_tm: 0,
              ty_pm: 0
            });
          });

          obj.getReportVarietyExpectedNextMonths().then(function (data) {

            noGrowerCodeMasterlist = noGrowerCodeMasterlist.concat(data.noGrowerCodeMasterlist);

            if (expectedItems.length > 0) {
              expectedItems.forEach(function (item) {
                var keyItem = buildKey(item);

                if (data.reportData[keyItem]) {
                  data.reportData[keyItem].ty_tm = item.ty_tm;
                  if (!data.reportData[keyItem].grower_code) {
                    data.reportData[keyItem].grower_code = item.variety + ' ' + item.length;
                  }
                } else {
                  data.reportData[keyItem] = {
                    "total_average": 0,
                    "variety": item.variety,
                    "search_name": item.search_name ? item.search_name : '',
                    "_KEY": item._KEY,
                    "length": item.length,
                    "grower_code": item.grower_code ? item.grower_code : '',
                    "uom": item.uom,
                    "ty_tm": item.ty_tm,
                    "prices_by_month": {
                      "aug": 0,
                      "sep": 0,
                      "oct": 0,
                      "nov": 0,
                      "dec": 0
                    }
                  };
                }
              });
            }

            var sortedData = Object.values(data.reportData).sort(function (a, b) {
              return a.grower_code.localeCompare(b.grower_code);
            });
            obj.downloadExcelVarietyExpectedPrice(Object.values(sortedData));

            alertify.success('Download successful');

            if (noGrowerCodeMasterlist.length > 0) {
              noGrowerCodeMasterlist = common.removeDuplicateFromArrayObj(noGrowerCodeMasterlist, "grower_code");

              common.method.run({
                key: environment.cloudscript.ibf_updateMasterListByGrower,
                params: { items: [].concat(_toConsumableArray(noGrowerCodeMasterlist)) }
              }).then(function (response) {});
            }
          }).catch(function (error) {
            console.log(error);
          });
        } else {
          obj.loading = false;
          alertify.alert('No data to download');
        }
      }, query);
    };

    function init() {
      obj.fromCountryManager = common.getUserData().fromCountryManager;

      // console.log(common.getUserData())

      obj.loading = true;
      var query = common.sbx.with('add_masterlist').andWhereIsEqual("grower", common.getUserData().grower).andWhereIsEqual("active", true).fetchModels(["variety.product_group", "UoM"]).compile();
      common.loadAllPages(query, function (res) {

        if (res.results.length) {

          var fetched = res.fetched_results;

          obj.masterlist = res.results.map(function (item) {

            var variety = fetched.variety[item.variety];
            if (variety) {
              item.subtitle = variety.subtitle ? variety.subtitle : '';
              item.variety = variety.variety_name;
            }

            if (variety.product_group) {
              var product_group = fetched.product_group[variety.product_group];
              if (product_group && product_group.common_name) {
                item.product_group = product_group.common_name;
              }
            }

            var uom = fetched.uom[item.UoM];
            if (uom) {
              item.uom = uom.uom;
            }

            return {
              _KEY: item._KEY ? item._KEY : '',
              uom: item.uom,
              length: item.length,
              variety: item.variety,
              subtitle: variety && variety.subtitle ? variety.subtitle : '',
              grower_code: item.grower_code,
              product_group: item.product_group,
              search_name: item.search_name ? item.search_name : ''
            };
          });

          obj.loading = false;

          // alertify.success('Download successful');
        } else {
          obj.loading = false;
          // alertify.alert('No data to download');
        }
      }, function (err) {
        obj.loading = false;
      });
    }

    init();
  }
})(angular);
//# sourceMappingURL=growerInventoryImportAssistantCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('growerInventoryRecommendationCtrl', ['$scope', 'alertify', 'commonSrv', '$filter', 'growerSrv', 'FileSaver', 'Blob', growerInventoryRecommendationCtrl]);

  function growerInventoryRecommendationCtrl($scope, alertify, commonSrv, $filter, growerSrv, FileSaver, Blob) {
    var obj = this,
        common = commonSrv;

    obj.isLoadingMasterlist = false;
    obj.isLoadingRecommendations = false;
    obj.isDownloading = false;
    obj.hasRequestedRecommendations = false;
    obj.hasLoadedRecommendations = false;
    obj.showDateValidation = false;
    obj.showProductFilter = true;
    obj.showVarietyFilter = true;
    obj.showLengthFilter = true;
    obj.showGradeFilter = false;
    obj.hasProductData = false;
    obj.hasVarietyData = false;
    obj.hasLengthData = false;
    obj.hasGradeData = false;
    obj.products = [];
    obj.varieties = [];
    obj.grades = [];
    obj.lengthsObject = [];
    obj.recommendationItems = [];
    obj.filteredItems = [];
    obj.pageItems = [];
    obj.tableColumns = [];
    obj.pageSizeOptions = [5, 10, 15, 20, 30];
    obj.totalItems = 0;
    obj.currentPage = 1;
    obj.itemsPerPage = 15;
    obj.searchText = '';
    obj.fromWeek = null;
    obj.toWeek = null;
    obj.fromWeekPopup = {
      opened: false
    };
    obj.toWeekPopup = {
      opened: false
    };
    obj.weekDateOptions = {
      dateDisabled: disableNonMondays
    };

    var FILTER_DEFINITIONS = {
      product: {
        model: 'product',
        optionsKey: 'products',
        visibleKey: 'showProductFilter',
        itemFields: ['product_group'],
        labelBuilder: function labelBuilder(value) {
          return value;
        },
        sortComparator: function sortComparator(a, b) {
          return a.label.localeCompare(b.label);
        }
      },
      variety: {
        model: 'variety',
        optionsKey: 'varieties',
        visibleKey: 'showVarietyFilter',
        itemFields: ['variety_name'],
        labelBuilder: function labelBuilder(value) {
          return value;
        },
        sortComparator: function sortComparator(a, b) {
          return a.label.localeCompare(b.label);
        }
      },
      length: {
        model: 'length',
        optionsKey: 'lengthsObject',
        visibleKey: 'showLengthFilter',
        itemFields: ['stem_length'],
        labelBuilder: function labelBuilder(value) {
          return value + ' cm';
        },
        sortComparator: function sortComparator(a, b) {
          return parseInt(a.value, 10) - parseInt(b.value, 10);
        }
      },
      grade: {
        model: 'grade',
        optionsKey: 'grades',
        visibleKey: 'showGradeFilter',
        itemFields: ['grade', 'grade_key'],
        labelBuilder: function labelBuilder(value) {
          return value;
        },
        sortComparator: function sortComparator(a, b) {
          return a.label.localeCompare(b.label);
        }
      }
    };

    function init() {}

    function getLoggedGrowerCompanyName() {
      var user = common.getUserData() || {};
      var metadata = user.data && user.data.metadata ? user.data.metadata : {};

      return user.grower_company_name || user.grower_name || metadata.grower_company_name || metadata.grower_name || '';
    }

    function normalizeText(value) {
      return (value || '').toString().trim().toLowerCase();
    }

    function disableNonMondays(data) {
      var date = data.date;
      var mode = data.mode;

      return mode === 'day' && date.getDay() !== 1;
    }

    function formatWeekStartDate(value) {
      if (!value) {
        return '';
      }

      if (angular.isDate(value)) {
        return $filter('date')(value, 'yyyy-MM-dd');
      }

      return value.toString().slice(0, 10);
    }

    function getNextMonday(date) {
      var nextMonday;

      if (!date) {
        return null;
      }

      nextMonday = new Date(date);
      nextMonday.setDate(nextMonday.getDate() + 7);

      return nextMonday;
    }

    function csvEscape(value) {
      var stringValue = value === null || value === undefined ? '' : value.toString();
      return '"' + stringValue.replace(/"/g, '""') + '"';
    }

    function buildDynamicColumns(items) {
      var columnsMap = {};
      var columns = [];

      angular.forEach(items || [], function (item) {
        angular.forEach(Object.keys(item || {}), function (key) {
          if (!key.includes("key") && !key.includes("KEY") && !columnsMap[key]) {
            columnsMap[key] = true;
            columns.push(key);
          }
        });
      });

      return columns;
    }

    function formatColumnLabel(column) {
      var customLabels = {
        grower_code: 'Grower Code',
        uom: 'UoM',
        current_inventory: 'Current Inventory',
        recommended_inventory: 'Recommended Inventory',
        current_price: 'Current ($)',
        recommended_price: 'Recommended ($)',
        most_competitive: 'Most Competitive ($)',
        avg_top_3: 'Avg Top 3 ($)'
      };

      if (customLabels[column]) {
        return customLabels[column];
      }

      return (column || '').replace(/_/g, ' ').replace(/\b\w/g, function (char) {
        return char.toUpperCase();
      });
    }

    function formatCellValue(value) {
      if (value === null || value === undefined) {
        return '';
      }

      if (angular.isArray(value)) {
        return value.join(' | ');
      }

      if (angular.isObject(value)) {
        return JSON.stringify(value);
      }

      return value;
    }

    function serializeCsv(items, columns) {
      var headers = columns || [];
      var rows = [headers.map(csvEscape).join(',')];

      angular.forEach(items, function (item) {
        rows.push(headers.map(function (header) {
          return csvEscape(formatCellValue(item[header]));
        }).join(','));
      });

      return rows.join('\r\n');
    }

    function downloadCsv(content, fileName) {
      var csv = angular.isString(content) ? content : '';
      var data = new Blob([csv], { type: 'text/plain;charset=utf-8' });
      FileSaver.saveAs(data, fileName);
    }

    function buildFileName() {
      var growerName = getLoggedGrowerCompanyName().replace(/[^a-z0-9]+/gi, '_').replace(/^_+|_+$/g, '');

      return 'inventory_recommendation_' + (growerName || 'grower') + '_' + common.convertDateToNumberDate(new Date(), true) + '.csv';
    }

    function hasOwnField(item, field) {
      return item && Object.prototype.hasOwnProperty.call(item, field);
    }

    function hasFieldInPayload(items, fields) {
      return (items || []).some(function (item) {
        return (fields || []).some(function (field) {
          return hasOwnField(item, field);
        });
      });
    }

    function getGradeValue(item) {
      if (!item) {
        return '';
      }

      return item.grade || item.grade_key || '';
    }

    function getFilterItemValue(item, filterKey) {
      if (!item) {
        return '';
      }

      if (filterKey === 'product') {
        return item.product_group;
      }

      if (filterKey === 'variety') {
        return item.variety_name;
      }

      if (filterKey === 'length') {
        return item.stem_length;
      }

      if (filterKey === 'grade') {
        return getGradeValue(item);
      }

      return '';
    }

    function buildOptionKey(filterKey, value) {
      if (filterKey === 'length') {
        return String(parseInt(value, 10));
      }

      return normalizeText(value);
    }

    function buildOptionValue(filterKey, value) {
      if (filterKey === 'length') {
        return String(parseInt(value, 10));
      }

      return value;
    }

    function hasOption(options, value) {
      var normalizedValue = value === null || value === undefined ? '' : value.toString();

      return (options || []).some(function (option) {
        return option.value.toString() === normalizedValue;
      });
    }

    function runInDigest(fn) {
      if ($scope.$$phase) {
        fn();
        return;
      }

      $scope.$apply(fn);
    }

    function refreshSelectizeOptions(selectize, options, value) {
      if (!selectize) {
        return;
      }

      selectize.clear(true);
      selectize.clearOptions();
      selectize.addOption(options || []);
      selectize.refreshOptions(false);

      if (value && hasOption(options, value)) {
        selectize.setValue(value, true);
      }
    }

    function isFilterVisible(filterKey) {
      return !!obj[FILTER_DEFINITIONS[filterKey].visibleKey];
    }

    function updateFilterVisibility(items) {
      obj.hasProductData = hasFieldInPayload(items, FILTER_DEFINITIONS.product.itemFields);
      obj.hasVarietyData = hasFieldInPayload(items, FILTER_DEFINITIONS.variety.itemFields);
      obj.hasLengthData = hasFieldInPayload(items, FILTER_DEFINITIONS.length.itemFields);
      obj.hasGradeData = hasFieldInPayload(items, FILTER_DEFINITIONS.grade.itemFields);
      obj.showProductFilter = true;
      obj.showVarietyFilter = true;
      obj.showLengthFilter = true;
      obj.showGradeFilter = obj.hasGradeData;
    }

    function matchesFilterSelection(item, filterKey, selectedValue) {
      var itemValue;

      if (!selectedValue || !isFilterVisible(filterKey)) {
        return true;
      }

      itemValue = getFilterItemValue(item, filterKey);
      if (itemValue === null || itemValue === undefined || itemValue === '') {
        return false;
      }

      if (filterKey === 'length') {
        return parseInt(itemValue, 10) === parseInt(selectedValue, 10);
      }

      return normalizeText(itemValue) === normalizeText(selectedValue);
    }

    function getItemsForAvailableOptions(excludedFilter) {
      return (obj.recommendationItems || []).filter(function (item) {
        return Object.keys(FILTER_DEFINITIONS).every(function (filterKey) {
          if (filterKey === excludedFilter) {
            return true;
          }

          return matchesFilterSelection(item, filterKey, obj[FILTER_DEFINITIONS[filterKey].model]);
        });
      });
    }

    function buildOptionsForFilter(filterKey) {
      var definition = FILTER_DEFINITIONS[filterKey];
      var optionMap = {};
      var options = [];

      if (!isFilterVisible(filterKey)) {
        return [];
      }

      angular.forEach(getItemsForAvailableOptions(filterKey), function (item) {
        var value = getFilterItemValue(item, filterKey);
        var optionKey;
        var optionValue;

        if (value === null || value === undefined || value === '') {
          return;
        }

        optionKey = buildOptionKey(filterKey, value);
        optionValue = buildOptionValue(filterKey, value);

        if (!optionMap[optionKey]) {
          optionMap[optionKey] = true;
          options.push({
            value: optionValue,
            label: definition.labelBuilder(optionValue)
          });
        }
      });

      return options.sort(definition.sortComparator);
    }

    function clearHiddenOrInvalidSelections() {
      var changed = false;

      angular.forEach(Object.keys(FILTER_DEFINITIONS), function (filterKey) {
        var definition = FILTER_DEFINITIONS[filterKey];
        var selectedValue = obj[definition.model];
        var options = obj[definition.optionsKey] || [];
        var selectize = obj[definition.model + 'Selectize'];

        if (!isFilterVisible(filterKey) && selectedValue) {
          obj[definition.model] = '';
          syncSelectizeValue(selectize, '');
          changed = true;
          return;
        }

        if (selectedValue && !hasOption(options, selectedValue)) {
          obj[definition.model] = '';
          syncSelectizeValue(selectize, '');
          changed = true;
        }
      });

      return changed;
    }

    function updateAvailableFilterOptions() {
      var attempts = 0;
      var changed;

      do {
        angular.forEach(Object.keys(FILTER_DEFINITIONS), function (filterKey) {
          var definition = FILTER_DEFINITIONS[filterKey];
          var options = buildOptionsForFilter(filterKey);

          obj[definition.optionsKey] = options;
          refreshSelectizeOptions(obj[definition.model + 'Selectize'], options, obj[definition.model]);
        });

        changed = clearHiddenOrInvalidSelections();
        attempts += 1;
      } while (changed && attempts < 5);
    }

    function filterForecastItems(items) {
      var search = normalizeText(obj.searchText);

      return (items || []).filter(function (item) {
        if (!matchesFilterSelection(item, 'product', obj.product)) {
          return false;
        }

        if (!matchesFilterSelection(item, 'length', obj.length)) {
          return false;
        }

        if (!matchesFilterSelection(item, 'variety', obj.variety)) {
          return false;
        }

        if (!matchesFilterSelection(item, 'grade', obj.grade)) {
          return false;
        }

        if (search) {
          var matchesSearch = obj.tableColumns.some(function (column) {
            return normalizeText(formatCellValue(item[column])).indexOf(search) !== -1;
          });

          if (!matchesSearch) {
            return false;
          }
        }

        return true;
      });
    }

    function syncSelectizeValue(selectize, value) {
      if (selectize) {
        selectize.setValue(value || '', true);
      }
    }

    function updateViewState(items) {
      obj.filteredItems = items;
      obj.totalItems = obj.filteredItems.length;
      obj.currentPage = 1;
      obj.getPage();
    }

    function resetRecommendationState() {
      obj.hasLoadedRecommendations = false;
      obj.showProductFilter = true;
      obj.showVarietyFilter = true;
      obj.showLengthFilter = true;
      obj.showGradeFilter = false;
      obj.hasProductData = false;
      obj.hasVarietyData = false;
      obj.hasLengthData = false;
      obj.hasGradeData = false;
      obj.product = '';
      obj.variety = '';
      obj.length = '';
      obj.grade = '';
      obj.searchText = '';
      obj.recommendationItems = [];
      obj.filteredItems = [];
      obj.pageItems = [];
      obj.tableColumns = [];
      obj.totalItems = 0;
      obj.products = [];
      obj.varieties = [];
      obj.lengthsObject = [];
      obj.grades = [];
      syncSelectizeValue(obj.productSelectize, '');
      syncSelectizeValue(obj.varietySelectize, '');
      syncSelectizeValue(obj.lengthSelectize, '');
      syncSelectizeValue(obj.gradesSelectize, '');
      refreshSelectizeOptions(obj.productSelectize, [], '');
      refreshSelectizeOptions(obj.varietySelectize, [], '');
      refreshSelectizeOptions(obj.lengthSelectize, [], '');
      refreshSelectizeOptions(obj.gradesSelectize, [], '');
    }

    function handleRecommendationData(items) {
      obj.recommendationItems = angular.copy(items || []).sort(function (a, b) {
        var valA = (a.grower_code || '').toString();
        var valB = (b.grower_code || '').toString();
        var isNumA = /^\d/.test(valA);
        var isNumB = /^\d/.test(valB);

        if (isNumA && !isNumB) {
          return 1;
        }
        if (!isNumA && isNumB) {
          return -1;
        }
        return valA.localeCompare(valB, undefined, { numeric: true, sensitivity: 'base' });
      });
      obj.tableColumns = buildDynamicColumns(obj.recommendationItems);
      updateFilterVisibility(obj.recommendationItems);
      updateAvailableFilterOptions();
      obj.hasLoadedRecommendations = true;
      updateViewState(filterForecastItems(obj.recommendationItems));
    }

    obj.getPage = function () {
      var initIndex = (obj.currentPage - 1) * obj.itemsPerPage;
      var endIndex = initIndex + obj.itemsPerPage;
      obj.pageItems = obj.filteredItems.slice(initIndex, endIndex);
    };

    obj.onItemsPerPageChange = function () {
      obj.itemsPerPage = parseInt(obj.itemsPerPage, 10) || 15;
      obj.currentPage = 1;
      obj.getPage();
    };

    obj.getVisibleRangeLabel = function () {
      var start;
      var end;

      if (!obj.totalItems) {
        return 'Showing 0-0 of 0';
      }

      start = (obj.currentPage - 1) * obj.itemsPerPage + 1;
      end = Math.min(obj.currentPage * obj.itemsPerPage, obj.totalItems);

      return 'Showing ' + start + '-' + end + ' of ' + obj.totalItems;
    };

    obj.getColumnLabel = function (column) {
      return formatColumnLabel(column);
    };

    obj.applyFilters = function () {
      if (!obj.hasLoadedRecommendations) {
        return;
      }

      updateAvailableFilterOptions();
      updateViewState(filterForecastItems(obj.recommendationItems));
    };

    function handleSelectizeChange(filterKey, value) {
      runInDigest(function () {
        obj[FILTER_DEFINITIONS[filterKey].model] = value || '';
        obj.applyFilters();
      });
    }

    obj.clearFilters = function () {
      obj.product = '';
      obj.length = '';
      obj.variety = '';
      obj.grade = '';
      obj.searchText = '';

      syncSelectizeValue(obj.productSelectize, '');
      syncSelectizeValue(obj.lengthSelectize, '');
      syncSelectizeValue(obj.varietySelectize, '');
      syncSelectizeValue(obj.gradesSelectize, '');

      if (obj.hasLoadedRecommendations) {
        updateAvailableFilterOptions();
        updateViewState(filterForecastItems(obj.recommendationItems));
      }
    };

    obj.hasServiceEmptyState = function () {
      return obj.hasLoadedRecommendations && !obj.recommendationItems.length;
    };

    obj.hasFilteredEmptyState = function () {
      return obj.hasLoadedRecommendations && obj.recommendationItems.length > 0 && !obj.filteredItems.length;
    };

    obj.getRecommendations = function () {
      var growerCompanyName = getLoggedGrowerCompanyName();

      if (!growerCompanyName) {
        return alertify.error('Unable to determine the logged grower.');
      }

      obj.showDateValidation = true;

      if (!obj.fromWeek) {
        return alertify.error('Please select a Monday in Start Week before getting recommendations.');
      }

      if (!obj.toWeek) {
        return alertify.error('Please select a Monday in End Week before getting recommendations.');
      }

      if (formatWeekStartDate(obj.toWeek) < formatWeekStartDate(obj.fromWeek)) {
        return alertify.error('End Week cannot be earlier than Start Week.');
      }

      obj.hasRequestedRecommendations = true;
      obj.isLoadingRecommendations = true;

      growerSrv.getInventoryRecommendationForecast(growerCompanyName, formatWeekStartDate(obj.fromWeek), formatWeekStartDate(obj.toWeek)).then(function (items) {
        handleRecommendationData(items);
        if (!obj.recommendationItems.length) {
          alertify.log('No recommendations available for this grower.');
        }
      }).catch(function (error) {
        resetRecommendationState();
        alertify.error(error && error.message || 'Error loading inventory recommendation.');
      }).finally(function () {
        obj.isLoadingRecommendations = false;
        $scope.$applyAsync();
      });
    };

    obj.download = function () {
      var csvContent;

      if (!obj.hasLoadedRecommendations || !obj.filteredItems.length) {
        return alertify.error('Load recommendations first to enable the download.');
      }

      obj.isDownloading = true;

      try {
        csvContent = serializeCsv(obj.filteredItems, obj.tableColumns);
        if (!angular.isString(csvContent) || !csvContent.length) {
          throw new Error('Unable to generate the CSV file.');
        }

        downloadCsv(csvContent, buildFileName());
        alertify.success('Download successful.');
      } catch (error) {
        alertify.error(error && error.message || 'Error downloading inventory recommendation.');
      } finally {
        obj.isDownloading = false;
      }
    };

    obj.formatCellValue = function (value) {
      return formatCellValue(value);
    };

    obj.openFromWeek = function () {
      obj.fromWeekPopup.opened = true;
    };

    obj.openToWeek = function () {
      obj.toWeekPopup.opened = true;
    };

    obj.onWeekRangeChange = function () {
      if (obj.fromWeek && (!obj.toWeek || formatWeekStartDate(obj.toWeek) <= formatWeekStartDate(obj.fromWeek))) {
        obj.toWeek = getNextMonday(obj.fromWeek);
      }
    };

    obj.productConfig = {
      create: false,
      highlight: true,
      valueField: 'value',
      labelField: 'label',
      delimiter: '|',
      searchField: ['label'],
      placeholder: 'Select Product Group',
      maxItems: 1,
      render: {
        option: function option(data, escape) {
          return '<div class="option"><span class="title">' + escape(data.label) + '</span></div>';
        },
        item: function item(data, escape) {
          return '<div class="item"><span class="item">' + escape(data.label) + '</span></div>';
        }
      },
      onChange: function onChange(value) {
        handleSelectizeChange('product', value);
      },
      onInitialize: function onInitialize(selectize) {
        obj.productSelectize = selectize;
      }
    };

    obj.varietyConfig = {
      create: false,
      highlight: true,
      valueField: 'value',
      labelField: 'label',
      delimiter: '|',
      searchField: ['label'],
      placeholder: 'Select Variety',
      maxItems: 1,
      render: {
        option: function option(data, escape) {
          return '<div class="option"><span class="title">' + escape(data.label) + '</span></div>';
        },
        item: function item(data, escape) {
          return '<div class="item"><span class="item">' + escape(data.label) + '</span></div>';
        }
      },
      onChange: function onChange(value) {
        handleSelectizeChange('variety', value);
      },
      onInitialize: function onInitialize(selectize) {
        obj.varietySelectize = selectize;
      }
    };

    obj.lengthConfig = {
      create: false,
      highlight: true,
      valueField: 'value',
      labelField: 'label',
      delimiter: '|',
      searchField: ['label'],
      placeholder: 'Select Length',
      maxItems: 1,
      render: {
        option: function option(data, escape) {
          return '<div class="option"><span class="title">' + escape(data.label) + '</span></div>';
        },
        item: function item(data, escape) {
          return '<div class="item"><span class="item">' + escape(data.label) + '</span></div>';
        }
      },
      onChange: function onChange(value) {
        handleSelectizeChange('length', value);
      },
      onInitialize: function onInitialize(selectize) {
        obj.lengthSelectize = selectize;
      }
    };

    obj.gradeConfig = {
      create: false,
      highlight: true,
      valueField: 'value',
      labelField: 'label',
      delimiter: '|',
      searchField: ['label'],
      placeholder: 'Select Grade',
      maxItems: 1,
      render: {
        option: function option(data, escape) {
          return '<div class="option"><span class="title">' + escape(data.label) + '</span></div>';
        },
        item: function item(data, escape) {
          return '<div class="item"><span class="item">' + escape(data.label) + '</span></div>';
        }
      },
      onChange: function onChange(value) {
        handleSelectizeChange('grade', value);
      },
      onInitialize: function onInitialize(selectize) {
        obj.gradesSelectize = selectize;
      }
    };

    init();
  }
})(angular);
//# sourceMappingURL=growerInventoryRecommendationCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('growerInventoryCopyDelAssistantCtrl', ['$scope', 'alertify', 'commonSrv', growerInventoryCopyDelAssistantCtrl]);

  function growerInventoryCopyDelAssistantCtrl($scope, alertify, commonSrv) {

    var obj = this,
        common = commonSrv;
    obj.copyInventory = true;
    obj.deleteInventory = false;
  }
})(angular);
//# sourceMappingURL=growerInventoryCopyDelAssistantCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('growerStandingOrdersCtrl', ['$scope', 'alertify', '$state', '$stateParams', 'commonSrv', 'sessionSrv', 'floristSrv', growerStandingOrdersCtrl]);

  function growerStandingOrdersCtrl($scope, alertify, $state, $stateParams, commonSrv, sessionSrv, floristSrv) {

    var content = this,
        common = commonSrv,
        fs = floristSrv;

    content.isCurrent = function (name) {
      return $state.is('grower.standingorders.' + name);
    };

    function init() {}

    init();
  }
})(angular);
//# sourceMappingURL=growerStandingOrdersCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('standingOrderDetailCtrl', ['alertify', 'commonSrv', '$uibModalInstance', 'config', 'floristSrv', standingOrderDetailCtrl]);

  function standingOrderDetailCtrl(alertify, commonSrv, $uibModalInstance, config, floristSrv) {
    var obj = this,
        common = commonSrv,
        fs = floristSrv;

    function init() {
      obj.items = config.items;
      obj.order = config.order;
      if (obj.order.status == 'canceled' || obj.order.status == 'rejected') {
        obj.getReasons();
      }
    }

    /******************************************
    * Get the reject reasons
    */

    obj.getReasons = function () {

      fs.getRejectReasons(function (data) {
        obj.reasons = data;
        obj.reasonsMap = common.toMap(obj.reasons, 'reasonMap', '_KEY');
      }, function (error) {
        alertify.error(error);
      });
    };

    obj.ok = function () {
      $uibModalInstance.close(true);
    };

    init();
  }
})(angular);
//# sourceMappingURL=standingOrderDetailCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('growerStandingOrdersPendingCtrl', ['$scope', 'alertify', '$state', '$stateParams', 'commonSrv', 'sessionSrv', 'floristSrv', '$uibModal', growerStandingOrdersPendingCtrl]).controller('rejectOrderCtrl', ['alertify', 'commonSrv', '$uibModalInstance', 'config', 'floristSrv', rejectOrderCtrl]);

  function growerStandingOrdersPendingCtrl($scope, alertify, $state, $stateParams, commonSrv, sessionSrv, floristSrv, $uibModal) {

    var obj = this,
        common = commonSrv,
        fs = floristSrv;

    function init() {
      obj.getOrders();
      obj.getReasons();
    }
    /******************************************
     * Get the standing order for the grower
     */
    obj.getOrders = function () {

      fs.getStandingOrders('pending', function (data) {
        obj.orders = data.orders;
        obj.order_items = data.collection;
        obj.map = data.map;
      }, function (error) {
        alertify.error(error);
      });
    };
    /******************************************
     * Get the reject reasons
     */

    obj.getReasons = function () {

      fs.getRejectReasons(function (data) {

        obj.reasons = data;
      }, function (error) {
        alertify.error(error);
      });
    };

    /******************************************
     * Reject the standing order
     */
    obj.rejectOrder = function (order) {

      var info = {
        customer: order.cart_box.customer,
        grower: common.getUserData().grower_name,
        msg: 'reject',
        key: order._KEY,
        reasons: obj.reasons,
        order_number: order.consecutive
      };
      console.log(obj);
      var modalInstance = $uibModal.open({
        templateUrl: 'views/grower/grower.standingorders.rejectModal.html',
        controller: 'rejectOrderCtrl',
        controllerAs: 'obj',
        size: 'md',
        resolve: {
          config: info
        }
      });

      modalInstance.result.then(function (data) {
        obj.getOrders();
      });
    };
    /******************************************
     * order detail modal
     */
    obj.detail = function (order) {

      console.log(order);
      var detailInstance = $uibModal.open({
        templateUrl: 'views/grower/standingorders.detail.html',
        controller: 'standingOrderDetailCtrl',
        controllerAs: 'obj',
        size: 'lg',
        resolve: {
          config: {
            order: order,
            items: obj.order_items[order.cart_box._KEY]
          }
        }
      });

      detailInstance.result.then(function (data) {});
    };
    /******************************************
     * Approve the standing order
     */
    obj.approveOrder = function (order) {

      fs.updateOrderStatus(order._KEY, 'confirmed', null, function () {

        var customer_claim = {
          'subject': 'Hi ' + common.getUserData().grower_name + ' has responded to your request for a standing order via iBuyFlowers.com',
          'to': 'bcc@ibuyflowers.com',
          // "to": order.customer.office_email,
          'domain': common.actual_domain,
          'from': 'info@ibuyflowers.com',
          'template_key': common.standing_order_response,
          'data': {
            'customer': order.cart_box.customer.company_name,
            'grower': common.getUserData().grower_name,
            'consecutive': order.consecutive,
            'status': 'Confirmed'
          }

        };
        common.method.send_mail(customer_claim).then(function (res) {
          if (res.success) {
            alertify.success('Standing Order Approved.');
            obj.getOrders();
            console.log('Standing order response email sent !!!');
          }
        });
      }, function (error) {
        alertify.error(error);
      });
    };

    init();
  }

  function rejectOrderCtrl(alertify, commonSrv, $uibModalInstance, config, floristSrv) {
    var obj = this,
        common = commonSrv,
        fs = floristSrv;

    function init() {

      obj.reasons = config.reasons;
      obj.order_key = config.key;
      obj.msg = config.msg;
      obj.customer = config.customer;
      obj.grower = config.grower;
      obj.order_number = config.order_number;
    }

    obj.cancel = function (action) {
      if (action == 'close') {
        $uibModalInstance.close(false);
      } else {
        $uibModalInstance.dismiss(action);
      }
    };

    obj.save = function () {

      fs.updateOrderStatus(obj.order_key, 'rejected', obj.reason._KEY, function () {

        var customer_claim = {
          'subject': 'Hi ' + obj.grower + ' has responded to your request for a standing order via iBuyFlowers.com',
          'to': 'bcc@ibuyflowers.com',
          // "to": obj.customer.office_email,
          'domain': common.actual_domain,
          'from': 'info@ibuyflowers.com',
          'template_key': common.standing_order_response,
          'data': {
            'customer': obj.customer.company_name,
            'grower': obj.grower,
            'consecutive': obj.order_number,
            'status': 'Rejected',
            'reason': obj.reason.reason
          }

        };
        common.method.send_mail(customer_claim).then(function (res) {
          if (res.success) {
            $uibModalInstance.close(true);
            console.log('Standing order response email sent !!!');
          }
        });
      }, function (error) {
        alertify.error(error);
      });
    };

    init();
  }
})(angular);
//# sourceMappingURL=growerStandingOrdersPendingCtrl.js.map

'use strict';

(function (angular) {
	angular.module('ibf').controller('growerStandingOrdersConfirmedCtrl', ['$scope', 'alertify', '$state', '$stateParams', 'commonSrv', 'sessionSrv', 'floristSrv', '$uibModal', growerStandingOrdersConfirmedCtrl]).controller('rejectConfirmedOrderCtrl', ['alertify', 'commonSrv', '$uibModalInstance', 'config', 'floristSrv', rejectConfirmedOrderCtrl]);

	function growerStandingOrdersConfirmedCtrl($scope, alertify, $state, $stateParams, commonSrv, sessionSrv, floristSrv, $uibModal) {
		var obj = this,
		    common = commonSrv,
		    fs = floristSrv;

		function init() {
			obj.getOrders();
		}

		/******************************************
     * Get the standing order for the grower
     */
		obj.getOrders = function () {
			fs.getStandingOrders('confirmed', function (data) {
				obj.orders = data.orders;
				obj.order_items = data.collection;
			}, function (error) {
				alertify.error(error);
			});
		};
		/******************************************
   * Get the reject reasons
  */

		obj.getReasons = function () {

			fs.getRejectReasons(function (data) {

				obj.reasons = data;
			}, function (error) {
				alertify.error(error);
			});
		};
		/******************************************
   * order detail modal
   */
		obj.detail = function (order) {

			console.log(order);
			var detailInstance = $uibModal.open({
				templateUrl: 'views/grower/standingorders.detail.html',
				controller: 'standingOrderDetailCtrl',
				controllerAs: 'obj',
				size: 'lg',
				resolve: {
					config: {
						order: order,
						items: obj.order_items[order.cart_box._KEY]
					}
				}
			});

			detailInstance.result.then(function (data) {});
		};
		/******************************************
   * Reject the standing order
   */
		obj.rejectOrder = function (order) {

			var info = {
				customer: order.customer,
				grower: common.getUserData().grower_name,
				msg: 'canceled',
				key: order._KEY,
				reasons: obj.reasons,
				order_number: order.consecutive
			};
			console.log(obj);
			var modalInstance = $uibModal.open({
				templateUrl: 'views/grower/grower.standingorders.rejectModal.html',
				controller: 'rejectConfirmedOrderCtrl',
				controllerAs: 'obj',
				size: 'md',
				resolve: {
					config: info
				}
			});

			modalInstance.result.then(function (data) {
				obj.getOrders();
			});
		};

		init();
	}

	function rejectConfirmedOrderCtrl(alertify, commonSrv, $uibModalInstance, config, floristSrv) {
		var obj = this,
		    common = commonSrv,
		    fs = floristSrv;

		function init() {
			obj.reasons = config.reasons;
			obj.order_key = config.key;
			obj.msg = config.msg;
			obj.customer = config.customer;
			obj.grower = config.grower;
			obj.order_number = config.order_number;
		}

		obj.cancel = function (action) {
			if (action == 'close') {
				$uibModalInstance.close(false);
			} else {
				$uibModalInstance.dismiss(action);
			}
		};

		obj.save = function () {

			fs.updateOrderStatus(obj.order_key, 'canceled', obj.reason._KEY, function () {
				var customer_claim = {
					'subject': 'Hi ' + obj.grower + ' has canceld your standing order via iBuyFlowers.com',
					'to': 'bcc@ibuyflowers.com',
					// "to": obj.customer.office_email,
					'domain': common.actual_domain,
					'from': 'info@ibuyflowers.com',
					'template_key': common.standing_order_response,
					'data': {
						'customer': obj.customer.company_name,
						'grower': obj.grower,
						'consecutive': obj.order_number,
						'status': 'Canceled',
						'reason': obj.reason.reason
					}

				};
				common.method.send_mail(customer_claim).then(function (res) {
					if (res.success) {
						$uibModalInstance.close(true);
						console.log('Standing order cancel response email sent !!!');
					}
				});
			}, function (error) {
				alertify.error(error);
			});
		};

		init();
	}
})(angular);
//# sourceMappingURL=growerStandingOrdersConfirmedCtrl.js.map

'use strict';

(function (angular) {
	angular.module('ibf').controller('growerStandingOrdersCanceledCtrl', ['$scope', 'alertify', '$state', '$stateParams', 'commonSrv', 'sessionSrv', 'floristSrv', '$uibModal', growerStandingOrdersCanceledCtrl]);

	function growerStandingOrdersCanceledCtrl($scope, alertify, $state, $stateParams, commonSrv, sessionSrv, floristSrv, $uibModal) {
		var obj = this,
		    common = commonSrv,
		    fs = floristSrv;

		function init() {
			obj.getOrders();
			obj.getReasons();
		}

		/******************************************
       * Get the standing order for the grower
       */
		obj.getOrders = function () {
			fs.getStandingOrders('canceled', function (data) {
				obj.orders = data.orders;
				obj.order_items = data.collection;
			}, function (error) {
				alertify.error(error);
			});
		};
		/******************************************
   * order detail modal
   */
		obj.detail = function (order) {

			console.log(order);
			var detailInstance = $uibModal.open({
				templateUrl: 'views/grower/standingorders.detail.html',
				controller: 'standingOrderDetailCtrl',
				controllerAs: 'obj',
				size: 'lg',
				resolve: {
					config: {
						order: order,
						items: obj.order_items[order.cart_box._KEY]
					}
				}
			});

			detailInstance.result.then(function (data) {});
		};

		/******************************************
     	* Get the reject reasons
     	*/

		obj.getReasons = function () {

			fs.getRejectReasons(function (data) {
				obj.reasons = data;
				obj.reasonsMap = common.toMap(obj.reasons, 'reasonMap', '_KEY');
			}, function (error) {
				alertify.error(error);
			});
		};

		init();
	}
})(angular);
//# sourceMappingURL=growerStandingOrdersCanceledCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('growerSetupCtrl', ['$scope', 'alertify', '$state', '$stateParams', 'commonSrv', 'sessionSrv', growerSetupCtrl]);

  function growerSetupCtrl($scope, alertify, $state, $stateParams, commonSrv, sessionSrv) {

    var content = this,
        common = commonSrv;

    function init() {}

    content.isCurrent = function (name) {
      return $state.is('grower.setup.' + name);
    };

    content.include = function (name) {
      return $state.includes('grower.setup.' + name);
    };

    init();
  }
})(angular);
//# sourceMappingURL=growerSetupCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('bulkDiscountCtrl', ['$scope', 'alertify', '$state', '$stateParams', 'commonSrv', 'growerSrv', '$filter', bulkDiscountCtrl]);

  function bulkDiscountCtrl($scope, alertify, $state, $stateParams, commonSrv, growerSrv, $filter) {
    var obj = this;
    obj.list = [];
    obj.product_groups = [];
    obj.totalItems = 0;
    obj.currentPage = 1;
    obj.itemsPerPage = 20;
    obj.pageItems = [];
    obj.isLoading = false;
    obj.searchText = '';

    function init() {
      obj.isLoading = true;
      growerSrv.getBulkDiscount(function (data) {
        if (data.success) {
          obj.product_groups = $filter('orderBy')(data.list, function (item) {
            return item.product_group.common_name;
          });
          obj.list = data.list.map(function (item) {
            item.percentage = parseFloat(item.percentage.toFixed(1));
            return item;
          });
          obj.totalItems = obj.list.length;
          obj.filterList();
        } else {
          alertify.error(data.message);
        }
        obj.isLoading = false;
      });
    }

    obj.change = function (item) {
      if (item.percentage < 0 || !item.percentage) {
        item.percentage = 0;
      }
      if (item.percentage > 100) {
        item.percentage = 100;
      }
      item.percentage = parseFloat(item.percentage.toFixed(1));
    };

    obj.clear_filters = function () {
      obj.searchText = '';
      obj.filterList();
    };

    obj.getPage = function () {
      var init = (obj.currentPage - 1) * obj.itemsPerPage;
      var end = obj.currentPage * obj.itemsPerPage;
      if (end > obj.totalItems) {
        end = obj.totalItems;
      }
      obj.pageItems = obj.list.slice(init, end);
    };

    obj.filterList = function () {
      if (obj.searchText) {
        obj.list = $filter('filter')(obj.product_groups, function (value) {
          var pg = value.product_group.common_name.toLowerCase();
          return pg.indexOf(obj.searchText.toLowerCase()) !== -1;
        });
      } else {
        obj.list = obj.product_groups.slice();
      }

      obj.totalItems = obj.list.length;
      obj.currentPage = 1;
      obj.getPage();
    };

    obj.getStatus = function (item) {
      if (item.status) {
        return 'Active';
      } else {
        return item._KEY ? 'Inactive' : 'No Created';
      }
    };

    function save(item, object) {
      var method = item._KEY ? 'update' : 'insert';
      if (method === 'update') {
        object._KEY = item._KEY;
      } else {
        object.product_group = item.product_group._KEY;
        object.grower = growerSrv.user.grower;
      }
      var query = commonSrv.sbx.insert('bulk_promo', object);
      return commonSrv.method[method](query).then(function (data) {
        if (data.success) {
          item._KEY = data.keys ? data.keys[0] : item._KEY;
        } else {
          alertify.error(data.message);
        }
        return data;
      });
    }

    obj.changeStatus = function (item) {
      obj.isLoading = true;
      var object = { status: !item.status };
      save(item, object).then(function (res) {
        if (res.success) {
          item.status = !item.status;
        }
        obj.isLoading = false;
      });
    };

    obj.changeBulk = function (item) {
      var object = { amount: item.amount, status: true, percentage: (item.percentage / 100).toFixed(3) };
      if (object.amount && object.percentage) {
        obj.isLoading = true;
        save(item, object).then(function (res) {
          if (res.success) {
            item.status = true;
            alertify.success('Discount set to ' + item.product_group.common_name + '.');
          }
          obj.isLoading = false;
        });
      } else {
        alertify.error('You must put the amount and a valid percentage for the promotion.');
      }
    };

    init();
  }
})(angular);
//# sourceMappingURL=growerBulkDiscount.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('growerSpecialsCtrl', ['$scope', 'alertify', '$state', '$stateParams', 'commonSrv', 'sessionSrv', 'growerSrv', '$filter', growerSpecialsCtrl]);

  function growerSpecialsCtrl($scope, alertify, $state, $stateParams, commonSrv, sessionSrv, growerSrv, $filter) {

    var obj = this,
        common = commonSrv,
        gs = growerSrv;
    obj.mlist = {};

    obj.totalItems = 0;
    obj.currentPage = 1;
    obj.itemsPerPage = 20;
    obj.pageItems = [];
    obj.isLoading = false;
    obj.searchText = '';
    obj.fromClick = false;

    function init() {
      obj.getMasterlists();
    }

    obj.getPage = function () {
      var init = (obj.currentPage - 1) * obj.itemsPerPage;
      var end = obj.currentPage * obj.itemsPerPage;
      if (end > obj.totalItems) {
        end = obj.totalItems;
      }
      obj.pageItems = obj.list.slice(init, end);
    };

    obj.clear_filters = function () {
      obj.fromClick = true;
      obj.list = obj.masterlist.slice();
      obj.varieties = obj.masterVarieties.slice();
      obj.product = null;
      obj.varietySelectize.setValue('');
      obj.productSelectize.setValue('');
      obj.searchText = '';
      obj.filterList();
    };

    obj.getMasterlists = function () {
      obj.isLoading = true;
      gs.getMasterlists(function (data) {
        obj.list = $filter('orderBy')(data, ['product_group.common_name', 'variety.variety_name']);

        obj.totalItems = obj.list.length;

        obj.masterlist = angular.copy(obj.list);
        obj.varietiesMap = {};
        obj.productsMap = {};
        obj.masterVarieties = [];
        obj.products = [];
        angular.forEach(obj.list, function (item) {
          if (!obj.varietiesMap[item.variety._KEY]) {
            obj.varietiesMap[item.variety._KEY] = item.variety;
            obj.masterVarieties.push(item.variety);
          }

          if (!obj.productsMap[item.product_group._KEY]) {
            obj.productsMap[item.product_group._KEY] = item.product_group;
            obj.products.push(item.product_group);
          }
        });

        obj.isLoading = false;
        obj.filterList();
      }, function (e) {
        obj.isLoading = false;
        alertify.error(e);
      });
    };
    //==================================================================================================
    obj.productConfig = {
      create: false,
      highlight: true,
      valueField: '_KEY',
      //labelField: 'common_name',
      delimiter: '|',
      searchField: ['common_name', 'category', 'botanical_name'],
      placeholder: 'Select Product Group',
      maxItems: 1,
      render: {
        option: function option(data, escape) {
          return '<div class="option">' + '<span class="title">' + escape(data.common_name) + '</span>' + '</div>';
        },
        item: function item(data, escape) {
          return '<div class="item">' + '<span class="item">' + escape(data.common_name) + '</span>' + '</div>';
        }
      },
      onChange: function onChange(value) {
        if (value) {
          obj.varieties = $filter('filter')(obj.masterVarieties, { product_group: value });
        }

        if (obj.variety) {
          obj.varietySelectize.setValue('');
        }

        obj.varietySelectize.refreshOptions(false);
        obj.filterList();
        if (!obj.fromClick) {
          $scope.$apply();
        }
        obj.fromClick = false;
      },
      onInitialize: function onInitialize(selectize) {
        // receives the selectize object as an argument
        obj.productSelectize = selectize;
      }
    };

    //==================================================================================================
    obj.varietyConfig = {
      create: false,
      highlight: true,
      valueField: '_KEY',
      delimiter: '|',
      searchField: ['variety_name'],
      placeholder: 'Select Variety',
      maxItems: 1,
      render: {
        option: function option(data, escape) {
          return '<div class="option">' + '<span class="title">' + escape(data.variety_name) + ' (' + escape(data.color.color_name) + ')' + '</span>' + '</div>';
        },
        item: function item(data, escape) {
          return '<div class="item">' + '<span class="item">' + escape(data.variety_name) + ' (' + escape(data.color.color_name) + ')' + '</span>' + '</div>';
        }
      },
      onChange: function onChange(value) {
        obj.filterList();
        if (!obj.fromClick) {
          $scope.$apply();
        }
        obj.fromClick = false;
      },
      onInitialize: function onInitialize(selectize) {
        // receives the selectize object as an argument
        obj.varietySelectize = selectize;
      }
    };

    obj.filterList = function () {
      if (obj.searchText || obj.product || obj.variety) {
        obj.list = $filter('filter')(obj.masterlist, function (value) {
          var pg = value.product_group.common_name.toLowerCase();
          var v = value.variety.variety_name.toLowerCase();

          var condition = true;

          if (obj.product) {
            condition = value.product_group._KEY === obj.product;
          }

          if (obj.variety) {
            condition = value.variety._KEY === obj.variety;
          }

          return (pg.indexOf(obj.searchText.toLowerCase()) !== -1 || v.indexOf(obj.searchText.toLowerCase()) !== -1) && condition;
        });
      } else {
        obj.list = obj.masterlist.slice();
      }

      obj.totalItems = obj.list.length;
      obj.currentPage = 1;
      obj.getPage();
    };

    //==================================================================================================
    obj.setSpecial = function (item) {
      var mark = item.special ? false : true;
      obj.mlist[item._KEY] = true;
      item.special = mark;
      gs.markSpecial(item._KEY, mark, function () {
        obj.mlist[item._KEY] = false;
      }, function (e) {
        alertify.error(e);
      });
    };
    //==================================================================================================
    obj.uncheckAll = function () {
      var list = [];
      for (var i = 0; i < obj.list.length; i++) {
        if (obj.list[i].special) {
          list.push({
            _KEY: obj.list[i]._KEY,
            special: false
          });
        }
      }
      gs.unMarkAll(list, function () {
        obj.getMasterlists();
        alertify.success('Masterlists Unchecked');
      }, function (e) {
        alertify.error(e);
      });
    };
    //==================================================================================================

    init();
  }
})(angular);
//# sourceMappingURL=growerSpecialsCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('growerCompanyInfoCtrl', ['$scope', 'alertify', 'commonSrv', 'growerSrv', 'FileUploader', '$timeout', '$state', growerCompanyInfoCtrl]);

  function growerCompanyInfoCtrl($scope, alertify, commonSrv, growerSrv, FileUploader, $timeout, $state) {
    var obj = this,
        common = commonSrv;
    obj.uploader = new FileUploader();
    obj.target_folder = null;
    obj.isEdit = false;
    obj.disable = true;
    obj.isLoading = false;
    obj.days = {
      monday: 1,
      tuesday: 2,
      wednesday: 3,
      thursday: 4,
      friday: 5,
      saturday: 6,
      sunday: 7
    };

    obj.shipping = {
      monday: false,
      tuesday: false,
      wednesday: false,
      thursday: false,
      friday: false,
      saturday: false,
      sunday: false
    };

    function init() {
      var random = new Date().toString();
      obj.thumbnail = {
        dataUrl: common.actual_base_url + '/growers/' + common.getUserData().grower + '/logo.png' + '?cb=' + random
      };
      obj.folderList();
      obj.getTimeZoneList();
      obj.getCompanyInfo();
      obj.getCities();
      obj.getGrowerPreferences();
      obj.showCompanyName = false;
      obj.showStreet = false;
      obj.showCity = false;
      obj.showCountry = false;
      obj.showVat = false;
      obj.showPhone = false;
      obj.showSite = false;
      obj.showEmail = false;
    }

    // obj.enable = function(name){
    //   switch(name){
    //     case 'company_name':
    //       obj.showCompanyName = obj.showCompanyName ? false : true;
    //     break;
    //     case 'street':
    //       obj.showStreet = obj.showStreet ? false : true;
    //     break;
    //     case 'city':
    //       obj.showCity = obj.showCity ? false : true;
    //     break;
    //     case 'country':
    //       obj.showCountry = obj.showCountry ? false : true;
    //     break;
    //     case 'vat_number':
    //       obj.showVat = obj.showVat ? false : true;
    //     break;
    //     case 'website':
    //       obj.showSite = obj.showSite ? false : true;
    //     break;
    //     case 'phone':
    //       obj.showPhone = obj.showPhone ? false : true;
    //     break;
    //     case 'email':
    //       obj.showEmail = obj.showEmail ? false : true;
    //     break;

    //   }
    // }

    obj.updateInfo = function (name) {
      obj.infoUpdate = angular.copy(obj.info);
      obj.infoUpdate.country = obj.info.country._KEY;

      var query = {
        'domain': common.actual_domain,
        'row_model': 'grower',
        'rows': [obj.infoUpdate]
      };
      delete query.rows[0]._META;
      common.method.query(common.urls.update, query).then(function () {

        var response = common.response.post_query.data;
        if (response.success) {
          alertify.success('Company Info updated');
          obj.enable(name);
        } else {
          alertify.error(response.error);
        }
      });
    };

    //============= FILE UPLOADER CONFIG ===============

    obj.folderList = function () {
      var params = { key: common.growers_folder_key };
      common.method.get(common.urls.folderList, params).then(function () {
        var grower_key = common.getUserData().grower;
        var response = common.response.get.data;

        if (response.success) {
          angular.forEach(response.contents, function (item) {
            if (item.name == grower_key) {
              obj.target_folder = item.key_id;
              return;
            }
          });
        }
      });
    };

    $scope.fileReaderSupported = window.FileReader != null;
    $scope.photoChanged = function (files) {

      if (files != null) {
        var file = files[0];
        if ($scope.fileReaderSupported && file.type.indexOf('image') > -1) {
          $timeout(function () {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
              $timeout(function () {
                obj.thumbnail.dataUrl = e.target.result;
                obj.uploadImage();
              });
            };
          });
        }
      }
    };

    obj.uploadImage = function () {

      obj.uploader.queue[0].url = common.urls.api + common.urls.uploadFile;
      obj.uploader.queue[0].headers = common.getHeaders();
      obj.uploader.queue[0].formData = [{ model: JSON.stringify({ key: obj.target_folder }) }];
      var name = obj.uploader.queue[0].file.name.split('.'),
          ext = name[name.length - 1];
      obj.uploader.queue[0].file.name = 'logo.png';
      obj.uploader.queue[0].upload();
    };

    obj.uploader.onSuccessItem = function (item, response, status, headers) {}
    //init();


    //==================================================

    ;obj.getCities = function () {
      common.listCities(function (data) {
        obj.citiesMap = common.toMap(data, 'citiesMap', '_KEY');
        obj.cities = data;
      }, function (error) {
        alertify.error(error);
      });
    };
    obj.setAdvance = function () {
      console.log(obj.info.city);
      obj.city_name = obj.info.city.name;
      obj.days_in_advance = obj.info.city.days_in_advance;
    };

    obj.getTimeZoneList = function () {
      var query = {
        'domain': common.actual_domain,
        'page': 1,
        'row_model': 'time_zone',
        'size': 1000
      };

      common.method.query(common.urls.find, query).then(function () {
        var response = common.response.post_query;
        obj.timeZones = response.data.results;
        obj.timezoneMap = common.toMap(obj.timeZones, 'timezoneMap', '_KEY');
      });
    };

    obj.getCompanyInfo = function () {
      var grower_key = common.getUserData().grower;
      // console.log("grower_key", grower_key);
      var query = {
        'domain': common.actual_domain,
        'page': 1,
        'row_model': 'grower',
        'fetch': ['country'],
        'where': {
          'keys': [grower_key]
        },
        'size': 1000
      };

      common.method.query(common.urls.find, query).then(function () {

        var response = common.response.post_query;
        obj.info = response.data.results[0];
        if (response.data.fetched_results) {
          var fetched = response.data.fetched_results;
          // obj.country = fetched.country[obj.info.country].country;
          obj.countryUpdate = obj.info.country;
          obj.timeSelect = obj.info.time_zone;
          obj.info.country = fetched.country[obj.info.country];
        }

        obj.shippingDayByCountry(obj.info.country._KEY);
        // console.log("company-info", obj.info);
      });
    };

    obj.getGrowerPreferences = function () {
      // var grower_key = common.getUserData().grower;
      // // var query ={
      // //   'domain': common.actual_domain,
      // //   'page': 1,
      // //   'row_model': 'grower_preference',
      // //   'where' : [{
      // //     'ANDOR': 'AND',
      // //     'GROUP': [{
      // //       'ANDOR': 'AND',
      // //       'FIELD': 'grower',
      // //       'OP': '=',
      // //       'VAL': grower_key,
      // //     }]
      // //   }],
      // //
      // //   'size': 1000
      // // }
      //
      // let query = common.sbx.with('grower_preference')
      //   .setPage(1)
      //   .andWhereIsEqual('grower', grower_key)
      //   .setPageSize(1000)
      //   .compile();
      // console.log("query", query)
      // common.method.query(common.urls.find, query).then(function(){
      //   var response = common.response.post_query;
      //   console.log("response", response)
      //   if(response.data.success){
      //     obj.growerPreference = response.data.results[0];
      //     if(obj.growerPreference){
      //       obj.disable = false;
      //     }
      //     // console.log("grower_preferences", obj.growerPreference);
      //   }else{
      //     alertify.error('Oops, there was an error!');
      //   }
      // });
    };

    obj.changeTimeZone = function (arg) {
      var grower_key = common.getUserData().grower;
      var data = {
        _KEY: grower_key,
        time_zone: arg
      };

      var query = {
        domain: common.actual_domain,
        row_model: 'grower',
        rows: [data]
      };

      common.method.query(common.urls.update, query).then(function () {
        var response = common.response.post_query.data;
        if (response.success) {
          alertify.success('Time zone updated');
        } else {
          alertify.error('Oops');
        }
      });
    };

    obj.shippingDayChange = function (arg, value) {
      var data = {
        _KEY: obj.growerPreference._KEY
      };

      switch (value) {
        case 1:
          data.shipping_monday = arg;
          break;
        case 2:
          data.shipping_tuesday = arg;
          break;
        case 3:
          data.shipping_wednesday = arg;
          break;
        case 4:
          data.shipping_thursday = arg;
          break;
        case 5:
          data.shipping_friday = arg;
          break;
        case 6:
          data.shipping_saturday = arg;
          break;
        default:
          data.shipping_sunday = arg;
      }

      var query = {
        domain: common.actual_domain,
        row_model: 'grower_preference',
        rows: [data]
      };

      common.method.query(common.urls.update, query).then(function () {
        var response = common.response.post_query.data;
        if (response.success) {
          alertify.success('Shipping day updated');
        } else {
          alertify.error('Oops');
        }
      });
    };

    obj.shippingDayByCountry = function (countryKey) {
      var query = {
        'domain': common.actual_domain,
        'page': 1,
        'row_model': 'shipping_day',
        'where': [{
          'ANDOR': 'AND',
          'GROUP': [{
            'ANDOR': 'AND',
            'FIELD': 'country',
            'OP': '=',
            'VAL': countryKey
          }]
        }],
        'size': 1000
      };

      common.method.query(common.urls.find, query).then(function () {
        var response = common.response.post_query.data.results;

        if (response.length > 0) {
          angular.forEach(response, function (item) {
            switch (item.shipping_day) {
              case 'monday':
                obj.shipping.monday = true;
                break;
              case 'tuesday':
                obj.shipping.tuesday = true;
                break;
              case 'wednesday':
                obj.shipping.wednesday = true;
                break;
              case 'thursday':
                obj.shipping.thursday = true;
                break;
              case 'friday':
                obj.shipping.friday = true;
                break;
              case 'saturday':
                obj.shipping.saturday = true;
                break;
              default:
                obj.shipping.sunday = true;
            }
          });
        } else {
          alertify.log('No shipping preference for this country');
        }
      });
    };

    common.listCountries(function (data) {
      obj.countries = data.countries;
    }, function (err) {});

    obj.edit_info = function () {

      obj.isEdit = true;
    };

    obj.cancel_edit = function () {
      obj.isEdit = false;
    };

    obj.save = function () {

      obj.isLoading = true;
      var grower_key = common.getUserData().grower;
      var data = {
        _KEY: grower_key,
        time_zone: obj.timeSelect,
        company_name: obj.info.company_name,
        street: obj.info.street,
        phone_number: obj.info.phone_number,
        vat_number: obj.info.vat_number,
        website: obj.info.website,
        email_address: obj.info.email_address,
        city_ref: obj.info.city._KEY,
        city: obj.city_name,
        days_in_advance: obj.days_in_advance,
        country: obj.info.country._KEY
      };

      var query = {
        domain: common.actual_domain,
        row_model: 'grower',
        rows: [data]
      };

      common.method.query(common.urls.update, query).then(function () {
        obj.isLoading = true;

        var res = common.response.post_query.data;
        if (res.success) {
          alertify.success('Info updated.');
          $state.reload();
        } else {
          alertify.error(res.error);
        }
      });
    };

    init();
  }
})(angular);
//# sourceMappingURL=growerCompanyInfoCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('growerUsersCtrl', ['$scope', 'alertify', 'commonSrv', '$uibModal', growerUsersCtrl]);

  function growerUsersCtrl($scope, alertify, commonSrv, $uibModal) {
    var obj = this,
        common = commonSrv;

    function init() {
      obj.loadUsers();
      obj.grower_admin = common.getUserData().grower_admin;
      obj.fromCountryManager = common.getUserData().fromCountryManager;

      if (obj.grower_admin == common.getUserData().data.id) {
        obj.isAdmin = true;
      }
    }

    obj.loadUsers = function () {

      var query = {
        'domain': common.actual_domain,
        'page': 1,
        'row_model': 'grower_user_config',
        'fetch': ['user'],
        'size': 1000,
        'where': [{
          'ANDOR': 'AND',
          'GROUP': [{
            'ANDOR': 'AND',
            'FIELD': 'user.grower',
            'OP': '=',
            'VAL': common.getUserData().grower
          }]
        }]
      };

      common.method.query(common.urls.find, query).then(function () {
        var response = common.response.post_query.data;

        if (response.success) {
          var fetched_results = response.fetched_results;

          angular.forEach(response.results, function (item) {
            item.user = fetched_results.user[item.user];
            item.user.isAdmin = item.user.user_id == obj.grower_admin;
          });

          obj.users = response.results;
        } else {
          alertify.error('Internal error loading users');
        }
      });
    };

    obj.edit_user = function (item) {

      var modalInstance = $uibModal.open({
        templateUrl: 'views/grower/add-user.html',
        controller: 'growerManageUsersCtrl',
        controllerAs: 'modal',
        bindToController: true,
        backdrop: 'static',
        keyboard: false,
        size: 'lg',
        resolve: {
          data: function data() {
            return {
              config: item,
              grower: common.getUserData().grower
            };
          }
        }
      });
      modalInstance.result.then(function (data) {
        obj.loadUsers();
      });
    };

    obj.add_user = function () {

      var modalInstance = $uibModal.open({
        templateUrl: 'views/grower/add-user.html',
        controller: 'growerManageUsersCtrl',
        controllerAs: 'modal',
        bindToController: true,
        backdrop: 'static',
        keyboard: false,
        size: 'lg',
        resolve: {
          data: function data() {
            return {
              user: null,
              grower: common.getUserData().grower
            };
          }
        }
      });
      modalInstance.result.then(function (data) {
        obj.loadUsers();
      });
    };

    obj.delete_user = function (item) {

      common.confirmModal({
        title: 'Delete User',
        msj: 'Are you sure yo want to continue?',
        saveText: 'Delete User',
        cancelText: 'Cancel'
      }, function () {
        deleteConfig(item);
      });
    };

    function deleteConfig(item) {

      var query = {
        domain: common.actual_domain,
        page: 1,
        row_model: 'grower_user_config',
        where: {
          keys: [item._KEY]
        }
      };

      common.method.query(common.urls.delete, query).then(function () {

        var response = common.response.post_query.data;

        if (response.success) {
          deleteUser(item.user);
        }
      });
    }
    function deleteUser(user) {

      var query = {
        domain: common.actual_domain,
        page: 1,
        row_model: 'user',
        where: {
          keys: [user._KEY]
        }
      };

      common.method.query(common.urls.delete, query).then(function () {

        var response = common.response.post_query.data;

        if (response.success) {
          obj.loadUsers();
          alertify.success('User Deleted');
        }
      });
    }

    init();
  }
})(angular);
//# sourceMappingURL=growerUsersCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('growerModalUpdate', ['$rootScope', '$scope', 'alertify', 'commonSrv', '$uibModalInstance', 'growerSrv', 'data', growerModalUpdate]);

  function growerModalUpdate($rootScope, $scope, alertify, commonSrv, $uibModalInstance, growerSrv, data) {

    var obj = this,
        common = commonSrv,
        gr = growerSrv;

    function init() {
      obj.params = data.params;
      obj.hasSpecial = data.params.changes[0].hasOwnProperty('special');
      obj.hasPhoto = data.params.changes[0].hasOwnProperty('photo');
    }

    obj.close = function () {
      $uibModalInstance.dismiss('close');
    };

    obj.import = function () {
      // console.log(obj.params);
      $uibModalInstance.close();
    };

    init();
  }
})(angular);
//# sourceMappingURL=growerModalUpdate.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('growerInventoryUpdated', ['$rootScope', '$scope', 'alertify', 'commonSrv', '$uibModalInstance', 'growerSrv', 'data', growerInventoryUpdated]);

  function growerInventoryUpdated($rootScope, $scope, alertify, commonSrv, $uibModalInstance, growerSrv, data) {

    var obj = this,
        common = commonSrv,
        gr = growerSrv;

    function init() {
      console.log(data);
      obj.totalChange = data.totalChangesNotFound;
      obj.notChange = data.changesNotFound.join(', ');
      obj.totalNew = data.totalNew;
      obj.totalUpdate = data.totalUpdate;
    }

    obj.close = function () {
      $uibModalInstance.close();
    };
    obj.import = function () {

      $uibModalInstance.close();
    };
    init();
  }
})(angular);
//# sourceMappingURL=growerInventoryUpdated.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('growerOrderEditModalCtrl', ['$scope', '$uibModalInstance', 'config', 'alertify', function ($scope, $uibModalInstance, config, alertify) {
    var modal = this;

    // Inicialización de datos del modal
    modal.saving = false;
    modal.cartbox = config.cartbox;
    modal.item = config.item;
    // Opciones solo lectura para mostrar UoM (stem/bunch)
    modal.uomOptions = config.uomOptions || [];
    // Opciones válidas para editar stems per bunch (desde tabla stems_per_bunch)
    modal.stemsOptions = config.spbOptions || [];
    modal.form = {
      quantity: config.item && config.item.quantity ? config.item.quantity : 1,
      // usar la key actual de stems_per_bunch o la primera disponible de la lista
      stems_per_bunch: config.initialSpbKey || modal.stemsOptions[0] && modal.stemsOptions[0]._KEY || null
    };

    // Cerrar modal sin guardar
    modal.close = function () {
      $uibModalInstance.dismiss('cancel');
    };

    // Guardar cambios
    modal.save = function (form) {
      if (!form || !form.$valid || modal.saving) return;

      modal.saving = true;

      var payload = {
        cartbox: modal.cartbox,
        item: modal.item,
        quantity: parseInt(modal.form.quantity, 10),
        stems_per_bunch: modal.form.stems_per_bunch
      };

      // onUpdate es provisto desde el controlador padre via resolve
      config.onUpdate(payload).then(function () {
        $uibModalInstance.close('ok');
        modal.saving = false;
      }).catch(function (err) {
        try {
          // console.log('alertify', alertify)
          alertify.error(err && err.message ? err.message : 'Error updating');
          modal.saving = false;
        } catch (e) {}
      }).finally(function () {
        modal.saving = false;
      });
    };
  }]);
})(angular);
//# sourceMappingURL=growerOrderEditModalCtrl.js.map

'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function (angular) {
  angular.module('ibf').controller('growerMasterlistCtrl', ['$scope', 'alertify', 'commonSrv', 'productSrv', '$state', '$filter', '$uibModal', 'filterSrv', '$timeout', growerMasterlistCtrl]);

  function growerMasterlistCtrl($scope, alertify, commonSrv, productSrv, $state, $filter, $uibModal, filterSrv, $timeout) {
    var obj = this,
        common = commonSrv,
        ps = productSrv,
        fs = filterSrv;
    obj.growerKey = '';
    obj.totalItems = 0;
    obj.currentPage = 1;
    obj.itemsPerPage = 20;
    obj.list = [];
    obj.pageItems = [];
    obj.length_list = [];
    obj.fetched_results = {};
    obj.isLoading = false;
    obj.fromClick = false;
    obj.showInactive = true;
    obj.searchText = '';
    obj.masterlist = [];
    obj.showMasterlistTab = false;
    obj.disabledStatusAction = true;
    obj.products = [];

    obj.getPage = function () {
      var init = (obj.currentPage - 1) * obj.itemsPerPage;
      var end = obj.currentPage * obj.itemsPerPage;
      if (end > obj.totalItems) {
        end = obj.totalItems;
      }

      obj.pageItems = obj.list.slice(init, end);
    };

    function init() {

      obj.masterVarieties = [];

      var permissions = common.getUserData().data.permissions;
      obj.disabledStatusAction = !(common.getUserData().ibf_role === 'ADMIN' || common.getUserData().main_role === 'ADMIN');

      if (obj.disabledStatusAction && permissions && Object.keys(permissions).length > 0) {
        obj.disabledStatusAction = !(permissions && permissions["masterlist"] && Array.isArray(permissions["masterlist"]) && permissions["masterlist"].includes("ACTIVE_MASTERLIST"));
      }

      if (common.getUserData().data.role !== 'GROWER' || common.getUserData().data.ibf_role !== 'GROWER' || common.getUserData().fromCountryManager) {
        obj.showMasterlistTab = true;
      }

      if (common.getUserData().ibf_role === "COUNTRY_MANAGER" || common.getUserData().ibf_role === "SUPPORT" || common.getUserData().ibf_role === "LOGISTICS_SUPPORT" || common.getUserData().ibf_role === "BOOKKEEPING") {
        obj.showMasterlistTab = true;
      }

      if (common.getUserData().data.role === 'GROWER' && !common.getUserData().main_role) {
        obj.showMasterlistTab = false;
      }

      var userData = common.getUserData();
      var userEmail = userData && userData.data ? userData.data.email : null;
      var isHdbEmail = userEmail === 'nederland@ibuyflowers.com';

      if (userData && userData.grower === 'a8bf30bf-9d85-4ad5-8c48-5c39d671d1f' && !isHdbEmail && !userData.main_role) {
        obj.showMasterlistTab = false;
      }

      obj.loadMasterlists(obj.growerKey);
      //obj.length_values();
    }

    obj.getNumber = function (num) {
      return new Array(num);
    };

    $scope.$on('$locationChangeStart', function (e, newUrl) {
      // Detecta si intenta entrar a la URL prohibida
      if (common.getUserData().data.role === 'GROWER' && !common.getUserData().main_role) {
        if (newUrl && typeof newUrl === "string" && newUrl.includes('/grower/setup/masterlist/')) {
          e.preventDefault(); // evitar que entre
          $state.go('grower.setup.company');
        }
      } else {}
    });

    obj.productConfig = {
      create: false,
      highlight: true,
      valueField: '_KEY',
      //labelField: 'common_name',
      delimiter: '|',
      searchField: ['common_name', 'category', 'botanical_name'],
      placeholder: 'Select Product Group',
      maxItems: 1,
      render: {
        option: function option(data, escape) {
          return '<div class="option">' + '<span class="title">' + escape(data.common_name) + '</span>' + '</div>';
        },
        item: function item(data, escape) {
          return '<div class="item">' + '<span class="item">' + escape(data.common_name) + '</span>' + '</div>';
        }
      },
      onChange: function onChange(value) {
        if (value) {
          obj.varieties = $filter('filter')(obj.masterVarieties, { product_group: value });
        }

        if (obj.variety) {
          obj.varietySelectize.setValue('');
        }

        obj.varietySelectize.refreshOptions(false);
        obj.filterList();
        if (!obj.fromClick) {
          $scope.$apply();
        }
        obj.fromClick = false;
      },
      onInitialize: function onInitialize(selectize) {
        // receives the selectize object as an argument
        obj.productSelectize = selectize;
      }
    };

    obj.lengthConfig = {
      create: false,
      highlight: true,
      valueField: 'length',
      //labelField: 'common_name',
      delimiter: '|',
      searchField: ['length'],
      placeholder: 'Select Length',
      maxItems: 1,
      render: {
        option: function option(data, escape) {
          return '<div class="option">' + '<span class="title">' + escape(data.length) + '</span>' + '</div>';
        },
        item: function item(data, escape) {
          return '<div class="item">' + '<span class="item">' + escape(data.length) + '</span>' + '</div>';
        }
      },
      onChange: function onChange(value) {
        obj.filterList();
        if (!obj.fromClick) {
          $scope.$apply();
        }
        obj.fromClick = false;
      },
      onInitialize: function onInitialize(selectize) {
        // receives the selectize object as an argument
        obj.lengthSelectize = selectize;
      }
    };

    obj.varietyConfig = {
      create: false,
      highlight: true,
      valueField: '_KEY',
      delimiter: '|',
      searchField: ['variety_name'],
      placeholder: 'Select Variety',
      maxItems: 1,
      render: {
        option: function option(data, escape) {
          return '<div class="option">' + '<span class="title">' + escape(data.variety_name) + ' (' + escape(data.color.color_name) + ')' + '</span>' + '</div>';
        },
        item: function item(data, escape) {
          return '<div class="item">' + '<span class="item">' + escape(data.variety_name) + ' (' + escape(data.color.color_name) + ')' + '</span>' + '</div>';
        }
      },
      onChange: function onChange(value) {
        obj.filterList();
        if (!obj.fromClick) {
          $scope.$apply();
        }
        obj.fromClick = false;
      },
      onInitialize: function onInitialize(selectize) {
        // receives the selectize object as an argument

        obj.varietySelectize = selectize;
      }
    };

    obj.toggleActive = function (key, status) {

      var active = status ? false : true;
      var config = {
        //title: "Change item status",
        // msj: "Do you want to activate / deactivate this item?",
        save: 'save',
        cancel: 'cancel',
        alignRight: true,
        hideCancel: false
      };
      config.title = status ? 'Deactivate Item' : 'Activate Item';
      config.msj = status ? 'Do you want to deactivate this item?' : 'Do you want to activate this item?';
      common.confirmModal(config, function () {
        var query = {
          'domain': common.actual_domain,
          'row_model': 'add_masterlist',
          'rows': [{
            '_KEY': key,
            'active': active
          }]
        };

        common.method.query(common.urls.update, query).then(function () {

          var response = common.response.post_query.data;
          if (response.success) {
            //obj.loadMasterlists();

            common.updateMasterlistInventory([key], function () {});
            if (status) {
              common.refreshMasterlist();
            }
            alertify.success('Updated.');

            // const query = common.sbx.with('masterlist_grower_box')
            //   .andWhereIsEqual('masterlist', key).compile();

            // common.method.query(common.urls.delete, query).then(() => {
            // });
          } else {
            alertify.error(response.error);
          }
        });
      }, function () {
        obj.loadMasterlists();
      });
    };

    obj.cleanInactive = function () {
      delete obj.showInactive;
      obj.toggleMasterlistActive();
    };

    obj.toggleMasterlistActive = function () {

      obj.loadMasterlists();

      obj.filterList();

      // obj.list = $filter('filter')(obj.masterlist, function (value) {
      //   return !obj.showInactive ? !value.active : value.active
      // });
      //
      //
      // // obj.totalItems = obj.list.length;
      // //
      obj.currentPage = 1;
      obj.getPage();
    };

    // obj.getGrowerKey= function (grower){
    //   console.log("sii",grower,obj.growerKey)
    //   obj.growerKey=grower
    // }
    obj.loadMasterlists = function (fromEdit) {

      obj.isLoading = true;
      var query = common.sbx.with('add_masterlist').fetchModels(['UoM', 'stems_per_bunch', 'grade', 'product_group', 'variety.color', 'variety.product_group', 'box']).andWhereIsEqual('grower', common.getUserData().grower ? common.getUserData().grower : $state.params.growerId).compile();
      /*const query = new common.queryBuilder().setDomain(common.actual_domain).setModel('add_masterlist')
        .fetchModels(['UoM', 'stems_per_bunch', 'grade', 'product_group', 'variety.color', 'box'])
        .addCondition('AND', 'grower', '=', common.getUserData().grower).compile();*/

      common.loadAllPages(query, function (response) {
        if (response.results.length) {
          obj.totalItems = response.results.length;
          obj.fetched_results = response.fetched_results;
          obj.lengths_object = [];
          var varieties = obj.fetched_results.variety,
              products = obj.fetched_results.product_group;
          Object.keys(varieties).forEach(function (key) {
            var item = varieties[key];
            item.variety_name = item.variety_name.replace(/\b[a-z]/g, function (x) {
              return x.toUpperCase();
            });
            obj.masterVarieties.push(item);
          });
          obj.masterVarieties = $filter('orderBy')(obj.masterVarieties, 'variety_name');
          obj.varieties = obj.masterVarieties;

          Object.keys(products).forEach(function (key) {
            obj.products.push(products[key]);
          });
          obj.products = $filter('orderBy')(obj.products, 'common_name');
          async.eachLimit(response.results, 100, function (item, cbEach) {
            item.UoM = obj.fetched_results.uom[item.UoM];
            item.box = obj.fetched_results.admin_box[item.box];
            item.stems_per_bunch = obj.fetched_results.stems_per_bunch[item.stems_per_bunch];
            item.grade = obj.fetched_results.grade[item.grade];
            // item.variety = obj.fetched_results.variety[item.variety] ? obj.fetched_results.variety[item.variety] : item.variety;
            item.variety = obj.fetched_results.variety[item.variety];
            item.product_group = obj.fetched_results.product_group[item.product_group];
            if (item.product_group && _typeof(item.variety) === "object") {
              item.variety.product_group = item.product_group;
            }

            if (item.variety && typeof item.variety.color === 'string' || item.variety.color instanceof String) {
              item.variety.color = obj.fetched_results.color[item.variety.color];
            }
            if (item.variety && item.variety.color) {
              item.color = item.variety.color;
            }

            item.length_label = item.length + 'cm';
            cbEach();
          }, function () {

            obj.masterlist = response.results.sortByVariety('variety');
            obj.list = obj.masterlist.slice();

            obj.length_list = obj.list.reduce(function (arr, item) {

              if (!arr.some(function (i) {
                return i.length === item.length;
              })) {
                arr.push({ length: item.length });
              }

              return arr;
            }, []).sort(function (a, b) {
              return a.length - b.length;
            });
            obj.filterList(fromEdit);
          });
        } else {
          alertify.error('No masterlists items have been found.');
        }
        obj.isLoading = false;
      }, function (err) {
        alertify.error('Error loading masterlist.' + err);
      });
    };

    var editRequestId = 0,
        editReleaseTimer = null;

    // leaving the page while the row is being read must not open the editor (or show a toast) elsewhere
    $scope.$on('$destroy', function () {
      editRequestId++;
      $timeout.cancel(editReleaseTimer);
    });

    // Re-reads the row from the server so the modal never opens with data older than the last save
    obj.edit = function (item) {
      if (obj.loadingEditKey) {
        return;
      }

      obj.loadingEditKey = item._KEY;

      // a request that never answers must not leave every Edit button locked
      var requestId = ++editRequestId;
      editReleaseTimer = $timeout(function () {
        if (requestId === editRequestId && obj.loadingEditKey) {
          editRequestId++;
          obj.loadingEditKey = null;
          alertify.error('The latest masterlist data could not be loaded, please try again.');
        }
      }, 30000);

      var query = common.sbx.with('add_masterlist').whereWithKeys([item._KEY]).fetchModels(['UoM', 'stems_per_bunch', 'grade', 'product_group', 'variety.color', 'variety.product_group', 'box']).compile();

      common.method.query(common.urls.find, query).then(function () {
        // answered after the timeout released the buttons: ignore it
        if (requestId !== editRequestId) {
          return;
        }

        $timeout.cancel(editReleaseTimer);
        var res = common.response.post_query.data;
        obj.loadingEditKey = null;

        if (!res || !res.success || !res.results || !res.results.length) {
          alertify.error('The latest masterlist data could not be loaded, please try again.');
          return;
        }

        var fetched = res.fetched_results || {};
        var fresh = res.results[0];

        fresh.UoM = fetched.uom ? fetched.uom[fresh.UoM] : fresh.UoM;
        fresh.box = fetched.admin_box ? fetched.admin_box[fresh.box] : fresh.box;
        fresh.stems_per_bunch = fetched.stems_per_bunch ? fetched.stems_per_bunch[fresh.stems_per_bunch] : fresh.stems_per_bunch;
        fresh.grade = fetched.grade ? fetched.grade[fresh.grade] : fresh.grade;
        fresh.variety = fetched.variety ? fetched.variety[fresh.variety] : fresh.variety;
        fresh.product_group = fetched.product_group ? fetched.product_group[fresh.product_group] : fresh.product_group;

        if (fresh.variety && _typeof(fresh.variety) === 'object') {
          if (fresh.variety.variety_name) {
            fresh.variety.variety_name = fresh.variety.variety_name.replace(/\b[a-z]/g, function (x) {
              return x.toUpperCase();
            });
          }
          if (fresh.product_group) {
            fresh.variety.product_group = fresh.product_group;
          }
          if (typeof fresh.variety.color === 'string' && fetched.color) {
            fresh.variety.color = fetched.color[fresh.variety.color];
          }
          if (fresh.variety.color) {
            fresh.color = fresh.variety.color;
          }
        }

        fresh.length_label = fresh.length + 'cm';

        obj.openEditModal(fresh);
      });
    };

    obj.openEditModal = function (item) {
      var modalInstance = $uibModal.open({
        templateUrl: 'views/admin/masterlistModal.html',
        controller: 'growerMasterlistEditCtrl',
        controllerAs: 'obj',
        bindToController: true,
        backdrop: 'static',
        keyboard: false,
        size: 'lg',
        resolve: {
          config: function config() {
            return {
              masterlist: item
            };
          }
        }
      });
      modalInstance.result.then(function (data) {
        obj.loadMasterlists(true);
      });
    };

    obj.filterList = function (fromEdit) {

      var masterlist = obj.masterlist.filter(function (item) {
        return !obj.showInactive ? !item.active : item.active;
      });

      if (obj.searchText || obj.product || obj.variety || obj.length) {
        obj.list = $filter('filter')(masterlist, function (value) {
          var pg = value.product_group.common_name.toLowerCase();
          var v = value.variety.variety_name.toLowerCase();

          var condition = true;

          if (obj.product) {
            condition = value.product_group._KEY === obj.product;
          }

          if (obj.variety) {
            condition = value.variety._KEY === obj.variety;
          }

          if (obj.length) {
            condition = value.length.toString() === obj.length;
          }

          if (obj.searchText) {
            return (pg.indexOf(obj.searchText.toLowerCase()) !== -1 || v.indexOf(obj.searchText.toLowerCase()) !== -1) && condition;
          }

          return condition;
        });
      } else {
        obj.list = masterlist.slice();
      }

      obj.totalItems = obj.list.length;
      if (!fromEdit) {
        obj.currentPage = 1;
      }

      obj.getPage();
    };

    obj.add_masterlist = function () {
      $state.go('grower.setup.masterlist.new');
    };

    obj.clear_filters = function () {
      obj.fromClick = true;
      obj.list = obj.masterlist.slice();
      obj.varieties = obj.masterVarieties.slice();
      obj.product = null;
      obj.length = null;
      obj.varietySelectize.setValue('');
      obj.lengthSelectize.setValue('');
      obj.productSelectize.setValue('');
      obj.searchText = '';
      obj.filterList();
    };

    init();
  }
})(angular);
//# sourceMappingURL=growerMasterlistCtrl.js.map

'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

(function (angular) {
  angular.module('ibf').controller('growerMasterlistAddCtrl', ['$scope', 'alertify', 'commonSrv', 'productSrv', '$state', '$filter', 'growerSrv', 'maskSrv', '$timeout', growerMasterlistAddCtrl]);

  function growerMasterlistAddCtrl($scope, alertify, commonSrv, productSrv, $state, $filter, growerSrv, maskSrv, $timeout) {
    var obj = this,
        common = commonSrv,
        ps = productSrv,
        gs = growerSrv,
        mask = maskSrv;
    var masterListBox = [];
    obj.boxOn = false;
    obj.onlyCombo = false;
    obj.isLogisticsSupport = false;
    obj.disableVariety = true;
    obj.order_in_advance = 0;
    obj.isLoading = false;
    obj.growerCountry;
    obj.growerBoxes = [];
    obj.copyGrowerBoxes = [];
    obj.masterlistGrowerBoxes = [];
    obj.full_box_selected = '';

    function init() {
      obj.charge = new mask(0);
      obj.boxes = [];
      obj.varietiesSelected = {};
      obj.gradeFromProductGroup = ''; // Initialize the grade from product group field
      async.parallel([obj.loadVarieties, obj.loadStems, obj.growerInfo, obj.loadUoM, obj.loadGrades, obj.loadFactors, obj.loadGrowerBoxes, obj.loadCountries], function () {});

      obj.isLogisticsSupport = common.getUserData().main_role === 'LOGISTICS_SUPPORT';

      obj.isGrowerRole = common.getUserData().ibf_role && !common.getUserData().main_role && common.getUserData().ibf_role === 'GROWER';

      gs.getLengthList(function (res) {
        obj.lengths = res;
      });
      obj.selectedGroup = false;
    }

    obj.getNumber = function (num) {
      return new Array(num);
    };

    obj.filterLength = function (num) {

      if (num > 0 && num <= 50) {
        return 50;
      }
      if (num > 50 && num <= 60) {
        return 60;
      }
      if (num > 60) {
        return 80;
      }
    };

    obj.filterbox = function () {

      var items = angular.copy(obj.actual_product);
      if (obj.search) {
        var list = [];
        angular.forEach(items, function (item) {

          if (item.variety_name.toLowerCase().match(obj.search.toLowerCase())) {
            list.push(item);
          }
        });
        obj.varieties = list;
      } else {
        angular.copy(obj.actual_product, obj.varieties);
      }
    };

    obj.showBox = function () {

      if (obj.length && obj.stems_num) {
        obj.boxOn = true;
      } else {
        obj.boxOn = false;
      }
    };

    obj.selectBox = function (box) {
      obj.box = box;
      setBox();
    };

    obj.setBox = function () {
      obj.uom = obj.uoms[0];
      obj.weight = 0;
    };

    obj.loadFactors = function (cb) {
      ps.listFactors(function (list) {
        obj.factors = list.data;
        obj.factorsMap = {};

        for (var i = 0; i < obj.factors.length; i++) {
          if (obj.factors[i].carrier.carrier !== 'Fedex') {
            continue;
          }
          if (!obj.factorsMap[obj.factors[i].country._KEY]) {
            obj.factorsMap[obj.factors[i].country._KEY] = [obj.factors[i]];
          } else {
            obj.factorsMap[obj.factors[i].country._KEY].push(obj.factors[i]);
          }
        }
        cb();
      }, function (err) {
        alertify.error(err);
        cb();
      });
    };

    obj.loadCountries = function () {
      var countries = {
        'domain': common.actual_domain,
        'row_model': 'country'
      };
      common.method.query(common.urls.find, countries).then(function (response) {
        if (response.data.success) {
          obj.countries = response.data.results;
        } else {
          alertify.error(response.data.error || 'Error loading countries');
        }
      }).catch(function (error) {
        console.error('Error loading countries:', error);
        alertify.error('Failed to load countries');
      });
    };

    obj.growerInfo = function (cb) {
      var grower = {
        'domain': common.actual_domain,
        'row_model': 'grower',
        'fetch': ['country'],
        'where': {
          'keys': [common.getUserData().grower]
        }
      };
      common.method.query(common.urls.find, grower).then(function () {
        var res = common.response.post_query.data;

        if (res.success) {
          obj.grower = res.results[0];
          obj.growerCountry = res.fetched_results.country[obj.grower.country];
          obj.origin_country = obj.growerCountry._KEY;
          obj.loadBoxes();
          cb();
        } else {
          alertify.error(res.error);
          cb();
        }
      });
    };

    obj.loadUoM = function (cb) {
      gs.uomList(function (units) {
        obj.uoms = $filter('orderBy')(units.data, 'index_order');
        obj.masterUoM = angular.copy(units.data);
        cb();
      }, function (err) {
        alertify.error(err);
        cb();
      });
    };

    obj.productConfig = {
      create: false,
      highlight: true,
      valueField: '_KEY',
      delimiter: '|',
      searchField: ['common_name', 'botanical_name'],
      placeholder: 'Select Product Group',
      maxItems: 1,
      render: {
        option: function option(data, escape) {
          return '<div class="option">' + '<span class="title">' + escape(data.common_name) + '(' + escape(data.group_type ? data.group_type.group_type : 'not provided') + ')' + '</span>' + '</div>';
        },
        item: function item(data, escape) {
          return '<div class="item">' + '<span class="item">' + escape(data.common_name) + '(' + escape(data.group_type ? data.group_type.group_type : 'not provided') + ')' + '</span>' + '</div>';
        }
      },
      onChange: function onChange(value) {

        obj.disableVariety = false;
        obj.varietiesSelected = {};
        obj.selectedGroup = true;
        obj.groupFilter = value;
        obj.varieties = $filter('filter')(obj.masterVarieties, value);
        obj.actual_product = [].concat(_toConsumableArray(obj.varieties));

        if (value) {
          obj.loadGradesByProductGroup(value);
        } else {
          obj.grade_type = '';
        }

        if (value && obj.productMap[value].group_type) {
          if (obj.productMap[value].group_type.group_type == 'flowers') {
            var new_uoms = [];

            angular.forEach(obj.uoms, function (item) {
              if (item.uom == 'stem' || item.uom == 'bunch') {
                new_uoms.push(item);
              }
            });
            obj.uoms = new_uoms;
          } else {
            angular.copy(obj.masterUoM, obj.uoms);
          }
        } else {
          angular.copy(obj.masterUoM, obj.uoms);
        }

        $scope.$apply();
      }
    };

    obj.checkLength = function (value) {

      var variety = $filter('filter')(obj.varieties, { '_KEY': value })[0];
      obj.isMixed = variety.is_combo;
    };

    obj.loadVarieties = function (cb) {

      ps.listVarietiesPG(1, 1000, function (varieties) {
        obj.masterVarieties = $filter('orderBy')(varieties.data, 'variety_name');
        obj.masterVarieties.forEach(function (ml) {
          return ml.variety_name = ml.variety_name.replace(/\b[a-z]/g, function (x) {
            return x.toUpperCase();
          });
        });
        obj.varietiesMap = common.toMap(obj.masterVarieties, 'varietyMap', '_KEY');
        obj.products = $filter('orderBy')(varieties.pg, 'common_name');
        obj.products = obj.products.filter(function (item) {
          return item.common_name !== 'Custom';
        });
        obj.productMap = common.toMap(obj.products, 'productMap', '_KEY');
        cb();
      }, function (err) {
        alertify.error(err);
        cb();
      });
    };

    obj.loadStems = function (cb) {

      ps.listStemsPerBunch(function (stems) {
        obj.stems = $filter('orderBy')(stems.data, 'index_order');
        obj.stemsMap = common.toMap(obj.stems, 'stems', '_KEY');
        cb();
      }, function (err) {
        alertify.error(err);
        cb();
      });
    };

    obj.loadGrowerBoxes = function (cb) {

      var user = common.getUserData();

      var query = common.sbx.with('grower_box').andWhereIsEqual('grower', user.grower).fetchModels(['box']).compile();

      common.loadAllPages(query, function (data) {
        if (data.results) {

          data.results = data.results.map(function (item) {

            if (item.box && data.fetched_results['admin_box'] && data.fetched_results['admin_box'][item.box]) {
              item = Object.assign(item, {
                box_name: data.fetched_results['admin_box'][item.box].box_name,
                alias: item.alias
              });
            }

            return item;
          });

          obj.growerBoxes = $filter('orderBy')(data.results, 'box.box_name');
          obj.copyGrowerBoxes = $filter('orderBy')(data.results, 'box.box_name');
        }

        cb();
      }, cb);
    };

    obj.stemConfig = {
      create: false,
      highlight: true,
      valueField: '_KEY',
      delimiter: '|',
      searchField: ['stems_per_bunch'],
      placeholder: 'Select Stems',
      maxItems: 1,
      render: {
        option: function option(data, escape) {
          return '<div class="option">' + '<span class="title">' + escape(data.stems_per_bunch) + '</span>' + '</div>';
        },
        item: function item(data, escape) {
          return '<div class="item">' + '<span class="item">' + escape(data.stems_per_bunch) + '</span>' + '</div>';
        }
      },
      onChange: function onChange(value) {
        if (obj.isMixed) {
          obj.boxOn = value ? true : false;
        } else {
          obj.showBox();
        }
        $scope.$apply();
      }
    };

    obj.getPercentage = function (bunches_in_box) {
      return (100 / bunches_in_box).toFixed(2) + '%';
    };

    obj.getUnits = function (item) {

      if (item && item.bunches_in_box > 0 && obj.stems_num) {
        var stems_per_bunch = obj.stems.find(function (item) {
          return item._KEY === obj.stems_num;
        });
        if (stems_per_bunch) {
          return item.bunches_in_box * stems_per_bunch.stems_per_bunch;
        }
      } else {
        if (obj.bunches_in_box > 0 && obj.stems_num) {
          var _stems_per_bunch = obj.stems.find(function (item) {
            return item._KEY === obj.stems_num;
          });
          if (_stems_per_bunch) {
            return obj.bunches_in_box * _stems_per_bunch.stems_per_bunch;
          }
        }
      }

      return 0;
    };

    obj.getBoxName = function (item) {
      var box = obj.copyGrowerBoxes.find(function (box) {
        return box._KEY === item.grower_box;
      });

      if (box) {
        return box.box_name;
      }

      return '';
    };

    obj.getBoxAlias = function (item) {
      var box = obj.copyGrowerBoxes.find(function (box) {
        return box._KEY === item.grower_box;
      });

      if (box) {
        return box.alias;
      }

      return '';
    };

    obj.saveMasterlistBox = function () {

      if (obj.growerBox && (obj.bunches_in_box || obj.percentage)) {
        obj.masterlistGrowerBoxes.push({
          grower_box: obj.growerBox,
          bunches_in_box: obj.bunches_in_box >= 0 ? obj.bunches_in_box : null,
          bunch_percentage: obj.percentage ? parseFloat(obj.percentage) : null
        });

        obj.growerBoxes = obj.growerBoxes.filter(function (item) {
          return item._KEY !== obj.growerBox;
        });
        obj.growerBox = null;
        obj.bunches_in_box = null;
        obj.percentage = null;
      } else {
        if (!obj.growerBox) {
          alertify.error('Please fill the box.');
        } else {
          alertify.error('Please fill the box percentage or bunches in box');
        }
      }
    };

    obj.removeMasterlistBox = function (item) {
      obj.masterlistGrowerBoxes = obj.masterlistGrowerBoxes.filter(function (box) {
        return box.grower_box !== item.grower_box;
      });
      var growerBox = obj.copyGrowerBoxes.find(function (box) {
        return box._KEY === item.grower_box;
      });
      if (growerBox) {
        obj.growerBoxes.push(growerBox);
      }
    };

    obj.boxConfig = {
      create: false,
      highlight: true,
      valueField: '_KEY',
      delimiter: '|',
      searchField: ['box_name'],
      placeholder: 'Select box',
      maxItems: 1,
      render: {
        option: function option(data, escape) {
          return '<div class="option">' + '<span class="title">' + escape(data.box_name) + '</span>' + '</div>';
        },
        item: function item(data, escape) {
          return '<div class="item">' + '<span class="item">' + escape(data.box_name) + '</span>' + '</div>';
        }
      },
      onChange: function onChange(value) {
        // if (obj.isMixed) {
        //   obj.boxOn = value ? true : false;
        // } else {
        //   obj.showBox();
        // }
        $scope.$apply();
      }
    };

    obj.loadLengths = function () {

      ps.listAdminLengths(function (lengths) {
        obj.lengths = $filter('orderBy')(lengths.data, 'index_order');
      }, function (err) {
        alertify.error(err);
      });
    };

    obj.lengthConfig = {
      create: false,
      highlight: true,
      valueField: '_KEY',
      delimiter: '|',
      searchField: ['length'],
      placeholder: 'Select Length',
      maxItems: 1,
      render: {
        option: function option(data, escape) {
          return '<div class="option">' + '<span class="title">' + escape(data.length) + '</span>' + '</div>';
        },
        item: function item(data, escape) {
          return '<div class="item">' + '<span class="item">' + escape(data.length) + '</span>' + '</div>';
        }
      }
    };

    obj.loadBoxes = function () {

      var query = commonSrv.sbx.with('admin_box').andWhereIsEqual('country', obj.grower.country).compile();
      /*var query = commonSrv.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('admin_box')
        .addCondition('AND', 'country', '=', obj.grower.country)
        .compile();*/

      common.method.query(common.urls.find, query).then(function () {
        var response = common.response.post_query.data;

        if (response.success) {
          masterListBox = response.results;
          obj.boxes = angular.copy(masterListBox.sort(function (a, b) {
            return (a.box_name ? a.box_name : '').localeCompare(b.box_name ? b.box_name : '');
          }));
        } else {
          alertify.error(response.error);
        }
      });
    };

    obj.updateGrades = function () {
      var type = obj.grade_type.value;

      if (type == 'all') {
        angular.copy(obj.grades, obj.gradeOptions);
      } else {
        obj.gradeOptions = [];
        obj.gradeOptions = obj.gradeTypesMap[type];
      }
      obj.gradesSelectize.refreshOptions();
    };

    obj.loadGrades = function (cb) {

      ps.listGrades(function (grades) {

        obj.grades = grades.all;

        var noneOption = {
          _KEY: 'NONE',
          grade: 'NONE',
          grade_type: 'NONE'
        };

        var noneExists = obj.grades.some(function (grade) {
          return grade._KEY === 'NONE';
        });

        if (!noneExists) {
          obj.grades.unshift(noneOption);
        }

        obj.gradeOptions = angular.copy(obj.grades);
        obj.gradeTypesMap = grades.mapped;
        obj.gradesMap = common.toMap(obj.grades, 'gradeMap', '_KEY');

        obj.grade_types = [{ label: 'all', value: 'all' }];
        angular.forEach(obj.gradeTypesMap, function (item, key) {
          obj.grade_types.push({ label: key, value: key });
        });

        cb();
      }, function (err) {
        alertify.error(err);
        cb();
      });
    };

    obj.loadGradesByProductGroup = function (productGroupKey) {
      var query = {
        'domain': common.actual_domain,
        'row_model': 'grade',
        'where': [{
          'ANDOR': 'AND',
          'GROUP': [{
            'ANDOR': 'AND',
            'FIELD': 'product_group',
            'OP': '=',
            'VAL': productGroupKey
          }]
        }]
      };

      common.method.query(common.urls.find, query).then(function () {
        var res = common.response.post_query.data;
        if (res.success) {
          var sortedGrades = res.results.sort(function (a, b) {
            return a.index_order - b.index_order;
          });

          var noneOption = {
            _KEY: 'NONE',
            grade: 'NONE',
            grade_type: 'NONE',
            product_group: productGroupKey
          };

          sortedGrades.unshift(noneOption);

          obj.gradeOptions = sortedGrades;

          if (obj.gradesSelectize) {
            obj.gradesSelectize.refreshOptions(false);
          }

          if (sortedGrades.length > 1) {
            if (!obj.grade) {
              obj.grade_type = sortedGrades[0].grade_type;
              obj.grade = sortedGrades[0]._KEY;
            }
          } else {
            obj.grade_type = 'NONE';
            obj.grade = 'NONE';
          }

          $scope.$applyAsync();
        } else {
          // Si la consulta falla, también mostramos 'NONE'
          var noneOption = {
            _KEY: 'NONE',
            grade: 'NONE',
            grade_type: 'NONE',
            product_group: productGroupKey
          };
          obj.gradeOptions = [noneOption];
          obj.grade_type = 'NONE';
          obj.grade = 'NONE';
          $scope.$applyAsync();
        }
      });
    };

    obj.countryConfig = {
      create: false,
      highlight: true,
      valueField: '_KEY',
      delimiter: '|',
      searchField: ['country'],
      placeholder: 'Select Country',
      maxItems: 1,
      render: {
        option: function option(data, escape) {
          return '<div class="option">' + '<span class="title">' + escape(data.country) + '</span>' + '</div>';
        },
        item: function item(data, escape) {
          return '<div class="item">' + '<span class="item">' + escape(data.country) + '</span>' + '</div>';
        }
      },
      onChange: function onChange(value) {

        $scope.$apply();
      }
    };

    obj.gradeConfig = {
      create: false,
      highlight: true,
      valueField: '_KEY',
      delimiter: '|',
      searchField: ['grade', 'grade_type'],
      placeholder: 'Select Grade',
      maxItems: 1,
      render: {
        option: function option(data, escape) {
          return '<div class="option">' + '<span class="title">' + escape(data.grade) + '</span>' + '</div>';
        },
        item: function item(data, escape) {
          return '<div class="item">' + '<span class="item">' + escape(data.grade) + '</span>' + '</div>';
        }
      },
      onInitialize: function onInitialize(selectize) {
        // receives the selectize object as an argument
        obj.gradesSelectize = selectize;
      },
      onChange: function onChange(value) {
        var selectedGrade = obj.gradeOptions.find(function (g) {
          return g._KEY === value;
        });
        if (selectedGrade) {
          obj.grade_type = selectedGrade.grade_type;
        } else {
          obj.grade_type = '';
        }
        obj.grade = value;
        $scope.$applyAsync();
      }
    };

    obj.checkSelected = function (key) {
      if (obj.varietiesSelected[key]) {
        return true;
      } else {
        return false;
      }
    };

    obj.areCombos = function () {

      var i = 0;
      angular.forEach(obj.varietiesSelected, function (item) {
        if (obj.checkSelected(item._KEY) && item.is_combo) {
          i++;
        }
      });
      return i;
    };

    obj.checkCombo = function (item) {

      if (item.is_combo && !obj.onlyCombo) {
        obj.onlyCombo = true;
      } else {
        if (item.is_combo && obj.areCombos() == 0) {
          obj.onlyCombo = false;
        }
      }
    };

    obj.handleItems = function (item) {
      if (Object.keys(obj.varietiesSelected).length <= 0) {
        obj.varietiesSelected[item._KEY] = item;
      } else {
        if (obj.varietiesSelected[item._KEY]) {
          delete obj.varietiesSelected[item._KEY];
        } else {
          obj.varietiesSelected[item._KEY] = item;
        }
      }
    };

    obj.checkVarietiesSelected = function () {
      return Object.keys(obj.varietiesSelected).length > 1;
    };

    obj.cleanNoCombo = function () {
      angular.forEach(obj.varietiesSelected, function (item) {
        if (!item.is_combo) {
          delete obj.varietiesSelected[item._KEY];
        }
      });
    };

    obj.toggleSelected = function (item) {

      // if(obj.comboSelection && !item.is_combo){
      //   return false;
      // }

      obj.checkLength(item._KEY);

      if (Object.keys(obj.varietiesSelected).length == 0) {
        obj.handleItems(item);
        obj.checkCombo(item);
      } else {

        if (obj.onlyCombo && item.is_combo && Object.keys(obj.varietiesSelected).length > 0) {
          obj.handleItems(item);
          obj.checkCombo(item);
          obj.cleanNoCombo();
        } else {
          if (!obj.onlyCombo && item.is_combo) {
            obj.handleItems(item);
            obj.checkCombo(item);
            obj.cleanNoCombo();
          }
        }

        if (!obj.onlyCombo && !item.is_combo && Object.keys(obj.varietiesSelected).length > 0) {
          obj.handleItems(item);
        }
      }
    };

    obj.cancel = function () {
      $state.go('grower.setup.masterlist.view');
    };
    // add save
    obj.save = function () {
      var valid = true,
          msg = '',
          rows = [],
          boxes = 0;

      $scope.$broadcast('show-errors-check-validity');
      if (obj.growerForm.$invalid) {

        obj.isLoading = false;
        return alertify.error('There are invalid fields');
      }

      if (Object.keys(obj.varietiesSelected).length <= 0) {
        return alertify.error('You need to select a variety.');
      }

      if (!obj.units || !obj.weight) {
        return alertify.error('You must provide a value for units and actual weight');
      }

      obj.unit_value = obj.units;
      obj.weight_value = obj.weight;

      if (!obj['length']) {
        valid = false;
        return alertify.error('You must provide the length');
      }

      if (obj.weight_value == 0) {
        return alertify.error('You must provide the actual weight of the box');
      }

      if (!obj.uom) {
        return alertify.error('You need to select a UoM');
      } else if (obj.uom.uom == 'stem') {
        if (obj.unit_value % obj.stemsMap[obj.stems_num].stems_per_bunch > 0) {
          return alertify.error('the number of units must be multiple of the number of stems.');
        }
      }

      obj.uom_value = obj.uom._KEY;
      if (obj.customizable && !obj.custom_percentage) {
        if (!obj.isLogisticsSupport) {
          return alertify.error('You must provide the custom percentage of bunch');
        }
      }
      obj.isLoading = true;

      var i = 0;
      angular.forEach(obj.varietiesSelected, function (item) {

        if (obj.uom.uom == 'stem') {
          obj.bunches_in_box = (parseInt(obj.unit_value) / parseInt(obj.stemsMap[obj.stems_num].stems_per_bunch)).toFixed(0);
        } else {
          obj.bunches_in_box = obj.unit_value;
        }
        var searchName = obj.productMap[obj.product].category.category + ' ';
        searchName += obj.productMap[obj.product].common_name + ' ';
        searchName += item.variety_name.slice(0, 50) + ' ';
        searchName += item.color.color_name + ' ';
        searchName += obj.grade && obj.grade !== 'NONE' ? obj.gradesMap[obj.grade].grade + ' ' : '';
        searchName += obj.length + 'cm ';
        searchName += obj.growerCountry.country;

        rows[i] = {
          variety: item._KEY,
          length: obj.length,
          grade: obj.grade === 'NONE' ? null : obj.grade,
          UoM: obj.uom_value,
          stems_per_bunch: obj.stems_num,
          units: obj.unit_value,
          actual_weight: obj.weight_value,
          box_charge: obj.charge.value,
          grower: common.getUserData().grower,
          // box: obj.box._KEY,
          active: true,
          product_group: obj.product,
          bunches_in_box: obj.bunches_in_box,
          grower_code: obj.grower_code,
          order_in_advance: obj.order_in_advance >= 0 ? obj.order_in_advance : 0,
          customizable: obj.customizable,
          custom_percentage: obj.custom_percentage,
          search_name: searchName,
          custom_photo: false,
          extra_photos: '',
          external_photo: '',
          prod_weight: obj.prod_weight && obj.prod_weight >= 0 ? parseFloat(obj.prod_weight) / 1000 : null,
          length_padding: obj.length_padding && obj.length_padding >= 0 ? obj.length_padding : 0,
          prod_weight_padding_enabled: obj.prod_weight_padding_enabled ? obj.prod_weight_padding_enabled : false,
          origin_country: obj.origin_country
        };

        if (obj.checkVarietiesSelected()) {
          delete rows[i].grower_code;
        }

        i++;
      });

      async.waterfall([function (callback) {
        var query = common.sbx.with('add_masterlist').andWhereIsEqual('grower', common.getUserData().grower).andWhereIsEqual('product_group', obj.product).andWhereIn('variety', Object.keys(obj.varietiesSelected)).compile();
        common.loadAllPages(query, function (response) {
          var varietyMap = {};
          response.results.forEach(function (item) {
            if (!varietyMap[item.variety]) {
              varietyMap[item.variety] = {
                custom_photo: item.custom_photo,
                extra_photos: item.extra_photos,
                external_photo: item.external_photo
              };
            }
          });
          rows = rows.map(function (item) {
            var aux = varietyMap[item.variety];
            if (aux) {
              item.custom_photo = aux.custom_photo;
              item.extra_photos = aux.extra_photos;
              item.external_photo = aux.external_photo;
            }
            return item;
          });
          callback(null, {});
        }, function (error) {
          callback(error);
        });
      }, function (_, callback) {

        productSrv.saveMasterlist(rows, function (masterlist) {
          if (masterlist && masterlist.length > 0 && obj.masterlistGrowerBoxes && obj.masterlistGrowerBoxes.length > 0) {
            var data = [];

            masterlist.forEach(function (masterlistKey) {
              obj.masterlistGrowerBoxes.forEach(function (t) {
                data.push({
                  masterlist: masterlistKey,
                  grower_box: t.grower_box,
                  bunches_in_box: t.bunches_in_box,
                  bunch_percentage: t.bunch_percentage,
                  full_box: obj.full_box_selected === t.grower_box
                });
              });
            });

            obj.isLoading = true;

            var query = common.sbx.insert('masterlist_grower_box', data);

            common.method.query(common.urls.row, query).then(function () {
              var res = common.response.post_query.data;
              if (res.success) {
                // cb(null, box);
                obj.loadGrowerBoxes(function () {
                  obj.isLoading = false;
                });
              } else {
                alertify.error(res.error);
                obj.isLoading = false;
                // cb(new Error(res.error),box);
              }
            });
          }

          obj.length = null;
          obj.box = null;
          obj.box_fixed = null;
          obj.stems_num = null;
          obj.weight = null;
          obj.units = null;
          obj.uom = null;
          obj.boxOn = false;
          obj.grower_code = null;
          obj.customizable = null;
          obj.custom_percentage = null;
          obj.masterlistGrowerBoxes = [];
          obj.growerBox = null;
          obj.bunches_in_box = null;
          obj.percentage = null;
          obj.order_in_advance = 0;
          // obj.length_padding = null
          // obj.prod_weight = null
          // obj.prod_weight_padding_enabled = false
          callback(null, {});
        }, function (error) {
          callback(error);
        });
      }], function (err, _) {
        obj.isLoading = false;
        if (err) {
          alertify.error(err);
        } else {
          alertify.success('Masterlist Created');
        }
      });
    };

    obj.handleFullBox = function (item) {
      obj.full_box_selected = item.grower_box;
    };

    init();
  }
})(angular);
//# sourceMappingURL=growerMasterlistAddCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('growerMasterlistEditCtrl', ['$scope', 'alertify', 'commonSrv', 'productSrv', 'growerSrv', '$uibModalInstance', 'config', '$filter', 'maskSrv', '$timeout', growerMasterlistEditCtrl]);

  function growerMasterlistEditCtrl($scope, alertify, commonSrv, productSrv, growerSrv, $uibModalInstance, config, $filter, maskSrv, $timeout) {

    var obj = this,
        common = commonSrv,
        ps = productSrv,
        gs = growerSrv,
        mask = maskSrv;
    obj.units = {};
    obj.uom = {};
    obj.weight = {};
    obj.lengths = [];
    obj.isLoading = false;
    obj.isSaving = false;
    obj.isAddingBox = false;
    obj.isLoadingBoxes = false;
    obj.boxesError = false;
    obj.boxesLoaded = false;
    obj.growerBoxes = [];
    obj.isLogisticsSupport = false;
    obj.copyGrowerBoxes = [];
    obj.masterlistGrowerBoxes = [];
    obj.full_box_selected = '';

    function init() {
      obj.config = config.masterlist;
      obj.order_in_advance = obj.config.order_in_advance ? obj.config.order_in_advance.toString() : '0';
      obj.length = obj.config.length ? obj.config.length.toString() : obj.config.box && obj.config.box.fixed_length ? obj.config.box.fixed_length : '';
      obj.stems_num = obj.config.stems_per_bunch._KEY;
      obj.grade = obj.config.grade ? obj.config.grade._KEY : null;
      obj.grower_code = obj.config.grower_code;
      obj.prod_weight = obj.config.prod_weight && obj.config.prod_weight > 0 ? obj.config.prod_weight * 1000 : null;
      obj.prod_weight_padding_enabled = obj.config.prod_weight_padding_enabled;
      obj.length_padding = obj.config.length_padding;
      obj.units = obj.config.units;
      obj.uom = obj.config.UoM;
      obj.weight = obj.config.actual_weight;
      obj.charge = obj.charge = new mask(obj.config.box_charge);
      obj.customizable = obj.config.customizable;
      obj.custom_percentage = obj.config.custom_percentage;
      obj.prod_group = obj.config.product_group;
      obj.origin_country = obj.config.origin_country || common.getUserData().country._KEY;
      obj.loadStems();
      obj.loadUoM();
      obj.loadMasterlistGrowerBoxes();
      obj.loadGradesByProductGroup();
      obj.loadCountries();
      obj.isLogisticsSupport = common.getUserData().main_role === 'LOGISTICS_SUPPORT';

      obj.isLogisticsSupport = common.getUserData().main_role === 'LOGISTICS_SUPPORT';

      obj.isGrowerRole = common.getUserData().ibf_role && !common.getUserData().main_role && common.getUserData().ibf_role === "GROWER";
      obj.lastUpdated = config.masterlist._META.updated_time;

      // obj.loadGrowerBoxes()
    }

    obj.loadGradesByProductGroup = function () {
      var query = {
        'domain': common.actual_domain,
        'row_model': 'grade',
        'where': [{
          'ANDOR': 'AND',
          'GROUP': [{
            'ANDOR': 'AND',
            'FIELD': 'product_group',
            'OP': '=',
            'VAL': obj.prod_group._KEY
          }]
        }]
      };

      common.method.query(common.urls.find, query).then(function () {
        var res = common.response.post_query.data;
        if (res.success) {
          var sortedGrades = res.results.sort(function (a, b) {
            return a.index_order - b.index_order;
          });

          var noneOption = {
            _KEY: 'NONE',
            grade: 'NONE',
            grade_type: 'NONE',
            product_group: obj.prod_group && obj.prod_group._KEY ? obj.prod_group._KEY : null
          };

          sortedGrades.unshift(noneOption);
          obj.gradeOptions = sortedGrades;
          var selectedGrade = null;

          if (!obj.config.grade || !obj.config.grade._KEY) {
            obj.grade_type = 'NONE';
            obj.grade = 'NONE';
          } else {
            selectedGrade = obj.gradeOptions.find(function (g) {
              return g._KEY === obj.config.grade._KEY;
            });

            if (selectedGrade) {
              obj.grade_type = selectedGrade.grade_type;
              obj.grade = selectedGrade._KEY;
            } else {
              obj.grade_type = obj.gradeOptions[0].grade_type;
              obj.grade = obj.gradeOptions[0]._KEY;
            }
          }
          if (obj.gradesSelectize) {
            obj.gradesSelectize.refreshOptions(false);
            obj.gradesSelectize.setValue(obj.grade, true);
          }
        } else {
          obj.gradeOptions = [{ _KEY: 'NONE', grade: 'NONE', grade_type: 'NONE', product_group: obj.prod_group && obj.prod_group._KEY ? obj.prod_group._KEY : null }];
          obj.grade_type = 'NONE';
          obj.grade = 'NONE';
          if (obj.gradesSelectize) {
            obj.gradesSelectize.refreshOptions(false);
            obj.gradesSelectize.setValue(obj.grade, true);
          }
        }
      });
    };

    function updateGrowerBoxAlias(growerBox) {

      if (growerBox && obj.select_size) {

        var updateGrowerBox = {
          _KEY: growerBox,
          alias: obj.select_size
        };

        var updateQuery = {
          domain: common.actual_domain,
          row_model: 'grower_box',
          rows: [updateGrowerBox]
        };

        common.method.query(common.urls.update, updateQuery).then(function (res) {

          if (res.data && res.data.success) {
            console.log('Grower box alias updated.');
          } else {}
        });
      }
    }

    obj.loadCountries = function () {
      var countries = {
        'domain': common.actual_domain,
        'row_model': 'country'
      };
      common.method.query(common.urls.find, countries).then(function (response) {
        if (response.data.success) {
          obj.countries = response.data.results;
        } else {
          alertify.error(response.data.error || 'Error loading countries');
        }
      }).catch(function (error) {
        console.error('Error loading countries:', error);
        alertify.error('Failed to load countries');
      });
    };

    obj.countryConfig = {
      create: false,
      highlight: true,
      valueField: '_KEY',
      delimiter: '|',
      searchField: ['country'],
      placeholder: 'Select Country',
      maxItems: 1,
      render: {
        option: function option(data, escape) {
          return '<div class="option">' + '<span class="title">' + escape(data.country) + '</span>' + '</div>';
        },
        item: function item(data, escape) {
          return '<div class="item">' + '<span class="item">' + escape(data.country) + '</span>' + '</div>';
        }
      },
      onChange: function onChange(value) {
        $scope.$apply();
      }
    };

    // Only the latest reload may write its result: an older, slower response is ignored
    var boxesRequestId = 0,
        boxesTimer = null;

    $scope.$on('$destroy', function () {
      boxesRequestId++;
      $timeout.cancel(boxesTimer);
    });

    obj.loadMasterlistGrowerBoxes = function () {

      var user = common.getUserData();
      var requestId = ++boxesRequestId;

      obj.isLoadingBoxes = true;
      obj.boxesError = false;

      // a request that never answers must not leave the selector loading forever
      $timeout.cancel(boxesTimer);
      boxesTimer = $timeout(function () {
        if (requestId === boxesRequestId && obj.isLoadingBoxes) {
          boxesRequestId++;
          obj.isLoadingBoxes = false;
          obj.boxesError = true;
          alertify.error('The boxes could not be loaded, please try again.');
        }
      }, 30000);

      var linkedQuery = common.sbx.with('masterlist_grower_box').andWhereIsEqual('grower_box.grower', user.grower).andWhereIsEqual('masterlist', config.masterlist._KEY).fetchModels(['grower_box.box']).compile();

      var growerBoxQuery = common.sbx.with('grower_box').andWhereIsEqual('grower', user.grower).fetchModels(['box']).compile();

      // both lists are independent, so they are requested at the same time
      async.parallel({
        linked: function linked(cb) {
          return common.loadAllPages(linkedQuery, function (data) {
            return cb(null, data);
          }, function (err) {
            return cb(err || new Error('masterlist_grower_box'));
          });
        },
        all: function all(cb) {
          return common.loadAllPages(growerBoxQuery, function (data) {
            return cb(null, data);
          }, function (err) {
            return cb(err || new Error('grower_box'));
          });
        }
      }, function (err, res) {

        if (requestId !== boxesRequestId) {
          return;
        }

        $timeout.cancel(boxesTimer);
        obj.isLoadingBoxes = false;

        if (err || !res.linked.results || !res.all.results) {
          obj.boxesError = true;
          alertify.error('The boxes could not be loaded, please try again.');
          return;
        }

        try {
          var linked = res.linked;
          var linkedFetched = linked.fetched_results || {};

          linked.results = linked.results.map(function (item) {

            var growerBox = (linkedFetched['grower_box'] || {})[item.grower_box];
            if (growerBox) {
              var box = (linkedFetched['admin_box'] || {})[growerBox.box];
              if (box) {
                item = Object.assign(item, {

                  box_name: box.box_name,
                  alias: growerBox.alias
                });
              }
            }

            return item;
          });

          obj.masterlistGrowerBoxes = $filter('orderBy')(linked.results, 'box.box_name');

          var boxesSelected = linked.results.map(function (it) {
            return it.grower_box;
          });

          obj.masterlistGrowerBoxes.forEach(function (item) {
            if (item.full_box) {
              obj.full_box_selected = item._KEY;
            }
          });

          var all = res.all;
          var allFetched = all.fetched_results || {};

          all.results = all.results.filter(function (it) {
            return !boxesSelected.includes(it._KEY);
          }).map(function (item) {

            if (item.box && allFetched['admin_box'] && allFetched['admin_box'][item.box]) {
              item = Object.assign(item, {
                box_name: allFetched['admin_box'][item.box].box_name
              });
            }

            return item;
          });

          obj.growerBoxes = $filter('orderBy')(all.results, 'box.box_name');
          obj.copyGrowerBoxes = $filter('orderBy')(all.results, 'box.box_name');
          obj.boxesLoaded = true;
        } catch (e) {
          obj.boxesError = true;
          alertify.error('The boxes could not be loaded, please try again.');
        }
      });
    };

    obj.isAddDisabled = function () {
      return obj.isLoading || obj.isAddingBox || obj.isLoadingBoxes || obj.boxesError || obj.boxesLoaded && !obj.growerBoxes.length;
    };
    obj.close = function () {
      $uibModalInstance.dismiss('cancel');
    };

    obj.getPercentage = function (bunches_in_box) {
      return (100 / bunches_in_box).toFixed(2) + '%';
    };

    obj.saveMasterlistBox = function () {

      var isExist = false;

      // one Add at a time: ignore extra clicks while the previous one is in flight
      if (obj.isAddingBox) {
        return;
      }

      if (obj.growerBox && (obj.bunches_in_box || obj.percentage)) {

        // keep what the user selected: the form is only cleared once the server confirms
        var growerBox = obj.growerBox;
        var bunchesInBox = obj.bunches_in_box;
        var percentage = obj.percentage;

        var clearForm = function clearForm() {
          obj.growerBoxes = obj.growerBoxes.filter(function (item) {
            return item._KEY !== growerBox;
          });
          if (obj.growerBox === growerBox) {
            obj.growerBox = null;
            obj.bunches_in_box = null;
            obj.percentage = null;
          }
        };

        obj.isAddingBox = true;

        var query1 = common.sbx.with('masterlist_grower_box').setPage(1).andWhereIsEqual('grower_box', growerBox).andWhereIsEqual('masterlist', config.masterlist._KEY).setPageSize(1).compile();

        common.method.query(common.urls.find, query1).then(function () {
          var response = common.response.post_query.data;
          if (!response.success) {
            obj.isAddingBox = false;
            alertify.error('The box could not be added, please try again.');
            return;
          }
          if (response.results.length > 0) {
            alertify.success('Box added successfully');
            clearForm();
            obj.isAddingBox = false;
            obj.loadMasterlistGrowerBoxes();
          } else {
            var newMasterlistBox = {
              grower_box: growerBox,
              bunches_in_box: bunchesInBox >= 0 ? bunchesInBox : null,
              bunch_percentage: percentage ? parseFloat(percentage) : null,
              masterlist: config.masterlist._KEY
            };

            var query = common.sbx.insert('masterlist_grower_box', newMasterlistBox);

            common.method.query(common.urls.row, query).then(function () {
              var res = common.response.post_query.data;
              obj.isAddingBox = false;
              if (res.success) {
                clearForm();
                obj.loadMasterlistGrowerBoxes();
                alertify.success('Box added successfully');
              } else {
                alertify.error(res.error || 'The box could not be added, please try again.');
              }
            });
          }
        });
      } else {
        if (!obj.growerBox) {
          alertify.error('Please fill the box.');
        } else {
          alertify.error('Please fill the box percentage or bunches in box');
        }
      }
    };

    obj.handleFullBox = function (item) {

      var newBoxes = obj.masterlistGrowerBoxes.map(function (it) {
        return {
          _KEY: it._KEY,
          full_box: item._KEY === it._KEY
        };
      });

      obj.full_box_selected = item._KEY;

      var query = common.sbx.insert('masterlist_grower_box', newBoxes);

      common.method.query(common.urls.update, query).then(function () {
        var res = common.response.post_query.data;
        if (res.success) {
          obj.loadMasterlistGrowerBoxes();
          alertify.success('Full box updated successfully');
        } else {
          alertify.error(res.error);
        }
      });
    };

    obj.removeMasterlistBox = function (item) {
      // common.confirmModal({
      //   title: 'Remove box',
      //   msj: 'Are you sure to remove this box?',
      //   saveText: 'Yes',
      //   cancelText: 'No',
      //   size: 'sm'
      // }, function () {
      var deleteMasterlistBox = {
        'domain': common.actual_domain,
        'row_model': 'masterlist_grower_box',
        'where': {
          'keys': [item._KEY]
        }
      };
      obj.isLoading = true;
      common.method.query(common.urls.delete, deleteMasterlistBox).then(function () {

        var res = common.response.post_query.data;

        if (res.success) {
          obj.isLoading = obj.isSaving;
          obj.loadMasterlistGrowerBoxes();
          alertify.success('The box has been successfully removed');
          // obj.close()
        } else {
          obj.isLoading = obj.isSaving;
          alertify.error('The claim could not be unlocked');
        }
      });
      // })
    };

    obj.boxConfig = {
      create: false,
      highlight: true,
      valueField: '_KEY',
      delimiter: '|',
      searchField: ['box_name'],
      placeholder: 'Select box',
      maxItems: 1,
      render: {
        option: function option(data, escape) {
          return '<div class="option">' + '<span class="title">' + escape(data.box_name) + '</span>' + '</div>';
        },
        item: function item(data, escape) {
          return '<div class="item">' + '<span class="item">' + escape(data.box_name) + '</span>' + '</div>';
        }
      },
      onChange: function onChange(value) {
        // if (obj.isMixed) {
        //   obj.boxOn = value ? true : false;
        // } else {
        //   obj.showBox();
        // }
        $scope.$apply();
      }
    };

    obj.getNumber = function (num) {
      return new Array(num);
    };

    obj.loadFactors = function () {
      ps.listFactors(function (list) {
        obj.factors = list.data;
        obj.factorsMap = {};

        for (var i = 0; i < obj.factors.length; i++) {
          if (obj.factors[i].carrier.carrier !== 'Fedex') {
            continue;
          }
          if (!obj.factorsMap[obj.factors[i].country._KEY]) {
            obj.factorsMap[obj.factors[i].country._KEY] = [obj.factors[i]];
          } else {
            obj.factorsMap[obj.factors[i].country._KEY].push(obj.factors[i]);
          }
        }
      }, function (err) {
        alertify.error(err);
      });
    };

    obj.loadStems = function () {
      ps.listStemsPerBunch(function (stems) {
        obj.stems = $filter('orderBy')(stems.data, 'index_order');
        obj.stemsMap = common.toMap(obj.stems, 'stems', '_KEY');
      }, function (err) {
        alertify.error(err);
      });
    };

    obj.stemConfig = {
      create: false,
      highlight: true,
      valueField: '_KEY',
      delimiter: '|',
      searchField: ['stems_per_bunch'],
      placeholder: 'Select Stems',
      maxItems: 1,
      render: {
        option: function option(data, escape) {
          return '<div class="option">' + '<span class="title">' + escape(data.stems_per_bunch) + '</span>' + '</div>';
        },
        item: function item(data, escape) {
          return '<div class="item">' + '<span class="item">' + escape(data.stems_per_bunch) + '</span>' + '</div>';
        }
      },
      onLoad: function onLoad() {
        console.log('here');
      }
    };

    obj.loadGrades = function () {

      ps.listGrades(function (grades) {
        obj.grades = grades.all;
      }, function (err) {
        alertify.error(err);
      });
    };

    obj.gradeConfig = {
      create: false,
      highlight: true,
      valueField: '_KEY',
      delimiter: '|',
      searchField: ['grade', 'grade_type'],
      placeholder: 'Select Grade',
      maxItems: 1,
      render: {
        option: function option(data, escape) {
          return '<div class="option">' + '<span class="title">' + escape(data.grade) + ' (' + escape(data.grade_type) + ')' + '</span>' + '</div>';
        },
        item: function item(data, escape) {
          return '<div class="item">' + '<span class="item">' + escape(data.grade) + '</span>' + '</div>';
        }
      },
      onInitialize: function onInitialize(selectize) {
        // Keep a reference to refresh options and set values programmatically
        obj.gradesSelectize = selectize;
      },
      onChange: function onChange(value) {
        var selectedGrade = obj.gradeOptions.find(function (g) {
          return g._KEY === value;
        });

        if (selectedGrade) {
          obj.grade_type = selectedGrade.grade_type;
        } else {
          obj.grade_type = '';
        }
        obj.grade = value;
        $scope.$applyAsync();
      }
    };

    obj.loadUoM = function () {

      gs.uomList(function (units) {
        obj.uoms = $filter('orderBy')(units.data, 'index_order');
      }, function (err) {
        alertify.error(err);
      });
    };

    obj.close = function () {
      $uibModalInstance.dismiss();
    };
    // edit save
    obj.save = function () {

      if (obj.isSaving) {
        return;
      }

      var valid = true,
          msg = '';

      $scope.$broadcast('show-errors-check-validity');
      if (obj.adminForm.$invalid) {
        obj.isLoading = false;
        valid = false;
        alertify.error('There are invalid fields');
        return;
      }

      if (obj.uom.uom == 'stem') {
        if (obj.units % obj.stemsMap[obj.stems_num].stems_per_bunch > 0) {
          valid = false;
          msg = 'the number of units must be multiple of the number of stems.';
        }
      }

      if (obj.weight == 0) {
        valid = false;
        msg = 'You must provide the actual weight of the box';
      }

      if (valid) {

        if (obj.uom.uom == 'stem') {
          obj.bunches_in_box = (parseInt(obj.units) / parseInt(obj.stemsMap[obj.stems_num].stems_per_bunch)).toFixed(0);
        } else {
          obj.bunches_in_box = obj.units;
        }

        var row = {
          _KEY: obj.config._KEY,
          length: obj.length || 0,
          grade: obj.grade === 'NONE' ? null : obj.grade,
          UoM: obj.uom._KEY,
          stems_per_bunch: obj.stems_num,
          units: obj.units,
          actual_weight: obj.weight,
          box_charge: obj.charge.value,
          grower: common.getUserData().grower,
          order_in_advance: obj.order_in_advance,
          bunches_in_box: obj.bunches_in_box,
          grower_code: obj.grower_code,
          customizable: obj.customizable,
          custom_percentage: obj.custom_percentage,
          prod_weight: obj.prod_weight && obj.prod_weight >= 0 ? parseFloat(obj.prod_weight) / 1000 : null,
          length_padding: obj.length_padding && obj.length_padding >= 0 ? parseInt(obj.length_padding) : 0,
          prod_weight_padding_enabled: obj.prod_weight_padding_enabled ? obj.prod_weight_padding_enabled : false,
          origin_country: obj.origin_country
        };

        obj.isLoading = true;
        obj.isSaving = true;

        productSrv.saveMasterlist([row], function () {
          alertify.success('Masterlist Updated');
          $uibModalInstance.close(true);
        }, function (error) {
          obj.isSaving = false;
          obj.isLoading = false;
          alertify.error(error && error.message ? error.message : error);
        });
      } else {
        alertify.error(msg);
      }
    };

    init();
  }
})(angular);
//# sourceMappingURL=growerMasterlistEditCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('growerPicturesCtrl', ['$scope', 'alertify', 'FileUploader', '$timeout', 'commonSrv', 'floristSrv', '$uibModal', growerPicturesCtrl]).controller('growerAdminPicture', ['$scope', 'alertify', '$uibModalInstance', 'FileUploader', 'commonSrv', 'config', '$filter', 'growerSrv', growerAdminPicture]);

  function growerPicturesCtrl($scope, alertify, FileUploader, $timeout, commonSrv, floristSrv, $uibModal) {
    var obj = this,
        common = commonSrv;

    obj.keys = Object.keys;
    obj.varietyResults = [];
    obj.target_folder = null;
    obj.variety_el = null;
    obj.variety = null;
    obj.isLoading = true;
    obj.reload = false;
    obj.showNoPictures = false;
    obj.op = {
      system_picture: 1,
      your_picture: 2
    };
    obj.productConfig = {
      create: false,
      highlight: true,
      valueField: '_KEY',
      delimiter: '|',
      searchField: ['common_name', 'category', 'botanical_name'],
      placeholder: 'Select Product Group',
      maxItems: 1,
      render: {
        option: function option(data, escape) {
          return '<div class="option">' + '<span class="title">' + escape(data.common_name) + '</span>' + '</div>';
        },
        item: function item(data, escape) {
          return '<div class="item">' + '<span class="item">' + escape(data.common_name) + '</span>' + '</div>';
        }
      }
    };

    obj.imageError = function (variety) {
      if (!variety.no_image) {
        variety.no_image = true;
      }
    };

    function init() {
      obj.loadMasterlists();
      obj.selectedOption = '';
      obj.selectedNoPicture = '';
    }

    obj.openModal = function (variety) {
      var variety_el = document.getElementById(variety._KEY);
      if (variety_el) {
        obj.variety_el = variety_el;
        obj.variety = variety;
      }
      var modalInstance = $uibModal.open({
        templateUrl: 'views/grower/grower.images.modal.html',
        controller: 'growerAdminPicture',
        controllerAs: 'obj',
        bindToController: true,
        size: 'md',
        resolve: {
          config: function config() {
            return {
              variety: angular.copy(variety),
              folder: obj.target_folder
            };
          }
        }
      });
      modalInstance.result.then(function (reload) {
        if (reload) {
          //obj.loadMasterlists();
          obj.reload = reload;
          obj.selectedNoPicture = '';
          if (obj.variety_el) {
            var variety_c = obj.varieties.find(function (variety) {
              return variety._KEY === obj.variety._KEY;
            });
            variety_c.image = common.actual_base_url + '/growers/' + common.getUserData().grower + '/variety_' + obj.variety._KEY + '.jpg' + '?cb=' + new Date().getTime();
            variety_c.no_image = false;
            variety_c.custom = true;

            var scrollFun = function scrollFun() {
              return new Promise(function (resolve) {
                obj.scrollToElement(obj.variety_el, resolve);
              });
            };

            var listFun = function listFun() {
              return new Promise(function (resolve) {
                obj.filterList(resolve);
              });
            };

            var loadVarieties = function loadVarieties() {
              Promise.resolve(listFun()).then(function (res) {
                Promise.resolve(scrollFun()).then(function (res) {});
              });
            };

            loadVarieties();
          }
        }
      });
    };

    obj.filterByNoPicture = function () {

      if (obj.selectedNoPicture) {
        obj.varietyResults = obj.varieties.filter(function (item) {
          var condition = false;
          if (obj.product) {
            condition = item.product_group._KEY === obj.product;
          }
          return condition && item.no_image === true;
        }).sortByVariety();
      } else {
        obj.varietyResults = obj.varieties.filter(function (item) {
          var condition = false;
          if (obj.product) {
            condition = item.product_group._KEY === obj.product;
          }
          return condition;
        }).sortByVariety();
      }

      setTimeout(function () {
        obj.showNoPictures = true;
      }, 2000);
    };

    obj.scrollToElement = function (variety_element, cb) {
      if (variety_element) {
        var bodyRect = document.body.getBoundingClientRect(),
            elemRect = variety_element.getBoundingClientRect(),
            offset = elemRect.top - bodyRect.top;

        window.scroll(0, offset - 200);

        variety_element.classList.add('shadow-yellow');

        setTimeout(function () {
          variety_element.classList.remove('shadow-yellow');
        }, 1000);
      }
      cb();
      obj.reload = false;
    };

    obj.filterList = function (cb) {
      obj.selectedNoPicture = '';

      obj.varietyResults = obj.varieties.filter(function (item) {
        var condition = false;
        if (obj.product) {
          condition = item.product_group._KEY === obj.product;
        }
        if (condition) {
          console.log(item);
        }

        return condition && (item.custom && obj.selectedOption === 'custom' || !item.custom && obj.selectedOption === 'regular' || obj.selectedOption === '');
      }).sortByVariety();

      setTimeout(function () {
        obj.showNoPictures = true;
      }, 2000);

      if (cb) {
        cb();
      }
    };

    obj.loadMasterlists = function () {
      var query = commonSrv.sbx.with('add_masterlist').andWhereIsEqual('grower', common.getUserData().grower).fetchModels(['variety', 'variety.product_group', 'variety.color', 'box']).compile();

      async.waterfall([function (cb) {
        common.loadAllPages(query, function (response) {
          if (response.results.length) {
            obj.products = [];
            obj.varieties = [];
            obj.colors = [];
            obj.varietyResults = [];
            obj.resProducts = response.fetched_results.product_group;
            obj.resVarieties = response.fetched_results.variety;
            obj.resColors = response.fetched_results.color;

            Object.keys(obj.resProducts).forEach(function (key) {
              obj.products.push(obj.resProducts[key]);
            });

            obj.products.sort(function (a, b) {
              return a.common_name.localeCompare(b.common_name);
            });
            obj.varieties.sort(function (a, b) {
              return a.variety_name.localeCompare(b.variety_name);
            });

            obj.varieties = Object.keys(obj.resVarieties).map(function (key) {
              var variety = obj.resVarieties[key];
              variety.masterlists = response.results.filter(function (item) {
                return item.variety === variety._KEY;
              });
              variety.custom = variety.masterlists[0].custom_photo;
              variety.extras = variety.masterlists[0].extra_photos;
              variety.external = variety.masterlists[0].external_photo;
              if (variety.custom) {
                variety.image = common.actual_base_url + '/growers/' + common.getUserData().grower + '/variety_' + variety._KEY + '.jpg' + '?cb=' + new Date().getTime();
              } else {
                variety.image = common.actual_base_url + '/varieties/variety_' + variety._KEY + '.jpg' + '?cb=' + new Date().getTime();
              }
              variety.color = obj.resColors[variety.color];
              variety.product_group = obj.resProducts[variety.product_group];
              return variety;
            });
            cb(null, {});
          }
        }, function () {
          cb('Error loading masterlist.');
        });
      }, function (box, cb) {
        floristSrv.folderList({ key: common.growers_folder_key }, function (data) {
          var folder = data.find(function (item) {
            return item.name === common.getUserData().grower;
          });
          cb(null, folder);
        }, function () {
          cb('Error loading folder, try again.');
        });
      }, function (folder, cb) {
        if (folder) {
          obj.target_folder = folder.key;
          cb(null, {});
        } else {
          common.method.post(common.urls.addFolder, {
            parent_key: common.growers_folder_key,
            name: common.getUserData().grower
          }).then(function () {
            var response = common.response.post.data;
            if (response.success) {
              obj.target_folder = response.folder.key;
              cb(null, {});
            } else {
              cb('Error loading folder, try again.');
            }
          });
        }
      }], function (err, box) {
        if (err) {
          alertify.error(err);
        }
        obj.filterList();
        obj.isLoading = false;
      });
    };

    init();
  }

  function growerAdminPicture($scope, alertify, $uibModalInstance, FileUploader, commonSrv, config, $filter, growerSrv) {
    var obj = this,
        common = commonSrv;
    obj.uploader = new FileUploader();
    obj.tempImage = '';
    obj.uploadText = '';
    obj.reload = false;
    obj.variety_el = null;

    function init() {
      obj.fileUploading = false;
      obj.variety = config.variety;
      obj.folder = config.folder;
      obj.photos = [{ url: obj.thumbnail(''), selected: false }];
      if (obj.variety.extras) {
        obj.variety.extras.split(',').forEach(function (item) {
          obj.photos.push({ url: obj.thumbnail(item), selected: false });
        });
      } else {
        obj.variety.extras = '';
      }
      if (obj.variety.custom && obj.photos.length < 5) {
        obj.photos.push({ url: obj.thumbnail('-extra' + obj.photos.length), selected: false });
      }
      obj.photos[obj.photos.length - 1].selected = true;

      console.log(obj.variety);
      console.log(obj.photos);

      obj.setUploadText();
    }

    $scope.fileAdded = function (input) {
      obj.tempImage = URL.createObjectURL(input.files[0]);
      obj.setUploadText();
    };

    obj.setUploadText = function () {
      var text = 'default';
      var index = obj.photos.findIndex(function (photo) {
        return photo.selected;
      });
      if (index) {
        text = 'image ' + index;
      }
      obj.uploadText = 'Upload ' + text;
    };

    obj.close = function () {
      $uibModalInstance.close(obj.reload);
    };

    obj.thumbnail = function (key) {
      return common.actual_base_url + '/growers/' + common.getUserData().grower + '/variety_' + obj.variety._KEY + key + '.jpg?cb=' + new Date().getTime();
    };

    obj.showDelete = function (index) {
      return obj.photos.some(function (i) {
        return i.indexOf('extra' + index) !== -1;
      });
    };

    obj.selectPhoto = function (index) {
      obj.photos.forEach(function (item) {
        item.selected = false;
      });
      obj.photos[index].selected = true;
      obj.setUploadText();
    };

    obj.saveExternalPhoto = function () {
      var updateList = obj.variety.masterlists.map(function (ml) {
        return { _KEY: ml._KEY, external_photo: obj.variety.external };
      });
      obj.variety.custom = true;
      obj.variety.extras = updateList[0].extra_photos;
      var query = common.sbx.insert('add_masterlist', updateList);

      common.method.update(query).then(function (data) {
        console.log(data);
        if (data.success) {
          alertify.success('External photo saved successfully.');
          obj.reload = true;
        } else {
          alertify.error('An error has occurred, please try again.');
        }
      });
    };

    obj.uploadFile = function () {
      obj.reload = true;
      obj.loading = true;
      var key = '';
      var index = obj.photos.findIndex(function (photo) {
        return photo.selected;
      });
      if (index) {
        key = '-extra' + index;
      }
      var myBlob = common.dataURItoBlob(obj.myFile.compressed.dataURL);
      var myFile = new File([myBlob], 'name.jpg');
      console.log(myBlob);
      console.log(myFile);

      var fd = new FormData();
      fd.append('file', myFile, 'variety_' + obj.variety._KEY + key + '.jpg');
      fd.append('model', JSON.stringify({ key: obj.folder }));

      async.waterfall([function (cb) {
        growerSrv.uploadFileToUrl(fd, function (res) {
          if (res) {
            cb(null, {});
          } else {
            cb('An error has occurred, please try again.', {});
          }
        });
      }, function (box, cb) {
        var updateList = obj.variety.masterlists.map(function (ml) {
          var extras = ml.extra_photos || '';
          if (key) {
            if (extras.indexOf(key) === -1) {
              extras += !extras ? '' + key : ',' + key;
            }
          }
          ml.extra_photos = extras;
          return { _KEY: ml._KEY, custom_photo: true, extra_photos: extras };
        });

        obj.variety.extras = updateList[0].extra_photos;
        var query = common.sbx.insert('add_masterlist', updateList);

        common.method.update(query).then(function (data) {
          console.log(data);
          if (data.success) {
            cb(null, {});
          } else {
            cb('An error has occurred, please try again.', {});
          }
        });
      }], function (err, box) {
        if (err) {
          alertify.error(err);
        } else {
          init();
        }
        obj.loading = false;
      });
    };

    init();
  }
})(angular);
//# sourceMappingURL=growerPicturesCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('growerCostumersCtrl', ['$scope', 'alertify', 'commonSrv', 'sessionSrv', 'floristSrv', 'growerSrv', growerCostumersCtrl]);

  function growerCostumersCtrl($scope, alertify, commonSrv, sessionSrv, floristSrv, growerSrv) {
    var obj = this,
        common = commonSrv,
        gs = growerSrv,
        fs = floristSrv;

    obj.isLoading = true;
    obj.optionsFilter = [{ id: 1, type: 'customer' }, { id: 2, type: 'state' }, { id: 3, type: 'city' }, { id: 4, type: 'status' }];

    obj.filterConfig = {
      create: false,
      highlight: true,
      valueField: 'id',
      delimiter: '|',
      searchField: ['type'],
      placeholder: 'Filter by',
      maxItems: 1,
      render: {
        option: function option(data, escape) {
          return '<div class="option">' + '<span class="title">' + escape(data.type) + '</span>' + '</div>';
        },
        item: function item(data, escape) {
          return '<div class="item">' + '<span class="item">' + escape(data.type) + '</span>' + '</div>';
        }
      }
    };

    obj.list = [];

    function init() {
      obj.load();
    }

    obj.load = function () {
      obj.isLoading = true;
      gs.getCustomersRelated(function (data) {
        obj.list = data;
        obj.isLoading = false;
      }, function (e) {
        obj.isLoading = false;
        alertify.error(e);
      });
    };

    obj.getImage = function (item) {
      if (item.country.country_iso) {
        return common.actual_base_url + '/flags/' + item.country.country_iso + '_flag.png';
      }
      return null;
    };

    obj.fixEmpty = function () {
      if (!obj.filter.country._KEY) {
        delete obj.filter.country;
      }
    };

    obj.changeStatus = function (item, block) {
      obj.isLoading = true;
      gs.changeCustomerGrowerStatus(item.customer._KEY, block, function () {
        var msj = block ? 'has been block' : 'has been activated';
        alertify.success(item.customer.company_name + ' ' + msj);
        obj.load();
      }, function (err) {
        obj.isLoading = false;
        alertify.error(err);
      });
    };

    init();
  }
})(angular);
//# sourceMappingURL=growerCostumersCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('growerBenchmarkCtrl', ['$scope', 'alertify', 'commonSrv', growerBenchmarkCtrl]);

  function growerBenchmarkCtrl($scope, alertify, commonSrv) {

    var obj = this,
        common = commonSrv;
  }
})(angular);
//# sourceMappingURL=growerBenchmarkCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('growerClaimsCtrl', ['$scope', 'alertify', '$state', '$stateParams', 'commonSrv', 'sessionSrv', growerClaimsCtrl]);

  function growerClaimsCtrl($scope, alertify, $state, $stateParams, commonSrv, sessionSrv) {

    var content = this,
        common = commonSrv;

    content.isCurrent = function (name) {
      return $state.is('grower.claims.' + name);
    };

    content.include = function (name) {
      return $state.includes('grower.claims.' + name);
    };

    function init() {}

    init();
  }
})(angular);
//# sourceMappingURL=growerClaimsCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('growerClaimsPendingCtrl', ['$scope', 'alertify', '$state', '$stateParams', 'commonSrv', 'sessionSrv', 'floristSrv', 'productSrv', growerClaimsPendingCtrl]).controller('growerClaimDetailCtrl', ['$scope', 'alertify', '$state', '$stateParams', 'commonSrv', 'sessionSrv', 'floristSrv', 'adminSrv', growerClaimDetailCtrl]);

  function growerClaimsPendingCtrl($scope, alertify, $state, $stateParams, commonSrv, sessionSrv, floristSrv, productSrv) {

    var obj = this,
        common = commonSrv,
        ps = productSrv,
        fs = floristSrv;
    obj.isLoading = false;
    function init() {
      obj.getClaims();
    }

    obj.getClaims = function () {
      obj.isLoading = true;
      fs.getClaims('Pending', 'all', function (data) {
        obj.claims = data.sort(function (a, b) {
          return common.convertDateToNumberDate(b.claim_dated) - common.convertDateToNumberDate(a.claim_dated);
        });
        console.log(obj.claims);
        obj.isLoading = false;
      }, function (e) {
        alertify.error(e);
        obj.isLoading = false;
      });
    };

    obj.setClaimState = function (claim, status) {
      obj.isLoading = true;
      console.log("claim", claim);
      fs.setClaimStatus(status, claim, function () {

        obj.isLoading = false;
        alertify.success('Request Claim Updated');
        var cc_mail = null;

        if (claim.cart_box.customer.acc_manager) {
          cc_mail = claim.cart_box.customer.acc_manager;
        }
        var customer_claim = {
          'subject': 'Hi ' + claim.cart_box.customer.company_name + ', ' + common.getUserData().grower_name + ' has responded to your claim via iBuyFlowers.com',
          'to': claim.cart_box.customer.office_email,
          'cc': cc_mail,
          'bcc': 'customerservice@ibuyflowers.com,carloscoral@ibuyflowers.com',
          'domain': common.actual_domain,
          'from': cc_mail ? cc_mail : 'customerservice@Ibuyflowers.com',
          'template_key': common.response_claim_mail,
          'data': {
            'customer': claim.cart_box.customer.company_name,
            'order_consecutive': claim.cart_box.consecutive,
            'grower': common.getUserData().grower_name,
            'claim_number': claim.consecutive,
            'amount': claim.total_claim.toFixed(2),
            'reason': claim.comments,
            'status': status === 'Accepted' ? 'accepted' : 'denied'
          }

        };
        common.method.send_mail(customer_claim).then(function (res) {
          if (res.success) {
            console.log('Customer claim response email sent !!!');
          }
        });
        obj.getClaims();
      }, function (error) {
        alertify.error(error);
      });
    };

    init();
  }

  function growerClaimDetailCtrl($scope, alertify, $state, $stateParams, commonSrv, sessionSrv, floristSrv, adminSrv) {
    var obj = this,
        common = commonSrv,
        fs = floristSrv;

    function init() {
      obj.key = $stateParams.key;
      obj.getClaims();
    }

    obj.getClaims = function () {
      adminSrv.getClaims(obj.key, '=', null, null, function (data) {

        obj.claim = data[0];
        obj.claim.total_claim = obj.claim.total_claim_grower;
        fs.getClaimReasons(obj.claim._KEY, function (data) {
          obj.claim_reasons = data;
        }, function (e) {
          alertify.error(e);
        });
        console.log(obj.claim);
      }, function (e) {
        alertify.error(e);
      });
    };

    obj.setClaimState = function (status) {
      if (obj.isLoading) {
        return;
      }

      obj.isLoading = true;
      fs.setClaimStatus(status, obj.claim, function () {
        obj.isLoading = false;
        alertify.success('Request Claim Updated');
        $state.go('grower.claims.pending.list');
      }, function (error) {
        alertify.error(error);
      });
    };

    init();
  }
})(angular);
//# sourceMappingURL=growerClaimsPendingCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('growerClaimsSettledCtrl', ['$scope', 'alertify', '$state', '$stateParams', 'commonSrv', 'sessionSrv', 'floristSrv', 'productSrv', growerClaimsSettledCtrl]).controller('growerClaimSettleDetailCtrl', ['$scope', 'alertify', '$state', '$stateParams', 'commonSrv', 'sessionSrv', 'floristSrv', 'adminSrv', growerClaimSettleDetailCtrl]);

  function growerClaimsSettledCtrl($scope, alertify, $state, $stateParams, commonSrv, sessionSrv, floristSrv, productSrv) {

    var obj = this,
        common = commonSrv,
        fs = floristSrv;
    obj.isLoading = false;

    function init() {
      obj.getClaims();
    }

    obj.getClaims = function () {
      obj.isLoading = true;
      fs.getClaims(null, 'all', function (data) {
        obj.claims = data.sort(function (a, b) {
          return common.convertDateToNumberDate(b.settle_date) - common.convertDateToNumberDate(a.settle_date);
        });

        obj.isLoading = false;
      }, function (e) {
        alertify.error(e);
        obj.isLoading = false;
      });
    };

    init();
  }

  function growerClaimSettleDetailCtrl($scope, alertify, $state, $stateParams, commonSrv, sessionSrv, floristSrv, adminSrv) {
    var obj = this,
        common = commonSrv,
        fs = floristSrv;

    function init() {
      obj.key = $stateParams.key;
      obj.getClaims();
    }

    obj.getClaims = function () {
      adminSrv.getClaims(obj.key, '!=', null, null, function (data) {
        obj.claim = data[0];
        obj.claim.total_claim = obj.claim.total_claim_grower;
        fs.getClaimReasons(obj.claim._KEY, function (data) {
          obj.claim_reasons = data;
        }, function (e) {
          alertify.error(e);
        });
      }, function (e) {
        alertify.error(e);
      });
    };

    init();
  }
})(angular);
//# sourceMappingURL=growerClaimsSettledCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('growerPurchaseDetailCtrl', ['$scope', 'alertify', 'commonSrv', 'productSrv', 'growerSrv', '$state', 'floristSrv', '$stateParams', growerPurchaseDetailCtrl]);

  function growerPurchaseDetailCtrl($scope, alertify, commonSrv, productSrv, growerSrv, $state, floristSrv, $stateParams) {
    var obj = this,
        common = commonSrv,
        florist = floristSrv;
    var countryMap = {};
    obj.total_bunches = 0;
    obj.total_prices = 0;
    obj.notReady = true;
    obj.callFinish = [false, false];

    function init() {
      obj.loadCountries();
      obj.loadCartbox();
      obj.loadPurchase();
    }

    obj.getImage = function (item) {
      var country = countryMap[item.grower.country];
      if (country) {
        return common.actual_base_url + '/flags/' + country.country_iso + '_flag.png';
      }
      return null;
    };

    obj.loadCountries = function () {
      florist.getCountriesList(function (data) {
        angular.forEach(data.results, function (item) {
          countryMap[item._KEY] = item;
        });
        obj.countries = data.results;
      }, function (err) {
        alertify.error(err);
      });
    };

    obj.loadPurchase = function () {
      florist.getPurchaseOrder($stateParams.purchaseId, function (data) {
        obj.info = data.results[0];
      });
    };

    obj.loadCartbox = function () {
      var temp = [];
      var total_bunches = 0;
      var total_boxes = 0;
      florist.getOrdersByRole($stateParams.purchaseId, function (res) {
        angular.forEach(res, function (item) {
          for (var i = 0; i < item.cartboxes.length; i++) {
            total_bunches = total_bunches + parseInt(item.cartboxes[i].current_items);
          }
          total_boxes += item.cartboxes.length;
          obj.total_prices += parseFloat(item.total);
        });

        obj.total_boxes = total_boxes;
        obj.total_bunches = total_bunches;
        obj.orders = res;
      }, common.onErrorDefault);
    };

    obj.showDetail = function (cartbox) {
      var modalInstance = florist.showDetailCartBox({
        cartbox: cartbox
      });
    };

    init();
  }
})(angular);
//# sourceMappingURL=growerPurchaseOrdersCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('growerOrdersCtrl', ['$scope', 'alertify', 'commonSrv', 'productSrv', 'growerSrv', '$state', '$filter', 'floristSrv', growerOrdersCtrl]);

  function growerOrdersCtrl($scope, alertify, commonSrv, productSrv, growerSrv, $state, $filter, floristSrv) {
    var obj = this,
        common = commonSrv,
        ps = productSrv,
        gs = growerSrv,
        fs = floristSrv;

    obj.isCurrent = function (name) {
      return $state.is('grower.orders.' + name);
    };

    obj.include = function (name) {
      return $state.includes('grower.orders.' + name);
    };
  }
})(angular);
//# sourceMappingURL=growerOrdersCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('growerOrdersCancelledCtrl', ['$scope', 'alertify', 'commonSrv', 'productSrv', 'growerSrv', '$state', '$filter', 'floristSrv', growerOrdersCancelledCtrl]);

  function growerOrdersCancelledCtrl($scope, alertify, commonSrv, productSrv, growerSrv, $state, $filter, floristSrv) {
    var obj = this,
        common = commonSrv,
        ps = productSrv,
        gs = growerSrv,
        fs = floristSrv;
    obj.orders = [];
    obj.filteredOrders = [];
    obj.isLoading = false;
    obj.totalItems = 0;
    obj.currentPage = 1;
    obj.itemsPerPage = 20;
    obj.searchText = '';

    function init() {
      obj.getCancelledOrders();
    }

    obj.getCancelledOrders = function () {
      obj.isLoading = true;
      gs.getCancelledOrders(function (data) {
        obj.orders = data;
        obj.filteredOrders = data;
        obj.totalItems = obj.filteredOrders.length;
        obj.isLoading = false;
        obj.filterList();
      }, function (err) {
        alertify.error(err);
        obj.isLoading = false;
      });
    };

    obj.filterList = function () {
      obj.filteredOrders = $filter('filter')(obj.orders, function (value) {
        var nameCustomer = value.customer.company_name.toLowerCase();
        var consecutive = String(value.consecutive);
        var productGroup = value.product_group.common_name.toLowerCase();
        var variety = value.variety ? value.variety.variety_name : '';

        return nameCustomer.indexOf(obj.searchText.toLowerCase()) !== -1 || consecutive.indexOf(obj.searchText.toLowerCase()) !== -1 || productGroup.indexOf(obj.searchText.toLowerCase()) !== -1 || variety.toLowerCase().indexOf(obj.searchText.toLowerCase()) !== -1;
      });

      obj.totalItems = obj.filteredOrders.length;
      obj.currentPage = 1;
    };

    init();
  }
})(angular);
//# sourceMappingURL=growerOrdersCancelledCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('growerOrderRequestCtrl', ['$state', growerOrderRequestCtrl]);

  function growerOrderRequestCtrl($state) {
    var obj = this;

    obj.isCurrent = function (name) {
      return $state.is('grower.order_request.' + name);
    };

    obj.include = function (name) {
      return $state.includes('grower.order_request.' + name);
    };
  }
})(angular);
//# sourceMappingURL=growerOrderRequestCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('growerOrderRequestOpenCtrl', ['$scope', 'alertify', 'commonSrv', 'productSrv', 'growerSrv', '$state', '$filter', 'floristSrv', 'FileSaver', 'Blob', '$uibModal', growerOrderRequestOpenCtrl]);

  function growerOrderRequestOpenCtrl($scope, alertify, commonSrv, productSrv, growerSrv, $state, $filter, floristSrv, FileSaver, Blob, $uibModal) {
    var obj = this,
        common = commonSrv,
        ps = productSrv,
        gs = growerSrv,
        fs = floristSrv;
    obj.orderRequestItems = [];
    obj.isLoading = false;
    obj.intervals = [];
    obj.masterlistsMap = {};
    obj.format = 'dd-MMMM-yyyy';
    obj.altInputFormats = ['M!/d!/yyyy'];
    var INVALID_CLASS = 'invalid-input';

    obj.onChangePrice = function (item) {
      var input = document.getElementById('price-' + item._KEY);
      if (input.classList.contains(INVALID_CLASS)) {
        input.classList.remove(INVALID_CLASS);
      }
    };

    obj.getCountDownInterval = function (OR) {
      var x = setInterval(function () {
        var countDownDate = new Date(OR.created_at).getTime() + OR.waiting_time * 60000;
        var now = new Date().getTime();
        var distance = countDownDate - now;

        // Time calculations for days, hours, minutes and seconds
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
        var minutes = Math.floor(distance % (1000 * 60 * 60) / (1000 * 60));
        var seconds = Math.floor(distance % (1000 * 60) / 1000);

        // If the count down is finished, write some text
        if (distance < 0) {
          clearInterval(x);
          document.getElementById('or_' + OR._KEY).innerHTML = 'Expired';
        } else {
          if (!document.getElementById('or_' + OR._KEY)) {
            clearInterval(x);
          } else {
            document.getElementById('or_' + OR._KEY).innerHTML = days + 'd ' + hours + 'h ' + minutes + 'm ' + seconds + 's ';
          }
        }
      }, 1000);
      obj.intervals.push(x);
    };

    obj.clearIntervals = function () {
      obj.intervals.forEach(function (f) {
        clearInterval(f);
      });
    };

    obj.changeMasterlist = function (or) {
      var select = obj.masterlistsMap[or.masterlist];
      select.customizable = select.customizable && !select.variety.box_only;
      var stems_per_bunch = select.stems_per_bunch.stems_per_bunch,
          bunches_in_box = select.bunches_in_box;

      if (select.customizable) {
        or.optionsQuantity = obj.genOptIsCustomizable(or.quantity, 0, stems_per_bunch, [], 0, true);
      } else {
        or.optionsQuantity = obj.genOptIsCustomizable(or.quantity, 0, select.variety.box_only ? 1 : stems_per_bunch * bunches_in_box, [], 0, false);
      }

      if (!or.optionsQuantity.some(function (oq) {
        return parseInt(oq.quantity) === parseInt(or.order_request_bid.quantity);
      })) {
        or.order_request_bid.quantity = or.optionsQuantity[or.optionsQuantity.length - 1].quantity;
      }
    };

    obj.genOptIsCustomizable = function (quantity, start, stb, result, index, cus) {
      if (start < quantity) {
        index++;
        start = start + stb;
        result.push({
          quantity: start,
          label: start + ' ' + (start === 10 ? 'Stem' : 'Stems') + ' (' + index + ' ' + (index === 1 ? cus ? 'Bunch' : 'Box' : cus ? 'Bunches' : 'Boxes') + ')'
        });
        return obj.genOptIsCustomizable(quantity, start, stb, result, index, cus);
      } else {
        return result;
      }
    };

    obj.masterlistConfig = {
      create: false,
      highlight: true,
      valueField: '_KEY',
      delimiter: '|',
      sortField: 'name',
      searchField: ['name'],
      placeholder: 'Select Masterlist',
      maxItems: 1,
      render: {
        option: function option(data) {
          return '<div class="option"><span class="title">' + data.name + '</span></div>';
        },
        item: function item(data) {
          return '<div class="item"><span class="item">' + data.name + '</span></div>';
        }
      },
      onInitialize: function onInitialize(selectize) {
        obj.masterlistSelectize = selectize;
      }
    };

    obj.picker_options = {
      customClass: getPurchaseDays
    };

    obj.open = function (name, evt) {
      obj[name] = true;
      evt.preventDefault();
    };

    function getPurchaseDays(data) {
      var date = data.date,
          mode = data.mode;
      if (mode === 'day') {
        var dayToCheck = new Date(date).setHours(0, 0, 0, 0);
        if (obj.dates.some(function (item) {
          return item === common.convertDateToNumberDateWithoutTimeZone(dayToCheck);
        })) {
          return 'activeClass';
        }
      }

      return '';
    }
    obj.closeOrderRequest = function (orderRequest) {
      obj.orderRequestItems = obj.orderRequestItems.filter(function (or) {
        return or._KEY !== orderRequest;
      });
      alertify.success('Order request complete!');
    };

    obj.searchDate = function () {
      if (!obj.date) {
        return alertify.error('Pick a date');
      }
      obj.clearIntervals();
      obj.masterlistsMap = {};
      obj.currentPage = 1;
      obj.itemsPerPage = 10;
      obj.isLoading = true;
      obj.fetch(obj.date);
    };

    obj.cancel = function (ori) {
      if (ori.initial) {
        common.confirmModal({
          title: 'Decline Order Request Bid',
          msj: 'Are you sure yo want to continue?',
          saveText: 'Decline Bid',
          cancelText: 'Cancel'
        }, function () {
          gs.DeclineOrderRequest(ori, function (res) {
            obj.orderRequestItems.forEach(function (orderRequest) {
              orderRequest.items = orderRequest.items.filter(function (i) {
                return i._KEY !== ori._KEY;
              });
            });
            obj.orderRequestItems = obj.orderRequestItems.filter(function (i) {
              return i.items.length;
            });
            alertify.success('Offer declined');
            window.mixpanel.track("grower_decline_or");
            if (res.orderRequestCompleted) {
              obj.closeOrderRequest(ori.order_request);
            }
          });
        });
      } else {
        ori.editing = !ori.editing;
      }
    };
    obj.fetch = function () {
      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (date) {
        date = common.convertDateToNumberDateWithoutTimeZone(date);
      }
      gs.getOrderRequest(date, function (res) {

        obj.isPlacingBid = false;
        obj.isDeleting = false;
        obj.masterlistsMap = res.masterlistsMap;
        if (!date) {
          obj.dates = res.items.map(function (order_request) {
            return order_request.packing_date;
          });
          obj.initialLoading = false;
        }
        res.items.forEach(function (order_request) {
          if (!order_request.items) {
            order_request.items = [];
          }
          order_request.packing_date = common.convertNumberDateToDateEst(order_request.packing_date);
          obj.getCountDownInterval(order_request);
          order_request.items.forEach(function (item) {
            item.editing = item.order_request_bid._KEY && !item.order_request_bid.quantity;
            item.initial = item.editing;
            var masterlist = obj.masterlistsMap[item.order_request_bid.masterlist];
            if (masterlist) {
              item.masterlist = masterlist._KEY;
            } else {
              if (item.masterlists && item.masterlists.length) {
                item.masterlist = item.masterlists[0]._KEY;
              }
            }
            if (item.masterlist) {
              obj.changeMasterlist(item);
            }
          });
          order_request.items = order_request.items.filter(function (i) {
            return i.masterlists.length;
          });
        });
        obj.orderRequestItems = res.items.filter(function (i) {
          return i.items.length;
        });
        obj.isLoading = false;
      }, function (error) {
        obj.isLoading = false;
        return alertify.error(error.message || 'Error fetching data');
      });
    };

    obj.init = function () {
      var userData = common.getUserData().data;
      obj.isLoading = true;
      obj.initialLoading = true;
      obj.masterlistsMap = {};
      obj.currentPage = 1;
      obj.itemsPerPage = 10;
      obj.dates = [];
      obj.fetch();
    };

    obj.isDeleting = false;
    obj.deleteOrderReqBid = function (orb, ori) {
      common.confirmModal({
        title: 'Delete Order Request Bid',
        msj: 'Are you sure yo want to continue?',
        saveText: 'Delete Bid',
        cancelText: 'Cancel'
      }, function () {
        orb.isDeleting = true;
        if (!orb._KEY) {
          return alertify.error('No offers');
        }
        obj.isDeleting = true;
        var inventory = {
          kind_quantity: 0,
          _KEY: orb.inventory
        };
        growerSrv.deleteOrderReqBid(orb._KEY, inventory, ori.order_request, function (res) {
          window.mixpanel.track("grower_delete_or");
          alertify.success('offer cancelled');
          orb.price = 0;
          ori.initial = true;
          ori.editing = true;
          // orb.inventory = null;
          obj.isDeleting = false;
          orb.isDeleting = false;
          if (res.orderRequestCompleted) {
            obj.closeOrderRequest(ori.order_request);
          }
        }, function (err) {
          alertify.error('the offer could not be canceled');
          obj.isDeleting = false;
          orb.isDeleting = false;
        });
      });
    };

    obj.saveOrderRequest = function (orderReqItem) {
      if (!orderReqItem.masterlist) {
        return alertify.error('Select a masterlist');
      } else if (!orderReqItem.order_request_bid.quantity) {
        return alertify.error('Select a quantity');
      } else if (orderReqItem.order_request_bid.price <= 0) {
        alertify.error('Price must be greater than zero.');
        return input.classList.add(INVALID_CLASS);
      }

      var name = orderReqItem.masterlists.find(function (i) {
        return i._KEY === orderReqItem.masterlist;
      }).name;
      common.confirmModal({
        title: 'Save Order Request Bid',
        msj: 'You are placing a bid for: ' + name + ' ' + orderReqItem.order_request_bid.quantity + (obj.masterlistsMap[orderReqItem.masterlist].variety.box_only ? ' Boxes' : ' Stems') + ' for $' + orderReqItem.order_request_bid.price + '/Stem. Are you sure you want to continue?',
        saveText: 'Place Bid',
        cancelText: 'Cancel'
      }, function () {
        var input = document.getElementById('price-' + orderReqItem._KEY);
        var price = parseFloat(orderReqItem.order_request_bid.price.toString().replace('$', ''));
        obj.isPlacingBid = true;
        orderReqItem.isPlacingBid = true;
        var userData = common.getUserData().data;
        var ordReqBid = orderReqItem.order_request_bid;
        var orderReqBid = {
          _KEY: ordReqBid._KEY,
          inventory: ordReqBid.inventory,
          price: price,
          quantity: ordReqBid.quantity,
          order_request_item: orderReqItem._KEY,
          grower: userData.metadata.grower,
          order_request: orderReqItem.order_request,
          masterlist: orderReqItem.masterlist,
          variety: orderReqItem.variety,
          stems_per_box: obj.masterlistsMap[orderReqItem.masterlist].units,
          box_only: obj.masterlistsMap[orderReqItem.masterlist].variety.box_only
        };
        gs.addOrderReqBid(orderReqBid, function (res) {
          alertify.success('Order request bid ' + (res.action === 'insert' ? 'created' : 'edited'));
          if (res.action === 'insert') {
            ordReqBid._KEY = res.key;
            ordReqBid.inventory = res.inventory;
            window.mixpanel.track("grower_place_or", { name: name, quantity: quantity });
          } else {
            orderReqItem.editing = false;
            window.mixpanel.track("grower_edit_or", { name: name, quantity: quantity });
          }
          obj.isPlacingBid = false;
          orderReqItem.isPlacingBid = false;
          if (res.orderRequestCompleted) {
            obj.closeOrderRequest(orderReqItem.order_request);
          }
        }, function (err) {
          alertify.error('Can\'t save Order request bid');
          obj.isPlacingBid = false;
          orderReqItem.isPlacingBid = false;
        });
      });
    };

    obj.init();
  }
})(angular);
//# sourceMappingURL=growerOrderRequestOpenCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('growerOrderRequestHistoryCtrl', ['$scope', 'alertify', 'commonSrv', 'productSrv', 'growerSrv', '$state', '$filter', 'floristSrv', 'FileSaver', 'Blob', '$uibModal', growerOrderRequestHistoryCtrl]);

  function growerOrderRequestHistoryCtrl($scope, alertify, commonSrv, productSrv, growerSrv, $state, $filter, floristSrv, FileSaver, Blob, $uibModal) {

    var obj = this,
        common = commonSrv,
        gs = growerSrv;
    obj.history = [];
    obj.search = '';
    obj.dates = [];
    obj.isLoadingHistory = false;

    obj.picker_options = {
      customClass: getPurchaseDays
    };

    obj.open = function (name, evt) {
      obj[name] = true;
      evt.preventDefault();
    };

    function getPurchaseDays(data) {
      var date = data.date,
          mode = data.mode;
      if (mode === 'day') {
        var dayToCheck = new Date(date).setHours(0, 0, 0, 0);
        if (obj.dates.some(function (item) {
          return item === common.convertDateToNumberDateWithoutTimeZone(dayToCheck);
        })) {
          return 'activeClass';
        }
      }

      return '';
    }

    obj.fetch = function () {
      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (date) {
        date = common.convertDateToNumberDateWithoutTimeZone(date);
      }
      gs.getHistoryByGrower(obj.user, date, function (res) {
        if (!date) {
          obj.dates = res.results.map(function (i) {
            return i.packing_date;
          });
          obj.initialLoading = false;
        }
        obj.history = res.results;
        obj.history.sort(function (a, b) {
          return b.created_at - a.created_at;
        }).map(function (d) {
          d.created_at ? d.created_at = common.convertNumberDateToDate(d.created_at) : null;
          d.packing_date = common.convertNumberDateToDateEst(d.packing_date);
          return d;
        });
        obj.isLoadingHistory = false;
      }, function (err) {
        alertify.error('Can not get history');
        obj.isLoadingHistory = false;
      });
    };

    obj.getHistory = function () {
      obj.isLoadingHistory = true;
      obj.fetch(obj.date);
    };

    var init = function init() {
      obj.isLoadingHistory = true;
      obj.initialLoading = true;
      obj.user = common.getUserData().data.metadata.grower;
      obj.fetch();
    };

    init();
  }
})(angular);
//# sourceMappingURL=growerOrderRequestHistoryCtrl.js.map

'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

(function (angular) {
  angular.module('ibf').controller('growerOrdersListCtrl', ['$scope', 'alertify', 'commonSrv', 'productSrv', 'growerSrv', '$state', '$filter', '$http', 'floristSrv', 'FileSaver', 'Blob', 'environment', '$uibModal', growerOrdersListCtrl]);

  function growerOrdersListCtrl($scope, alertify, commonSrv, productSrv, growerSrv, $state, $filter, $http, floristSrv, FileSaver, Blob, environment, $uibModal) {
    var obj = this,
        common = commonSrv,
        ps = productSrv,
        gs = growerSrv,
        fs = floristSrv;

    obj.standingOrder = false;
    obj.cartboxes = [];
    obj.selectedProductGroup = '';
    obj.productGroupVariety = '';
    obj.activo = false;

    obj.grower_approved = { key: '', grower_approved: false };
    obj.format = 'dd-MMMM-yyyy';
    obj.altInputFormats = ['M!/d!/yyyy'];
    obj.dateSelected = null;
    obj.showEditQuantity = false;

    obj.loadingMonth = false;

    obj.dates = {
      selected: [],
      existing: [],
      lastAdjustedMonth: []
    };

    // Carga opciones de UoM (solo stem/bunch) para mostrar en el modal (solo lectura)
    obj.uomOptions = [];
    obj._loadUomOptions = function () {
      gs.uomList(function (units) {
        // Filtrar solo opciones válidas: stem y bunch
        obj.uomOptions = $filter('orderBy')(units.data.filter(function (item) {
          return item.uom === 'stem' || item.uom === 'bunch';
        }), 'index_order');
      }, function () {/* noop */
      });
    };

    // Carga opciones desde la tabla stems_per_bunch para el selector del modal
    obj.spbOptions = [];
    obj._loadSpbOptions = function () {
      ps.listStemsPerBunch(function (res) {
        // ordenar por valor numérico de stems_per_bunch ascendente
        obj.spbOptions = $filter('orderBy')(res.data || [], 'stems_per_bunch');
      }, function () {/* noop */
      });
    };

    function init() {
      obj.orders = [];
      obj.summary = [];
      // UoM a mostrar en el summary: 'both' | 'stems' | 'bunches'
      obj.summaryUom = 'both';

      var _getCurrentMonthRange = getCurrentMonthRange(),
          start_date = _getCurrentMonthRange.start_date,
          end_date = _getCurrentMonthRange.end_date;

      obj.findAllCartBox(start_date, end_date, function () {});

      obj.grower = common.getUserData();

      if (obj.grower.data.metadata.grower) {
        obj.getProductGroup(obj.grower.data.metadata.grower);
      }

      // if (obj.grower.grower_company_name === "VDK"){
      if (obj.grower.grower_company_name === "HDB") {
        obj.showEditQuantity = true;
      }

      // cargar opciones UoM (solo lectura) y Stems per Bunch (selector) para el modal de edición
      obj._loadUomOptions();
      obj._loadSpbOptions();
    }

    $scope.$watchCollection('obj.dates.selected', function (selectedDates) {

      if (!obj.dates || !Array.isArray(selectedDates) || selectedDates.length === 0) {
        return;
      }

      var selectedDate = selectedDates[selectedDates.length - 1];

      if (!selectedDate) {
        return;
      }

      var isDateAlreadyInExisting = obj.dates.existing.some(function (existingDate) {
        return existingDate.start_date === selectedDate.start_date && existingDate.end_date === selectedDate.end_date;
      });

      if (!isDateAlreadyInExisting && !obj.loadingMonth) {

        obj.loadingMonth = true;
        obj.findAllCartBox(selectedDate.start_date, selectedDate.end_date, function () {
          obj.loadingMonth = false;
        });

        obj.dates.existing.push(selectedDate);
      }
    });

    $scope.$watch('selectedMonth', function (newValue) {
      if (newValue && !obj.loadingMonth) {
        if (
        // obj.cartboxes.length>0
        // &&
        shouldAdjustMonth(newValue, obj)) {
          adjustMonthSelection(newValue);
        }
      }
    }, true);

    obj.picker_options = {
      showWeeks: false,
      customClass: function customClass(data) {
        var classes = getPurchaseDays(data);
        if (data.mode === 'day' && isInRange(data.date)) {
          classes += ' date-in-range';
        }
        return classes;
      },
      dateDisabled: disabled
    };

    obj.productGroup = [];
    obj.grower = '';
    obj.carrier = '';

    function getMonthDetails(date) {
      var currentMonth = new Date(date).getMonth();
      var currentYear = new Date(date).getFullYear();

      var startDate = Number('' + currentYear + (currentMonth + 1).toString().padStart(2, '0') + '01');
      var lastDay = new Date(currentYear, currentMonth + 1, 0).getDate();
      var endDate = Number('' + currentYear + (currentMonth + 1).toString().padStart(2, '0') + lastDay);

      return { month: currentMonth, year: currentYear, start_date: startDate, end_date: endDate };
    }

    function getCurrentMonthRange() {
      var currentMonth = new Date().getMonth() + 1;
      var currentYear = new Date().getFullYear();

      var startDate = Number('' + currentYear + currentMonth.toString().padStart(2, '0') + '01');
      var lastDay = new Date(currentYear, currentMonth, 0).getDate();
      var endDate = Number('' + currentYear + currentMonth.toString().padStart(2, '0') + lastDay);

      return { start_date: startDate, end_date: endDate };
    }

    function adjustMonthSelection(date) {

      var adjustedMonth = new Date(date);
      adjustedMonth.setMonth(adjustedMonth.getMonth());

      var adjustedMonthDetails = getMonthDetails(adjustedMonth);

      var isSelected = obj.dates.selected.some(function (d) {
        return new Date(d.start_date).getTime() === new Date(adjustedMonthDetails.start_date).getTime() && new Date(d.end_date).getTime() === new Date(adjustedMonthDetails.end_date).getTime();
      });

      if (isSelected) {

        obj.dates.selected = [];
        obj.dates.existing.push(adjustedMonthDetails);
      } else {

        obj.dates.selected = [adjustedMonthDetails];
      }
    }

    function shouldAdjustMonth(date, obj) {
      if (!date) return false;

      var currentMonth = date.getMonth();
      var currentYear = date.getFullYear();
      var dateKey = currentYear + '-' + currentMonth;
      if (obj.dates.lastAdjustedMonth.includes(dateKey)) {
        return false;
      }

      obj.dates.lastAdjustedMonth.push(dateKey);

      return true;
    }

    function getPurchaseDays(data) {

      var date = data.date,
          mode = data.mode;

      if (mode === 'day') {

        /*if (
          obj.cartboxes.length>0
          &&
          shouldAdjustMonth(date, obj)) {
           adjustMonthSelection(date);
          }*/

        var dayToCheck = new Date(date).setHours(0, 0, 0, 0);

        for (var i = 0; i < obj.cartboxes.length; i++) {
          var cartbox = obj.cartboxes[i];
          var packing_date = common.convertNumberDateToDate(cartbox.packing_date);
          var currentDay = new Date(packing_date).getTime();
          if (dayToCheck === currentDay) {
            return 'activeClass';
          }
        }
      }

      return '';
    }

    function disabled() {

      return obj.loadingMonth;
    }

    obj.dateOptions = {
      formatYear: 'yy',
      maxDate: new Date(2020, 5, 22),
      minDate: new Date(),
      startingDay: 1

    };

    obj.row_per_page = 5;
    obj.list_master = [];
    obj.copy_list_master = [];

    obj.open = function (name, evt) {

      obj[name] = true;
      evt.preventDefault();
    };

    // Rango de fechas de empaque: filtra la tabla y define lo que se descarga con "Download All".
    // Un solo día = from sin to.
    obj.RANGE_MAX_DAYS = 15;
    obj.range = { from: null, to: null };
    obj.rangePick = null; // modelo del uib-datepicker inline (último día clickeado)
    obj.isRangeOpen = false;

    function isInRange(date) {
      if (!obj.range.from) {
        return false;
      }
      var day = moment(date).startOf('day');
      return !day.isBefore(moment(obj.range.from).startOf('day')) && !day.isAfter(moment(obj.range.to || obj.range.from).startOf('day'));
    }

    // Primer click define el inicio; un segundo click igual o posterior define el fin.
    // Con el rango completo, o con un día anterior al inicio, se empieza de nuevo.
    obj.onRangePick = function () {
      var date = obj.rangePick;
      if (!date) {
        return;
      }
      var day = moment(date).startOf('day');
      if (!obj.range.from || obj.range.to || day.isBefore(moment(obj.range.from).startOf('day'))) {
        obj.range = { from: date, to: null };
      } else if (!day.isSame(moment(obj.range.from).startOf('day'))) {
        obj.range.to = date;
      }
    };

    obj.rangeLabel = function () {
      if (!obj.range.from) {
        return '';
      }
      var from = $filter('date')(obj.range.from, 'MM/dd/yyyy');
      return obj.range.to ? from + ' - ' + $filter('date')(obj.range.to, 'MM/dd/yyyy') : from;
    };

    obj.applyRange = function () {
      obj.isRangeOpen = false;
      obj.listOrders();
    };

    obj.clearRange = function () {
      obj.range = { from: null, to: null };
      obj.rangePick = null;
    };

    // Descarga todo lo cargado en la tabla: todos los días del rango con los filtros aplicados
    obj.downloadAllOrders = function () {
      if (!obj.list_master.length) {
        return alertify.log('There are no orders to download.');
      }

      var name = 'orders';
      if (obj.loadedRange) {
        name += ' ' + (obj.loadedRange.from === obj.loadedRange.to ? obj.loadedRange.from : obj.loadedRange.from + '-' + obj.loadedRange.to);
      }

      // Un solo día baja igual que el antiguo "Download Order"; varios días van por bloques
      var days = obj.list_master.filter(function (order) {
        return order.cartboxes && order.cartboxes.length;
      });
      var data = days.length === 1 ? obj.generateExcel(days[0].cartboxes) : obj.generateExcelRange(obj.list_master);

      obj.appendExcelSummary(data);
      obj.writeOrderWorkbook(data, name + '.xlsx');
    };

    // Agrega al final de la hoja el mismo summary de la página (obj.summary, ya agrupado por
    // product group y variety + grade). Los nombres de product group van en negrita.
    obj.appendExcelSummary = function (rows) {
      if (!obj.summary.length) {
        return rows;
      }

      rows.dateRows = rows.dateRows || [];

      rows.push([]);
      rows.dateRows.push(rows.length);
      rows.push(['Summary', 'Stems', 'Bunches']);

      obj.summary.forEach(function (group) {
        rows.dateRows.push(rows.length);
        rows.push([group.productGroup, group.totallyStems, group.totallyBunches]);

        group.variety.forEach(function (element) {
          rows.push(['- ' + element.varietyName + (element.grade ? ' (' + element.grade + ')' : ''), element.total_stems, element.total_bunches]);
        });
      });

      return rows;
    };

    obj.clearFilters = function () {
      obj.filter = {};
      obj.date = null;
      obj.summary = [];
      obj.loadedOrders = [];
    };

    // Modal de edición por item (aplica para no custom y custom)
    obj.openEditModal = function (cartbox, item) {
      if (!cartbox) return;

      // Si no viene item explícito, intentar tomar el primero (para no custom)
      item = item || (cartbox.items && cartbox.items[0] ? cartbox.items[0] : null);
      if (!item) return;

      var initialUomKey = null;
      var initialSpbKey = null;
      // Intentar derivar la key del UoM actual del item (si existe)
      if (item.uom && item.uom._KEY) {
        initialUomKey = item.uom._KEY;
      } else if (item.UoM) {
        initialUomKey = item.UoM;
      } else if (item.uom && item.uom.uom) {
        // Buscar por nombre si no tenemos key
        var found = obj.uomOptions.find(function (u) {
          return u.uom === item.uom.uom;
        });
        if (found) initialUomKey = found._KEY;
      }

      // Intentar derivar la key del stems_per_bunch actual del item (si existe)
      if (item.stems_per_bunch && item.stems_per_bunch._KEY) {
        initialSpbKey = item.stems_per_bunch._KEY;
      } else if (item.stems_per_bunch) {
        // si viene como string key
        initialSpbKey = item.stems_per_bunch;
      }

      var modalInstance = $uibModal.open({
        templateUrl: 'views/grower/order.edit.modal.html',
        controller: 'growerOrderEditModalCtrl',
        controllerAs: 'modal',
        bindToController: true,
        backdrop: 'static', // Evita cerrar haciendo click fuera del modal
        keyboard: false, // Evita cerrar con tecla ESC
        resolve: {
          config: function config() {
            return {
              cartbox: cartbox,
              item: item,
              uomOptions: angular.copy(obj.uomOptions || []),
              initialUomKey: initialUomKey,
              spbOptions: angular.copy(obj.spbOptions || []),
              initialSpbKey: initialSpbKey,
              onUpdate: obj.onUpdate
            };
          }
        }
      });

      modalInstance.result.then(function () {
        // Al cerrar OK, refrescar el listado principal
        try {
          obj.listOrders();
        } catch (e) {/* noop */
        }
      });
    };

    // Función onUpdate: invoca cloudscript para actualizar el cart_box_item
    // payload: { cartbox, item, quantity, stems_per_bunch }
    obj.onUpdate = function (payload) {
      var params = {
        customer: payload.cartbox.customer && payload.cartbox.customer._KEY ? payload.cartbox.customer._KEY : null,
        cart_box_item: payload.item && payload.item._KEY ? payload.item._KEY : null,
        quantity: payload.quantity,
        stems_per_bunch: payload.stems_per_bunch
      };

      return gs.updateCartBoxItemProperties(params).then(function (res) {
        // Crear registro en AUDIT cuando el update sea exitoso
        try {
          var userData = common.getUserData() || {};
          // Si viene desde Country Manager, usar la key del CM; de lo contrario, la key del usuario logueado

          var userKey = userData.key;

          var auditPayload = {
            cartbox: payload.cartbox && payload.cartbox._KEY ? payload.cartbox._KEY : null,
            item: payload.item && payload.item._KEY ? payload.item._KEY : null,
            quantity: payload.quantity,
            stems_per_bunch: payload.stems_per_bunch
          };

          var growerName = userData && (userData.grower_company_name || userData.grower_name) || '';
          var description = 'The user ' + (userData.data.user_id || 0) + ' update quantity from box ' + (payload.cartbox && payload.cartbox.consecutive || '') + ' for grower ' + growerName;

          var auditObj = {
            action: 'UPDATE_CART_BOX_ITEM_QUANTITY',
            user: userKey,
            date: new Date(),
            description: description,
            object_string: JSON.stringify(auditPayload)
          };

          if (typeof common.createAudit === 'function') {
            common.createAudit(auditObj, function () {/* noop */
            }, function (err) {
              try {
                console.warn('Audit creation failed', err);
              } catch (e) {}
            });
          }
        } catch (e) {
          try {
            console.warn('Audit step error', e);
          } catch (er) {}
        }
        try {
          alertify.success('Updated');
        } catch (e) {}
        return res;
      }).catch(function (err) {
        try {
          alertify.error(err && err.message ? err.message : err || 'Error updating');
        } catch (e) {}
        return Promise.reject(err);
      });
    };

    obj.hasDateBeenRequested = function (startDate, endDate) {
      return obj.dates.existing.some(function (date) {
        return date.start_date === startDate && date.end_date === endDate;
      });
    };

    obj.findAllCartBox = function (startDate, endDate, callback) {

      obj.isLoading = true;

      obj.cartBoxByGrower(startDate, endDate, function (cartbox) {

        obj.cartboxes = obj.cartboxes || [];
        obj.cartboxes = [].concat(_toConsumableArray(obj.cartboxes), _toConsumableArray(cartbox));

        if (obj.cartboxes.length) {
          obj.dates.selected.push({ start_date: startDate, end_date: endDate });
          obj.dates.existing.push({ start_date: startDate, end_date: endDate });
        }

        var date1 = new Date();

        var daysDiff = 31;
        var date = null;

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = obj.cartboxes.filter(function (cart_box) {
            return cart_box.packing_date <= common.convertDateToNumberDate(new Date());
          })[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var cart_box = _step.value;

            var packing_date = common.convertNumberDateToDate(cart_box.packing_date);
            var diffTime = Math.abs(packing_date - date1);
            var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

            if (diffDays < daysDiff) {
              date = common.convertNumberDateToDate(cart_box.packing_date);
              daysDiff = diffDays;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        obj.isLoading = false;

        if (date && !obj.range.from && !obj.loadingMonth) {
          obj.range = { from: date, to: null };
          obj.rangePick = date;
          obj.listOrders();
        }

        if (callback) callback();
      }, function (err) {
        common.onErrorDefault(err);
        obj.loadingMonth = false;
        if (callback) callback();
      });
    };

    obj.cartBoxByGrower = function (startDate, endDate, onSuccess, onError) {
      if (!startDate || !endDate) {
        return onError();
      }
      if (!common.getUserData()) {
        return onError();
      }
      var query = common.sbx.with('cart_box').andWhereIsEqual('grower', common.getUserData().grower).andWhereGreaterOrEqualThan('packing_date', startDate).andWhereLessOrEqualThan('packing_date', endDate).andWhereIsNotNull('purchase').fetchModels(["carrier"]).compile();

      common.loadAllPages(query, function (res) {
        res.results = res.results.map(function (box) {

          var fetched = res.fetched_results;

          if (fetched["carrier"][box.carrier] && box.carrier) {
            box.carrier_name = fetched["carrier"][box.carrier].carrier;
          } else {
            box.carrier_name = "Fedex";
          }

          return box;
        });

        onSuccess(res.results);
      }, onError);
    };

    obj.clearFilter = function () {
      obj.clearRange();
      obj.consecutive = null;
      obj.customer = null;
      obj.standingOrder = false;
      obj.selectedProductGroup = '';
      obj.productGroupVariety = '';
      obj.orders = [];
      obj.list_master = [];
      obj.loadedRange = null;
      obj.loadedInfo = null;
      obj.summary = [];
      obj.dates.selected = [];
      obj.dates.existing = [], obj.dates.lastAdjustedMonth = [];
    };
    obj.generateArrayCartbox = function (array) {
      return array.map(function (item) {
        var box = [];
        if (item.custom || item.product_group.common_name === "Custom Box") {
          item.items.map(function (article) {

            box.push({
              cart_box_item_key: article._KEY,
              product_group: article.product_group,
              variety_key: article.variety._KEY,
              customizable: true,
              variety: article.variety,
              total_stems: article.quantity * article.stems_per_bunch.stems_per_bunch,
              total_bunches: Number(article.quantity) || 0,
              stems_per_bunch: article.stems_per_bunch,
              custom_item: true,

              items: article

            });
          });
        } else {

          box.push({
            _KEY: item._KEY,
            variety_key: item.variety,
            product_group: item.product_group,
            variety: item.variety,
            customizable: item.items[0].masterlist ? item.items[0].masterlist.customizable : null,
            length: item.items[0].masterlist ? item.items[0].masterlist.length : null,
            total_stems: item.items[0].quantity * item.items[0].stems_per_bunch.stems_per_bunch,
            total_bunches: item.total_items,
            items: item.items,
            custom: item.custom
          });
        }
        return box;
      });
    };

    obj.listOrders = function () {
      obj.orders = [];
      obj.list_master = [];
      obj.loadedRange = null;
      obj.loadedInfo = null;
      var conditions = {};

      if (!obj.range.from && !obj.consecutive && !obj.customer && !obj.standingOrder && !obj.selectedProductGroup && !obj.productGroupVariety) {
        return alertify.error('please use a filter');
      }

      var packingRange = null;
      if (obj.range.from) {
        var toDate = obj.range.to || obj.range.from;
        var days = moment(toDate).startOf('day').diff(moment(obj.range.from).startOf('day'), 'days') + 1;
        if (days > obj.RANGE_MAX_DAYS) {
          return alertify.error('The date range cannot be longer than ' + obj.RANGE_MAX_DAYS + ' days.');
        }
        packingRange = {
          from: common.convertDateToNumberDate(obj.range.from, true),
          to: common.convertDateToNumberDate(toDate, true)
        };
      }

      if (obj.isLoading) {
        return;
      }

      obj.isLoading = true;

      if (packingRange) {
        conditions.packingFrom = packingRange.from;
        conditions.packingTo = packingRange.to;
      }

      if (obj.consecutive) {
        conditions.order = obj.consecutive;
      }

      if (obj.customer) {
        conditions.customer = obj.customer;
      }

      if (obj.standingOrder) {
        conditions.standingOrder = obj.standingOrder;
      }
      if (obj.selectedProductGroup) {
        conditions.selectedProductGroup = obj.selectedProductGroup;
      }
      if (obj.productGroupVariety) {
        conditions.productGroupVariety = obj.productGroupVariety;
      }

      fs.listOrdersByRole(conditions, function (res) {
        obj.isLoading = false;

        obj.list_master = $filter('orderBy')(res, '-packing_date');
        //obj.orders = obj.list_master.slice(0, obj.row_per_page);
        obj.list_master = obj.list_master.map(function (order) {
          order.cartboxes = order.cartboxes.map(function (cartbox) {
            if (cartbox.grower_approved_date && cartbox.grower_approved) {
              var now = moment(new Date()).tz('America/New_York');
              var approvalDate = moment(new Date(cartbox.grower_approved_date)).tz('America/New_York');
              cartbox.expired_approval_reverse = now.diff(approvalDate, "minutes") > 60;
            } else {
              cartbox.expired_approval_reverse = false;
            }

            return cartbox;
          });
          return order;
        });

        // Aplicar cambios desde cart_box_item_changes antes de mostrar
        obj._applyCartBoxItemChanges(obj.list_master, function () {
          obj.orders = obj.list_master.slice(0, obj.row_per_page);
          obj.loadedRange = packingRange;
          obj.loadedInfo = {
            label: packingRange ? obj.rangeLabel() : '',
            days: obj.list_master.length,
            boxes: _.sumBy(obj.list_master, function (order) {
              return order.cartboxes.length;
            })
          };

          ///summary start (todos los días cargados, no solo los visibles por el scroll)
          var arrayCarboxes = _.flatten(obj.list_master.map(function (item) {
            return item.cartboxes;
          }));

          var summary = _.flatten(obj.generateArrayCartbox(arrayCarboxes)).reduce(function (objSum, item) {

            var line = void 0;
            if (!item.custom && item.items[0] && !item.custom_item) {
              line = {
                product_group: item.items[0].product_group,
                variety: item.items[0].variety,
                grade: _.get(item.items[0], 'grade.grade'),
                total_stems: item.items[0].quantity * item.items[0].stems_per_bunch.stems_per_bunch,
                total_bunches: Number(item.items[0].quantity) || 0
              };
            } else {
              line = {
                product_group: item.product_group,
                variety: item.variety,
                grade: _.get(item.items, 'grade.grade'),
                total_stems: item.total_stems,
                total_bunches: item.total_bunches
              };
            }

            if (!(line.product_group._KEY in objSum)) {
              objSum[line.product_group._KEY] = {
                totallyStems: 0,
                totallyBunches: 0,
                productGroup: line.product_group.common_name,
                varietyMap: {}
              };
            }
            var group = objSum[line.product_group._KEY];
            group.totallyStems += line.total_stems;
            group.totallyBunches += line.total_bunches;

            // Agrupa por variety + grade para no repetir filas en el summary
            var varietyKey = (line.variety._KEY || line.variety.variety_name) + '|' + (line.grade || '');
            if (!(varietyKey in group.varietyMap)) {
              group.varietyMap[varietyKey] = {
                total_stems: 0,
                total_bunches: 0,
                varietyName: line.variety.variety_name,
                grade: line.grade
              };
            }
            group.varietyMap[varietyKey].total_stems += line.total_stems;
            group.varietyMap[varietyKey].total_bunches += line.total_bunches;

            return objSum;
          }, {});

          if (Object.keys(summary).length > 0) {
            obj.summary = Object.keys(summary).map(function (key) {
              var group = summary[key];
              group.variety = _.sortBy(_.values(group.varietyMap), ['varietyName', 'grade']);
              delete group.varietyMap;
              return group;
            });
            obj.summary.sort(function (a, b) {
              return a.productGroup.localeCompare(b.productGroup);
            });
          }
          //summary end
        });
      }, function (err) {
        obj.isLoading = false;
        common.onErrorDefault(err);
      });
    };

    // Carga cambios de cart_box_item_changes y los aplica a los items visualizados
    obj._applyCartBoxItemChanges = function (orders, done) {
      try {
        // recolectar todas las keys de cart_box_item presentes
        var keys = [];
        (orders || []).forEach(function (order) {
          (order.cartboxes || []).forEach(function (cb) {
            (cb.items || []).forEach(function (it) {
              if (it && it._KEY) keys.push(it._KEY);
            });
          });
        });

        if (!keys.length) {
          return done();
        }

        var query = common.sbx.with('cart_box_item_changes').andWhereIn('cart_box_item', keys).compile();

        common.loadAllPages(query, function (data) {
          var changes = data.results || [];
          if (!changes.length) {
            return done();
          }

          // Helper para obtener el created_time como timestamp numérico
          var getCreatedTs = function getCreatedTs(rec) {
            var t = rec && rec._META && rec._META.created_time;
            if (t == null && rec && rec.created_time != null) {
              t = rec.created_time;
            }
            // Si es número, devolver directamente
            if (typeof t === 'number') return t;
            // Si es string numérica
            if (typeof t === 'string' && /^\d+$/.test(t)) return parseInt(t, 10);
            // Si es string fecha ISO u otro formato parseable
            if (typeof t === 'string') {
              var parsed = Date.parse(t);
              return isNaN(parsed) ? 0 : parsed;
            }
            // Si viene como Date
            if (t instanceof Date) return t.getTime();
            return 0;
          };

          // asegurar stems options en memoria
          var proceed = function proceed(stemsOptions) {
            var spbMap = {};
            (stemsOptions || []).forEach(function (s) {
              spbMap[s._KEY] = s;
            });

            // Seleccionar el último cambio por cart_box_item según _META.created_time
            var changeMap = {};
            changes.forEach(function (c) {
              var key = c.cart_box_item;
              if (!key) return;
              var prev = changeMap[key];
              if (!prev) {
                changeMap[key] = c;
              } else {
                var prevTs = getCreatedTs(prev);
                var curTs = getCreatedTs(c);
                if (curTs >= prevTs) {
                  changeMap[key] = c;
                }
              }
            });

            (orders || []).forEach(function (order) {
              (order.cartboxes || []).forEach(function (cb) {
                (cb.items || []).forEach(function (it) {
                  var c = changeMap[it._KEY];
                  if (c) {
                    if (c.quantity !== undefined && c.quantity !== null) {
                      it.quantity = c.quantity;
                    }
                    if (c.stems_per_bunch) {
                      it.stems_per_bunch = spbMap[c.stems_per_bunch] || it.stems_per_bunch;
                    }
                  }
                });
              });
            });

            done();
          };

          if (obj.spbOptions && obj.spbOptions.length) {
            proceed(obj.spbOptions);
          } else {
            // cargar stems_per_bunch si aún no están listados
            ps.listStemsPerBunch(function (res) {
              obj.spbOptions = $filter('orderBy')(res.data || [], 'stems_per_bunch');
              proceed(obj.spbOptions);
            }, function () {
              proceed([]);
            });
          }
        }, function () {
          done();
        });
      } catch (e) {
        done();
      }
    };

    obj.totalCartbox = function (cartbox) {
      return cartbox.items.reduce(function (sum, item) {
        sum += item.total_price;
        return sum;
      }, 0);
    };

    obj.finishRenderOrders = function () {

      var width_array = [];
      $('.fixed').width($('.title-heading').width());
      $('.title-heading th').each(function (index) {
        width_array[index] = $(this).width();
      });
      $('.fixed th').each(function (index) {
        $(this).width(width_array[index]);
      });
    };

    obj.showDetail = function (cartbox) {
      var modalInstance = fs.showDetailCartBox({
        cartbox: cartbox
      });
    };

    obj.getMoreData = function () {
      if (obj.orders.length === obj.list_master.length) {
        return;
      }
      if (obj.date) {
        return;
      }

      var limit = obj.orders.length + parseInt(obj.row_per_page);
      obj.orders = obj.list_master.slice(0, limit);
    };

    obj.getProductGroup = function (grower) {
      common.method.run({
        key: environment.cloudscript.ibf_getProduct_groupXGrower,
        params: {
          grower: grower
        }
      }).then(function (response) {

        if (response.success) {
          obj.productGroup = response.data;
        } else {
          alertify.error('An error occurred while loading the data');
        }
      }).catch(function (err) {
        alertify.error('An error has occurred on the server');
      });
    };

    // Selección de órdenes (cart_box) por día de empaque para el FedEx File
    obj.getSelectedCartboxes = function (item) {
      return (item.cartboxes || []).filter(function (cartbox) {
        return cartbox.fedex_selected;
      });
    };

    obj.isAllCartboxesSelected = function (item) {
      return !!(item.cartboxes && item.cartboxes.length) && item.cartboxes.every(function (cartbox) {
        return cartbox.fedex_selected;
      });
    };

    obj.toggleAllCartboxes = function (item) {
      var selected = !obj.isAllCartboxesSelected(item);
      (item.cartboxes || []).forEach(function (cartbox) {
        return cartbox.fedex_selected = selected;
      });
    };

    obj.generateSelectedCSV = function (item) {
      var cartboxes = obj.getSelectedCartboxes(item);
      if (!cartboxes.length) {
        return alertify.error('Select at least one order');
      }
      obj.generateCSV(item.packing_date, false, null, cartboxes);
    };

    // cartboxes: opcional, si se envía el archivo solo incluye esas órdenes
    obj.generateCSV = function (date, email, carrier, cartboxes) {

      var grower = common.getUserData();

      var isDutch = grower && grower.data && grower.data.metadata && grower.data.metadata.country && grower.data.metadata.country.country_iso ? grower.data.metadata.country.country_iso === "NL" : grower.grower_company_name === "HDB";

      var params = {
        date: common.convertDateToNumberDate(date, true),
        grower: grower.grower,
        email: email
      };

      if (cartboxes && cartboxes.length) {
        params.cart_boxes = cartboxes.map(function (cartbox) {
          return cartbox._KEY;
        });
      }

      if (isDutch || carrier && carrier.toUpperCase() === 'DUTCH') {
        // obj.isLoading = true

        gs.generateDutchCSV(params, function (res) {
          var csv = angular.copy(res.box);
          // const csv = response[grower.grower];

          if (!email) {
            var data = new Blob([csv], { type: 'text/plain;charset=utf-8' });
            FileSaver.saveAs(data, 'FedEx dutch ' + commonSrv.upper(grower.grower_name) + ' ' + common.convertDateToNumberDate(date, true) + '.csv');
            // obj.isLoading = false
          } else {
            alertify.success('Mail sended');
            // obj.isLoading = false
          }
        }, alertify.error);
      } else {
        gs.generateCSV(params, function (res) {
          var response = angular.copy(res.box);
          var csv = response[grower.grower];
          if (!email) {
            var data = new Blob([csv], { type: 'text/plain;charset=utf-8' });
            FileSaver.saveAs(data, 'FedEx IPD ' + commonSrv.upper(grower.grower_name) + ' ' + common.convertDateToNumberDate(date, true) + '.in');
          } else {
            alertify.success('Mail sended');
          }
        }, alertify.error); // debugger
      }
    };

    obj.filterDate = function () {
      if (!obj.date) {
        return obj.orders = obj.list_master.slice(0, obj.row_per_page);
      }
      obj.orders = $filter('filterByDate')(obj.list_master, obj.date, 'packing_date');
    };

    obj.filterByCarrier = function () {

      if (!obj.carrier) {
        obj.orders = obj.list_master.slice(0, obj.row_per_page);
      } else {

        var newOrders = [];

        obj.list_master.forEach(function (item) {
          var newItem = {
            packing_date: item.packing_date,
            total: item.total,
            cartboxes: []
          };
          item.cartboxes.forEach(function (cartbox) {
            if (obj.carrier === "DHL") {
              if (cartbox.carrier_name === "DHL") {
                newItem.cartboxes.push(cartbox);
              }
            } else {
              if (!cartbox.carrier || cartbox.carrier_name !== "DHL") {
                newItem.cartboxes.push(cartbox);
              }
            }
          });

          newOrders.push(newItem);
        });

        obj.orders = newOrders;
      }
    };

    obj.deleteBox = function (cartbox) {
      common.confirmModal({
        title: 'Warning',
        msj: 'Are you sure? \n do you want to delete this order?',
        save: 'Yes',
        cancel: 'No'
      }, function () {
        var dialog = common.showDialogProgress({ msj: 'Deleting..' });

        gs.deleteBoxPurchase(cartbox, function (res) {
          dialog.close();
          alertify.success(res);
          obj.listOrders();
        }, function (err) {
          dialog.close();
          alertify.error(err);
        });
      });
    };

    obj.canDelete = function (date) {
      var userData = common.getUserData();
      if (userData.ibf_role === 'GROWER' && !userData.main_role) {
        return false;
      }
      return common.verifyCloseTimeGrower(date);
    };

    // create excel order


    obj.generateExcelOrder = function (item) {
      obj.writeOrderWorkbook(obj.generateExcel(item.cartboxes, item), 'order.xlsx');
    };

    obj.writeOrderWorkbook = function (data, fileName) {

      var wb = XLSX.utils.book_new();

      wb.SheetNames.push('order');

      var ws = XLSX.utils.aoa_to_sheet(data);

      ws['!cols'] = [28, 26, 10, 10, 11, 16, 34, 38, 9, 12, 14, 8, 10, 12].map(function (wch) {
        return { wch: wch };
      });

      // Encabezado, cabeceras de Special Pack y total en negrita, igual que en la tabla del portal.
      // La build community de SheetJS descarta los estilos al escribir; se respetan con xlsx-js-style.
      (data.boldRows || []).forEach(function (row) {
        for (var col = 0; col < obj.EXCEL_COLUMNS.length; col++) {
          var cell = ws[XLSX.utils.encode_cell({ r: row, c: col })];
          if (cell) {
            cell.s = angular.extend({}, cell.s, { font: { bold: true } });
          }
        }
      });

      // Bloques por día de "Download All": título combinado en todo el ancho y más alto
      if (data.merges) {
        ws['!merges'] = data.merges;
      }
      if (data.rowProps) {
        ws['!rows'] = data.rowProps;
      }

      wb.Sheets['order'] = ws;
      var wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

      if (data.dateRows && data.dateRows.length) {
        wbout = obj.boldFirstCell(wbout, data.dateRows);
      }

      saveAs(new Blob([obj.convertArrayBuffer(wbout)], { type: 'application/octet-stream' }), fileName);
    };
    // La build community de SheetJS no escribe estilos, así que la negrita de los títulos de
    // cada día se agrega retocando el .xlsx generado (es un zip) con el CFB que trae SheetJS:
    // una fuente en negrita en styles.xml y el atributo s en la celda A de esas filas.
    // Si algo falla se devuelve el archivo sin negrita.
    obj.boldFirstCell = function (wbout, rows) {
      try {
        var zip = XLSX.CFB.read(wbout, { type: 'binary' });

        var readXml = function readXml(path) {
          var content = XLSX.CFB.find(zip, path).content,
              bin = '';
          for (var i = 0; i < content.length; i++) {
            bin += String.fromCharCode(content[i]);
          }return decodeURIComponent(escape(bin));
        };

        var writeXml = function writeXml(path, xml) {
          var bin = unescape(encodeURIComponent(xml)),
              bytes = new Uint8Array(bin.length);
          for (var i = 0; i < bin.length; i++) {
            bytes[i] = bin.charCodeAt(i);
          }XLSX.CFB.utils.cfb_add(zip, path, bytes);
        };

        var fontId = void 0,
            styleId = void 0;
        var styles = readXml('/xl/styles.xml').replace(/<fonts count="(\d+)">([\s\S]*?)(<font>[\s\S]*?<\/font>)([\s\S]*?)<\/fonts>/, function (m, count, before, font, after) {
          fontId = +count;
          return '<fonts count="' + (fontId + 1) + '">' + before + font + after + font.replace('<font>', '<font><b/>') + '</fonts>';
        }).replace(/<cellXfs count="(\d+)">([\s\S]*?)<\/cellXfs>/, function (m, count, xfs) {
          styleId = +count;
          return '<cellXfs count="' + (styleId + 1) + '">' + xfs + '<xf numFmtId="0" fontId="' + fontId + '" fillId="0" borderId="0" xfId="0" applyFont="1"/></cellXfs>';
        });

        if (fontId === undefined || styleId === undefined) {
          return wbout;
        }

        var sheet = readXml('/xl/worksheets/sheet1.xml');
        rows.forEach(function (row) {
          var cell = '<c r="A' + (row + 1) + '"';
          sheet = sheet.replace(cell, cell + ' s="' + styleId + '"');
        });

        writeXml('/xl/styles.xml', styles);
        writeXml('/xl/worksheets/sheet1.xml', sheet);
        return XLSX.CFB.write(zip, { fileType: 'zip', type: 'binary' });
      } catch (e) {
        return wbout;
      }
    };

    obj.convertArrayBuffer = function (item) {

      var buf = new ArrayBuffer(item.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i < item.length; i++) {
        view[i] = item.charCodeAt(i) & 0xFF;
      }return buf;
    };

    // Columnas en el mismo orden que la tabla del portal (views/grower/orders.list.html)
    obj.EXCEL_COLUMNS = ['Customer', 'Box Type', 'Carrier', 'PO #', 'Order #', 'Product Group', 'Variety/Grade', 'Subtitle', 'Length', 'Stems/Bunch', 'Total Bunches', 'UoM', 'Price', 'Total Price'];

    obj.generateExcel = function (array) {

      // El product group / variety / grade / length de una caja custom (Special Pack)
      // viven en cada cart_box_item, no en la caja, por eso se emite una fila por item.
      var productGroupOf = function productGroupOf(cartbox, item) {
        var product_group = (cartbox.custom ? item.product_group : cartbox.product_group) || item.product_group;
        return product_group ? product_group.common_name : '';
      };

      var varietyOf = function varietyOf(item) {
        if (!item.variety) {
          return '';
        }
        var variety = item.variety.variety_name;
        if (item.grade && item.grade.grade) {
          variety += ' ' + item.grade.grade;
        }
        if (item.variety.color) {
          variety += ' (' + item.variety.color.color_name + ')';
        }
        return variety;
      };

      var lengthOf = function lengthOf(cartbox, item) {
        var length = cartbox.custom ? item.masterlist && item.masterlist.length ? item.masterlist.length : cartbox.box.fixed_length : cartbox.length ? cartbox.length : cartbox.box.fixed_length;
        return length ? length + ' cm' : '';
      };

      var boxTypeOf = function boxTypeOf(cartbox) {
        return cartbox.box.box_name + ' ' + cartbox.box.box_length + '*' + cartbox.box.box_width + '*' + cartbox.box.box_heigth;
      };

      var itemRow = function itemRow(cartbox, item, leading) {
        return leading.concat([productGroupOf(cartbox, item), varietyOf(item), item.variety && item.variety.subtitle || '', lengthOf(cartbox, item), item.stems_per_bunch ? item.stems_per_bunch.stems_per_bunch : '', item.quantity, item.uom ? item.uom.uom : '', '$' + (item.base_price || 0).toFixed(3), '$' + (item.total_price || 0).toFixed(2)]);
      };

      var rows = [obj.EXCEL_COLUMNS];
      // Filas que van en negrita: encabezado, cabeceras de Special Pack y total final.
      var boldRows = [0];

      $filter('orderBy')(array || [], ['purchase.consecutive', 'consecutive']).forEach(function (cartbox) {

        var items = cartbox.items || [];
        var leading = [cartbox.customer.company_name + (cartbox.is_standing_order ? ' (standing order)' : ''), boxTypeOf(cartbox), cartbox.carrier_name, cartbox.purchase.consecutive, cartbox.consecutive];

        if (!cartbox.custom) {
          items.forEach(function (item) {
            rows.push(itemRow(cartbox, item, leading));
          });
          return;
        }

        // Caja custom: fila agrupadora "Special Pack" con el total de la caja,
        // y debajo una fila por item con las columnas de identificacion vacias.
        boldRows.push(rows.length);
        rows.push(leading.concat([cartbox.product_group ? cartbox.product_group.common_name : 'Custom Box', 'Special Pack', items[0] && items[0].variety && items[0].variety.subtitle || '', '', '', '', '', '', '$' + obj.totalCartbox(cartbox).toFixed(2)]));

        items.forEach(function (item) {
          rows.push(itemRow(cartbox, item, ['', '', '', '', '']));
        });
      });

      var total = (array || []).reduce(function (acc, cartbox) {
        return acc + (cartbox.items || []).reduce(function (sum, item) {
          return sum + (item.total_price || 0);
        }, 0);
      }, 0);

      boldRows.push(rows.length);
      rows.push(['', '', '', '', '', '', '', '', '', '', '', '', 'Total:', '$' + total.toFixed(2)]);

      rows.boldRows = boldRows;
      return rows;
    };

    // Varios días en una hoja, en orden cronológico. Cada día es un bloque: un título combinado
    // en todo el ancho seguido del mismo contenido de "Download Order" (generateExcel), con su
    // total como total del día. Entre bloques va una fila vacía y al final el total del rango.
    obj.generateExcelRange = function (orders) {

      var rows = [];
      var boldRows = [];
      var dateRows = [];
      var merges = [];
      var rowProps = [];
      var totalBoxes = 0;
      var total = 0;

      var days = $filter('orderBy')(orders || [], 'packing_date').filter(function (order) {
        return order.cartboxes && order.cartboxes.length;
      });

      days.forEach(function (order, index) {
        var cartboxes = order.cartboxes;
        var dayRows = obj.generateExcel(cartboxes);

        totalBoxes += cartboxes.length;
        total += cartboxes.reduce(function (acc, cartbox) {
          return acc + (cartbox.items || []).reduce(function (sum, item) {
            return sum + (item.total_price || 0);
          }, 0);
        }, 0);

        if (index > 0) {
          rows.push([]);
        }

        merges.push({ s: { r: rows.length, c: 0 }, e: { r: rows.length, c: obj.EXCEL_COLUMNS.length - 1 } });
        rowProps[rows.length] = { hpt: 26 };
        boldRows.push(rows.length);
        dateRows.push(rows.length);
        rows.push(['PACKING DATE: ' + $filter('date')(order.packing_date, 'EEEE MM/dd/yyyy').toUpperCase() + '  —  ' + cartboxes.length + (cartboxes.length === 1 ? ' BOX' : ' BOXES')]);

        // La fila "Total:" de generateExcel pasa a ser el total del día
        dayRows[dayRows.length - 1][12] = 'Total ' + $filter('date')(order.packing_date, 'MM/dd/yyyy') + ':';
        dayRows.boldRows.forEach(function (row) {
          boldRows.push(rows.length + row);
        });
        Array.prototype.push.apply(rows, dayRows);
      });

      if (days.length > 1) {
        var grandTotal = obj.EXCEL_COLUMNS.map(function () {
          return '';
        });
        grandTotal[0] = 'Total boxes: ' + totalBoxes;
        grandTotal[12] = 'Total all days:';
        grandTotal[13] = '$' + total.toFixed(2);

        rows.push([]);
        rowProps[rows.length] = { hpt: 22 };
        boldRows.push(rows.length);
        rows.push(grandTotal);
      }

      rows.boldRows = boldRows;
      rows.dateRows = dateRows;
      rows.merges = merges;
      rows.rowProps = rowProps;
      return rows;
    };

    obj.checkApproved = function (grower_approved, cartbox) {
      // console.log(obj.grower)


      if (common.getUserData().main_role === "COUNTRY_MANAGER") {
        obj.grower_approved.key = grower_approved;
        cartbox.grower_approved = grower_approved;
        common.updateStateOrder(cartbox._KEY, grower_approved, function (res) {
          alertify.success('Update ', res);
        }, function (err) {
          alertify.error('Internal error ', err);
        });
      } else {
        if (grower_approved) {

          common.confirmModal({
            title: '',
            msj: 'Are you sure you want to set it to "Yes"',
            saveText: 'Yes (you have 60 min to set it back to "No")',
            cancelText: 'No, set it back to No',
            size: 'md'
          }, function () {
            cartbox.grower_approved = true;
            obj.grower_approved.key = grower_approved;
            common.updateStateOrder(cartbox._KEY, grower_approved, function (res) {
              alertify.success('Update ', res);
            }, function (err) {
              alertify.error('Internal error ', err);
            });
          }, function () {
            cartbox.grower_approved = false;
          });
        } else {
          obj.grower_approved.key = grower_approved;
          cartbox.grower_approved = false;
          common.updateStateOrder(cartbox._KEY, grower_approved, function (res) {
            alertify.success('Update ', res);
          }, function (err) {
            alertify.error('Internal error ', err);
          });
        }
      }

      // console.log(grower_approved)
      // console.log(obj.grower_approved)

    };

    obj.approvedAllOrders = function (item, grower_approved) {
      var cartbox = item.cartboxes;

      if (common.getUserData().main_role === "COUNTRY_MANAGER") {
        cartbox.forEach(function (res, index) {
          item.cartboxes[index].grower_approved = grower_approved;
          common.updateStateOrder(res._KEY, grower_approved, function (res) {
            alertify.success('Update ', res);
          }, function (err) {
            alertify.error('Internal error ', err);
          });
        });
      } else {
        if (grower_approved) {

          common.confirmModal({
            title: '',
            msj: 'Are you sure you want to set it to "Yes"',
            saveText: 'Yes (you have 60 min to set it back to "No")',
            cancelText: 'No, set it back to No',
            size: 'md'
          }, function () {
            var cartbox = item.cartboxes;
            cartbox.forEach(function (res, index) {
              item.cartboxes[index].grower_approved = grower_approved;
              common.updateStateOrder(res._KEY, grower_approved, function (res) {
                alertify.success('Update ', res);
              }, function (err) {
                alertify.error('Internal error ', err);
              });
            });
          });
        } else {
          // obj.grower_approved.key=grower_approved
          var _cartbox = item.cartboxes;
          if (_cartbox.some(function (res, index) {
            return item.cartboxes[index].expired_approval_reverse;
          })) {
            common.confirmModal({
              title: '',
              msj: 'Some of your cart boxes have the time to reverse approval expired',
              size: 'sm',
              saveText: 'Ok',
              hideCancel: true
            }, function () {});
          }

          _cartbox.forEach(function (res, index) {
            if (!item.cartboxes[index].expired_approval_reverse) {
              item.cartboxes[index].grower_approved = false;
              common.updateStateOrder(res._KEY, false, function (res) {
                alertify.success('Update ', res);
              }, function (err) {
                alertify.error('Internal error ', err);
              });
            }
          });
        }
      }
    };

    init();
  }
})(angular);
//# sourceMappingURL=growerOrdersListCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('growerAccountingCtrl', ['$scope', 'alertify', 'commonSrv', 'productSrv', 'growerSrv', '$state', growerAccountingCtrl]);

  function growerAccountingCtrl($scope, alertify, commonSrv, productSrv, growerSrv, $state) {
    var obj = this,
        common = commonSrv,
        gs = growerSrv,
        ps = productSrv;
  }
})(angular);
//# sourceMappingURL=growerAccountingCtrl.js.map
